/* tslint:disable */
/* eslint-disable */
/**
 * くらしスタディAPI仕様
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ApplyAffiliationTypeTemplateDto
 */
export interface ApplyAffiliationTypeTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof ApplyAffiliationTypeTemplateDto
     */
    template: ApplyAffiliationTypeTemplateDtoTemplateEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ApplyAffiliationTypeTemplateDtoTemplateEnum {
    School = 'SCHOOL',
    Company = 'COMPANY'
}

/**
 * 
 * @export
 * @interface AssignAffiliationDto
 */
export interface AssignAffiliationDto {
    /**
     * 
     * @type {string}
     * @memberof AssignAffiliationDto
     */
    user_type: AssignAffiliationDtoUserTypeEnum;
    /**
     * 学習者は learner_id、企業ユーザーは user_id
     * @type {string}
     * @memberof AssignAffiliationDto
     */
    user_id: string;
    /**
     * 
     * @type {number}
     * @memberof AssignAffiliationDto
     */
    affiliation_id: number;
    /**
     * 
     * @type {string}
     * @memberof AssignAffiliationDto
     */
    role?: AssignAffiliationDtoRoleEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AssignAffiliationDtoUserTypeEnum {
    Learner = 'LEARNER',
    CompanyUser = 'COMPANY_USER'
}
/**
    * @export
    * @enum {string}
    */
export enum AssignAffiliationDtoRoleEnum {
    Member = 'MEMBER',
    Admin = 'ADMIN'
}

/**
 * 
 * @export
 * @interface CancelLessonInput
 */
export interface CancelLessonInput {
    /**
     * 
     * @type {number}
     * @memberof CancelLessonInput
     */
    cancelReason: number;
    /**
     * 
     * @type {boolean}
     * @memberof CancelLessonInput
     */
    isReschedule: boolean;
    /**
     * 
     * @type {string}
     * @memberof CancelLessonInput
     */
    cancelReasonText?: string;
}
/**
 * 
 * @export
 * @interface ChangeAffiliationRoleDto
 */
export interface ChangeAffiliationRoleDto {
    /**
     * 
     * @type {string}
     * @memberof ChangeAffiliationRoleDto
     */
    role: ChangeAffiliationRoleDtoRoleEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ChangeAffiliationRoleDtoRoleEnum {
    Member = 'MEMBER',
    Admin = 'ADMIN'
}

/**
 * 
 * @export
 * @interface CheckTestStatus
 */
export interface CheckTestStatus {
    /**
     * 
     * @type {string}
     * @memberof CheckTestStatus
     */
    check_test_datetime: string | null;
}
/**
 * 
 * @export
 * @interface ConnectionId
 */
export interface ConnectionId {
    /**
     * 
     * @type {string}
     * @memberof ConnectionId
     */
    room_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectionId
     */
    connection_id: string;
}
/**
 * 
 * @export
 * @interface CreateActiveLearnerLogResponse
 */
export interface CreateActiveLearnerLogResponse {
    /**
     * 
     * @type {number}
     * @memberof CreateActiveLearnerLogResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof CreateActiveLearnerLogResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateActiveLearnerLogResponse
     */
    data?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateAffiliationNodeDto
 */
export interface CreateAffiliationNodeDto {
    /**
     * 
     * @type {number}
     * @memberof CreateAffiliationNodeDto
     */
    parent_id: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAffiliationNodeDto
     */
    type_id: number;
    /**
     * 
     * @type {string}
     * @memberof CreateAffiliationNodeDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CreateAffiliationNodeDto
     */
    sort_order?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAffiliationNodeDto
     */
    academic_year?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAffiliationNodeDto
     */
    valid_from?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAffiliationNodeDto
     */
    valid_to?: string | null;
    /**
     * 年度繰り上げ時の移動先の初期提案
     * @type {number}
     * @memberof CreateAffiliationNodeDto
     */
    successor_id?: number | null;
}
/**
 * 
 * @export
 * @interface CreateAffiliationTypeDto
 */
export interface CreateAffiliationTypeDto {
    /**
     * 
     * @type {string}
     * @memberof CreateAffiliationTypeDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CreateAffiliationTypeDto
     */
    sort_order?: number;
    /**
     * 年度で入れ替わる種別か(クラス等)
     * @type {boolean}
     * @memberof CreateAffiliationTypeDto
     */
    is_year_bound?: boolean;
}
/**
 * 
 * @export
 * @interface CreateAgreementInput
 */
export interface CreateAgreementInput {
    /**
     * 
     * @type {string}
     * @memberof CreateAgreementInput
     */
    plan_name: string;
    /**
     * 
     * @type {number}
     * @memberof CreateAgreementInput
     */
    company_id: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAgreementInput
     */
    payment_id: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAgreementInput
     */
    start_year?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAgreementInput
     */
    start_month?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAgreementInput
     */
    period_month: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAgreementInput
     */
    account_count: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAgreementInput
     */
    lesson_count: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAgreementInput
     */
    billed_amount: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAgreementInput
     */
    tax: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAgreementInput
     */
    discount: number;
    /**
     * 
     * @type {string}
     * @memberof CreateAgreementInput
     */
    fee_code: string;
}
/**
 * 
 * @export
 * @interface CreateCompanyInput
 */
export interface CreateCompanyInput {
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyInput
     */
    company_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyInput
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyInput
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyInput
     */
    representative: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyInput
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyInput
     */
    main_bank_info: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyInput
     */
    main_bank_account: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyInput
     */
    transfer_bank_info: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyInput
     */
    transfer_bank_account: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyInput
     */
    company_id: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyInput
     */
    create_datetime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyInput
     */
    create_user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyInput
     */
    update_datetime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyInput
     */
    update_user_id?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateCompanyInput
     */
    stop_flg?: object;
    /**
     * 
     * @type {object}
     * @memberof CreateCompanyInput
     */
    delete_flg?: object;
}
/**
 * 
 * @export
 * @interface CreateCompanyUserInput
 */
export interface CreateCompanyUserInput {
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyUserInput
     */
    user_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyUserInput
     */
    email: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyUserInput
     */
    company_id: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyUserInput
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyUserInput
     */
    create_datetime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyUserInput
     */
    create_user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyUserInput
     */
    update_datetime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyUserInput
     */
    update_user_id?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateCompanyUserInput
     */
    stop_flg: object;
    /**
     * 
     * @type {object}
     * @memberof CreateCompanyUserInput
     */
    delete_flg: object;
}
/**
 * 
 * @export
 * @interface CreateErrorLog
 */
export interface CreateErrorLog {
    /**
     * 
     * @type {string}
     * @memberof CreateErrorLog
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof CreateErrorLog
     */
    currentPage: string;
    /**
     * 
     * @type {string}
     * @memberof CreateErrorLog
     */
    userAgent: string;
    /**
     * 
     * @type {string}
     * @memberof CreateErrorLog
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof CreateErrorLog
     */
    errorCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateErrorLog
     */
    error: string;
}
/**
 * 
 * @export
 * @interface CreateForBeginnersInquiryInput
 */
export interface CreateForBeginnersInquiryInput {
    /**
     * 
     * @type {string}
     * @memberof CreateForBeginnersInquiryInput
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateForBeginnersInquiryInput
     */
    companyHomePageLink: string;
    /**
     * 
     * @type {string}
     * @memberof CreateForBeginnersInquiryInput
     */
    identity: string;
    /**
     * 
     * @type {string}
     * @memberof CreateForBeginnersInquiryInput
     */
    identityHurigana: string;
    /**
     * 
     * @type {string}
     * @memberof CreateForBeginnersInquiryInput
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateForBeginnersInquiryInput
     */
    telephoneNo: string;
    /**
     * 
     * @type {string}
     * @memberof CreateForBeginnersInquiryInput
     */
    inquiryDetails: string;
    /**
     * 
     * @type {string}
     * @memberof CreateForBeginnersInquiryInput
     */
    userCountPlan: string;
    /**
     * 
     * @type {string}
     * @memberof CreateForBeginnersInquiryInput
     */
    onlinePlan: string;
    /**
     * 
     * @type {string}
     * @memberof CreateForBeginnersInquiryInput
     */
    jpLevel: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateForBeginnersInquiryInput
     */
    request: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateForBeginnersInquiryInput
     */
    personalInfoPermission: boolean;
}
/**
 * 
 * @export
 * @interface CreateInquiryInput
 */
export interface CreateInquiryInput {
    /**
     * 
     * @type {string}
     * @memberof CreateInquiryInput
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInquiryInput
     */
    companyHomePageLink: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInquiryInput
     */
    identity: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInquiryInput
     */
    identityHurigana: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInquiryInput
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInquiryInput
     */
    telephoneNo: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInquiryInput
     */
    inquiryDetails: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInquiryInput
     */
    userCountPlan: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInquiryInput
     */
    onlinePlan: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInquiryInput
     */
    jpLevel: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateInquiryInput
     */
    request: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateInquiryInput
     */
    personalInfoPermission: boolean;
}
/**
 * 
 * @export
 * @interface CreateLearnerInput
 */
export interface CreateLearnerInput {
    /**
     * 
     * @type {string}
     * @memberof CreateLearnerInput
     */
    learner_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLearnerInput
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLearnerInput
     */
    full_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLearnerInput
     */
    nick_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLearnerInput
     */
    initial_password?: string;
    /**
     * 所属ノードID(複数可)。未指定の場合はルートに付与する
     * @type {Array<number>}
     * @memberof CreateLearnerInput
     */
    affiliation_ids?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof CreateLearnerInput
     */
    company_id: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLearnerInput
     */
    create_user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLearnerInput
     */
    create_datetime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLearnerInput
     */
    update_user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLearnerInput
     */
    update_datetime?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateLearnerInput
     */
    delete_flg: object;
    /**
     * 
     * @type {object}
     * @memberof CreateLearnerInput
     */
    stop_flg: object;
    /**
     * 
     * @type {object}
     * @memberof CreateLearnerInput
     */
    email_send_flg: object;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLearnerInput
     */
    invalid_email_auth_flg?: boolean;
}
/**
 * 
 * @export
 * @interface CreateLessonFeeHistoryInput
 */
export interface CreateLessonFeeHistoryInput {
    /**
     * 
     * @type {string}
     * @memberof CreateLessonFeeHistoryInput
     */
    teacher_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLessonFeeHistoryInput
     */
    year_month: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLessonFeeHistoryInput
     */
    billed_flg: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLessonFeeHistoryInput
     */
    create_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLessonFeeHistoryInput
     */
    create_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLessonFeeHistoryInput
     */
    update_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLessonFeeHistoryInput
     */
    update_datetime: string;
    /**
     * 
     * @type {object}
     * @memberof CreateLessonFeeHistoryInput
     */
    delete_flg: object;
    /**
     * 
     * @type {object}
     * @memberof CreateLessonFeeHistoryInput
     */
    stop_flg: object;
}
/**
 * 
 * @export
 * @interface CreateLessonFeeInput
 */
export interface CreateLessonFeeInput {
    /**
     * 
     * @type {string}
     * @memberof CreateLessonFeeInput
     */
    teacher_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLessonFeeInput
     */
    year_month: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLessonFeeInput
     */
    item_name: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLessonFeeInput
     */
    unit_price: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLessonFeeInput
     */
    item_count: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLessonFeeInput
     */
    total_amount: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLessonFeeInput
     */
    tax_rate: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLessonFeeInput
     */
    billing_amount: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLessonFeeInput
     */
    total_option_fee: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLessonFeeInput
     */
    create_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLessonFeeInput
     */
    create_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLessonFeeInput
     */
    update_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLessonFeeInput
     */
    update_datetime: string;
    /**
     * 
     * @type {object}
     * @memberof CreateLessonFeeInput
     */
    delete_flg: object;
    /**
     * 
     * @type {object}
     * @memberof CreateLessonFeeInput
     */
    stop_flg: object;
}
/**
 * 
 * @export
 * @interface CreateLessonInput
 */
export interface CreateLessonInput {
    /**
     * 
     * @type {number}
     * @memberof CreateLessonInput
     */
    company_id: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLessonInput
     */
    payment_id: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLessonInput
     */
    learner_ids?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateLessonInput
     */
    create_user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLessonInput
     */
    create_datetime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLessonInput
     */
    update_user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLessonInput
     */
    update_datetime?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateLessonInput
     */
    delete_flg?: object;
    /**
     * 
     * @type {object}
     * @memberof CreateLessonInput
     */
    stop_flg?: object;
    /**
     * 
     * @type {object}
     * @memberof CreateLessonInput
     */
    approval_flg?: object;
    /**
     * 
     * @type {object}
     * @memberof CreateLessonInput
     */
    cancel_flg?: object;
}
/**
 * 
 * @export
 * @interface CreateLessonLogResponse
 */
export interface CreateLessonLogResponse {
    /**
     * 
     * @type {number}
     * @memberof CreateLessonLogResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof CreateLessonLogResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {TLessonLogs}
     * @memberof CreateLessonLogResponse
     */
    data?: TLessonLogs;
}
/**
 * 
 * @export
 * @interface CreateMaintenanceInput
 */
export interface CreateMaintenanceInput {
    /**
     * 
     * @type {string}
     * @memberof CreateMaintenanceInput
     */
    maintenance_title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMaintenanceInput
     */
    maintenance_detail: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMaintenanceInput
     */
    immediate_flg: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateMaintenanceInput
     */
    start_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMaintenanceInput
     */
    end_datetime: string;
}
/**
 * 
 * @export
 * @interface CreateManagerInput
 */
export interface CreateManagerInput {
    /**
     * 
     * @type {string}
     * @memberof CreateManagerInput
     */
    full_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateManagerInput
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateManagerInput
     */
    manager_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateManagerInput
     */
    create_datetime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateManagerInput
     */
    create_user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateManagerInput
     */
    update_datetime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateManagerInput
     */
    update_user_id?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateManagerInput
     */
    stop_flg: object;
    /**
     * 
     * @type {object}
     * @memberof CreateManagerInput
     */
    delete_flg: object;
    /**
     * 
     * @type {string}
     * @memberof CreateManagerInput
     */
    nick_name: string;
}
/**
 * 
 * @export
 * @interface CreateNoticeCompanyInput
 */
export interface CreateNoticeCompanyInput {
    /**
     * 
     * @type {number}
     * @memberof CreateNoticeCompanyInput
     */
    company_id: number;
    /**
     * 
     * @type {number}
     * @memberof CreateNoticeCompanyInput
     */
    payment_id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateNoticeCompanyInput
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNoticeCompanyInput
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNoticeCompanyInput
     */
    start_datetime: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateNoticeCompanyInput
     */
    end_datetime: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateNoticeCompanyInput
     */
    target: string;
}
/**
 * 
 * @export
 * @interface CreateNoticeInput
 */
export interface CreateNoticeInput {
    /**
     * 
     * @type {string}
     * @memberof CreateNoticeInput
     */
    target_num: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNoticeInput
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNoticeInput
     */
    notice: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNoticeInput
     */
    start_datetime: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateNoticeInput
     */
    end_datetime: string | null;
}
/**
 * 
 * @export
 * @interface CreateRoomChatInput
 */
export interface CreateRoomChatInput {
    /**
     * 
     * @type {string}
     * @memberof CreateRoomChatInput
     */
    lesson_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomChatInput
     */
    sender_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomChatInput
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomChatInput
     */
    receiver_id: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRoomChatInput
     */
    company_id: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRoomChatInput
     */
    chat_number: number;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomChatInput
     */
    create_user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomChatInput
     */
    create_datetime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomChatInput
     */
    update_user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomChatInput
     */
    update_datetime?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateRoomChatInput
     */
    delete_flg: object;
    /**
     * 
     * @type {object}
     * @memberof CreateRoomChatInput
     */
    stop_flg: object;
}
/**
 * 
 * @export
 * @interface CreateSurveyAnswerDto
 */
export interface CreateSurveyAnswerDto {
    /**
     * 
     * @type {number}
     * @memberof CreateSurveyAnswerDto
     */
    question_id: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSurveyAnswerDto
     */
    option_id: number;
}
/**
 * 
 * @export
 * @interface CreateSurveyResponseDto
 */
export interface CreateSurveyResponseDto {
    /**
     * 
     * @type {number}
     * @memberof CreateSurveyResponseDto
     */
    survey_id: number;
    /**
     * 
     * @type {Array<CreateSurveyAnswerDto>}
     * @memberof CreateSurveyResponseDto
     */
    answers: Array<CreateSurveyAnswerDto>;
}
/**
 * 
 * @export
 * @interface CreateSurveyResponseResponse
 */
export interface CreateSurveyResponseResponse {
    /**
     * 
     * @type {number}
     * @memberof CreateSurveyResponseResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof CreateSurveyResponseResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {object}
     * @memberof CreateSurveyResponseResponse
     */
    data: object | null;
}
/**
 * 
 * @export
 * @interface CreateTeacherInput
 */
export interface CreateTeacherInput {
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherInput
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherInput
     */
    full_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherInput
     */
    nick_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherInput
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherInput
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherInput
     */
    memo: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherInput
     */
    teacher_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherInput
     */
    create_user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherInput
     */
    create_datetime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherInput
     */
    update_user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherInput
     */
    update_datetime?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateTeacherInput
     */
    delete_flg: object;
    /**
     * 
     * @type {object}
     * @memberof CreateTeacherInput
     */
    stop_flg: object;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherInput
     */
    bill_to: string;
}
/**
 * 
 * @export
 * @interface DailyStudyData
 */
export interface DailyStudyData {
    /**
     * 
     * @type {string}
     * @memberof DailyStudyData
     */
    date: string;
    /**
     * 
     * @type {number}
     * @memberof DailyStudyData
     */
    totalDurationMinutes: number;
    /**
     * 
     * @type {boolean}
     * @memberof DailyStudyData
     */
    hasStudied?: boolean;
    /**
     * セッション種別ごとの詳細
     * @type {Array<SessionTypeDetailDto>}
     * @memberof DailyStudyData
     */
    sessionBreakdown?: Array<SessionTypeDetailDto>;
}
/**
 * 
 * @export
 * @interface DeactivateLearnerEndPointsResponse
 */
export interface DeactivateLearnerEndPointsResponse {
    /**
     * 
     * @type {number}
     * @memberof DeactivateLearnerEndPointsResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof DeactivateLearnerEndPointsResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeactivateLearnerEndPointsResponse
     */
    data?: Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteAgreementInput
 */
export interface DeleteAgreementInput {
    /**
     * 
     * @type {number}
     * @memberof DeleteAgreementInput
     */
    company_id: number;
    /**
     * 
     * @type {number}
     * @memberof DeleteAgreementInput
     */
    payment_id: number;
    /**
     * 
     * @type {string}
     * @memberof DeleteAgreementInput
     */
    target_month?: string;
}
/**
 * 
 * @export
 * @interface DeleteLessonLearnerInput
 */
export interface DeleteLessonLearnerInput {
    /**
     * 
     * @type {string}
     * @memberof DeleteLessonLearnerInput
     */
    learnerId: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteLessonLearnerInput
     */
    cancelStatus: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteLessonLearnerInput
     */
    participationStatus: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteLessonLearnerInput
     */
    cancelReason?: string;
}
/**
 * 
 * @export
 * @interface DrillParam
 */
export interface DrillParam {
    /**
     * 
     * @type {number}
     * @memberof DrillParam
     */
    drill_id: number;
    /**
     * 
     * @type {string}
     * @memberof DrillParam
     */
    drill_name: string;
}
/**
 * 
 * @export
 * @interface ExistsLearnerInPlanInput
 */
export interface ExistsLearnerInPlanInput {
    /**
     * 
     * @type {string}
     * @memberof ExistsLearnerInPlanInput
     */
    email: string;
    /**
     * 
     * @type {number}
     * @memberof ExistsLearnerInPlanInput
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof ExistsLearnerInPlanInput
     */
    paymentId: number;
}
/**
 * 
 * @export
 * @interface ExistsLearnerInput
 */
export interface ExistsLearnerInput {
    /**
     * 
     * @type {string}
     * @memberof ExistsLearnerInput
     */
    email: string;
}
/**
 * 
 * @export
 * @interface ForgotCompanyPasswordInput
 */
export interface ForgotCompanyPasswordInput {
    /**
     * 
     * @type {string}
     * @memberof ForgotCompanyPasswordInput
     */
    email: string;
}
/**
 * 
 * @export
 * @interface ForgotLearnerPasswordInput
 */
export interface ForgotLearnerPasswordInput {
    /**
     * 
     * @type {string}
     * @memberof ForgotLearnerPasswordInput
     */
    email: string;
}
/**
 * 
 * @export
 * @interface GetApprovedLessonsResponse
 */
export interface GetApprovedLessonsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetApprovedLessonsResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetApprovedLessonsResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {LessonList}
     * @memberof GetApprovedLessonsResponse
     */
    data?: LessonList;
}
/**
 * 
 * @export
 * @interface GetCheckTestStatusResponse
 */
export interface GetCheckTestStatusResponse {
    /**
     * 
     * @type {number}
     * @memberof GetCheckTestStatusResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetCheckTestStatusResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {CheckTestStatus}
     * @memberof GetCheckTestStatusResponse
     */
    data: CheckTestStatus;
}
/**
 * 
 * @export
 * @interface GetCompletedStagesData
 */
export interface GetCompletedStagesData {
    /**
     * 
     * @type {Array<number>}
     * @memberof GetCompletedStagesData
     */
    completedStages: Array<number>;
}
/**
 * 
 * @export
 * @interface GetCompletedStagesResponse
 */
export interface GetCompletedStagesResponse {
    /**
     * 
     * @type {number}
     * @memberof GetCompletedStagesResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetCompletedStagesResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {GetCompletedStagesData}
     * @memberof GetCompletedStagesResponse
     */
    data: GetCompletedStagesData | null;
}
/**
 * 
 * @export
 * @interface GetHighestStageCompletedResponse
 */
export interface GetHighestStageCompletedResponse {
    /**
     * 
     * @type {number}
     * @memberof GetHighestStageCompletedResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetHighestStageCompletedResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {IsHighestStageCompleted}
     * @memberof GetHighestStageCompletedResponse
     */
    data: IsHighestStageCompleted;
}
/**
 * 
 * @export
 * @interface GetLatestSurveyData
 */
export interface GetLatestSurveyData {
    /**
     * 
     * @type {boolean}
     * @memberof GetLatestSurveyData
     */
    has_responded: boolean | null;
    /**
     * 
     * @type {SurveyDto}
     * @memberof GetLatestSurveyData
     */
    survey: SurveyDto | null;
}
/**
 * 
 * @export
 * @interface GetLatestSurveyResponse
 */
export interface GetLatestSurveyResponse {
    /**
     * 
     * @type {number}
     * @memberof GetLatestSurveyResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetLatestSurveyResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {GetLatestSurveyData}
     * @memberof GetLatestSurveyResponse
     */
    data: GetLatestSurveyData;
}
/**
 * 
 * @export
 * @interface GetLearnerActiveEndPointCountResponse
 */
export interface GetLearnerActiveEndPointCountResponse {
    /**
     * 
     * @type {number}
     * @memberof GetLearnerActiveEndPointCountResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetLearnerActiveEndPointCountResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetLearnerActiveEndPointCountResponse
     */
    data?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetLearnerByEmailResponse
 */
export interface GetLearnerByEmailResponse {
    /**
     * 
     * @type {number}
     * @memberof GetLearnerByEmailResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetLearnerByEmailResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {MLearner}
     * @memberof GetLearnerByEmailResponse
     */
    data?: MLearner;
}
/**
 * 
 * @export
 * @interface GetLearnerByIdResponse
 */
export interface GetLearnerByIdResponse {
    /**
     * 
     * @type {number}
     * @memberof GetLearnerByIdResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetLearnerByIdResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {MLearner}
     * @memberof GetLearnerByIdResponse
     */
    data?: MLearner;
}
/**
 * 
 * @export
 * @interface GetLearnerDetailsResponse
 */
export interface GetLearnerDetailsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetLearnerDetailsResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetLearnerDetailsResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {MLearner | MCompanyUser}
     * @memberof GetLearnerDetailsResponse
     */
    data?: MLearner | MCompanyUser;
}
/**
 * 
 * @export
 * @interface GetLearnerStudyTimeResponse
 */
export interface GetLearnerStudyTimeResponse {
    /**
     * 
     * @type {number}
     * @memberof GetLearnerStudyTimeResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetLearnerStudyTimeResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {StudyTimeInfo}
     * @memberof GetLearnerStudyTimeResponse
     */
    data: StudyTimeInfo;
}
/**
 * 
 * @export
 * @interface GetLearnerTotalLessonsVsParticipatedLessonsResponse
 */
export interface GetLearnerTotalLessonsVsParticipatedLessonsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetLearnerTotalLessonsVsParticipatedLessonsResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetLearnerTotalLessonsVsParticipatedLessonsResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {TotalLessonsVsParticipatedLessons}
     * @memberof GetLearnerTotalLessonsVsParticipatedLessonsResponse
     */
    data: TotalLessonsVsParticipatedLessons;
}
/**
 * 
 * @export
 * @interface GetLearnerUserListResponse
 */
export interface GetLearnerUserListResponse {
    /**
     * 
     * @type {number}
     * @memberof GetLearnerUserListResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetLearnerUserListResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {Array<TLearnerUser>}
     * @memberof GetLearnerUserListResponse
     */
    data?: Array<TLearnerUser>;
}
/**
 * 
 * @export
 * @interface GetLearnersWithoutFeedbackResponse
 */
export interface GetLearnersWithoutFeedbackResponse {
    /**
     * 
     * @type {number}
     * @memberof GetLearnersWithoutFeedbackResponse
     */
    code: number;
    /**
     * 
     * @type {object}
     * @memberof GetLearnersWithoutFeedbackResponse
     */
    message: object;
    /**
     * 
     * @type {LearnerFeedbackList}
     * @memberof GetLearnersWithoutFeedbackResponse
     */
    data?: LearnerFeedbackList;
}
/**
 * 
 * @export
 * @interface GetMostRecentScheduledLessonResponse
 */
export interface GetMostRecentScheduledLessonResponse {
    /**
     * 
     * @type {number}
     * @memberof GetMostRecentScheduledLessonResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetMostRecentScheduledLessonResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {SingleLesson}
     * @memberof GetMostRecentScheduledLessonResponse
     */
    data?: SingleLesson;
}
/**
 * 
 * @export
 * @interface GetNotUpdatedNoteLessonsResponse
 */
export interface GetNotUpdatedNoteLessonsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetNotUpdatedNoteLessonsResponse
     */
    code: number;
    /**
     * 
     * @type {object}
     * @memberof GetNotUpdatedNoteLessonsResponse
     */
    message: object;
    /**
     * 
     * @type {LessonList}
     * @memberof GetNotUpdatedNoteLessonsResponse
     */
    data?: LessonList;
}
/**
 * 
 * @export
 * @interface GetNoticeReadResponse
 */
export interface GetNoticeReadResponse {
    /**
     * 
     * @type {number}
     * @memberof GetNoticeReadResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetNoticeReadResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {object}
     * @memberof GetNoticeReadResponse
     */
    data?: object;
}
/**
 * 
 * @export
 * @interface GetNoticeUnreadCountResponse
 */
export interface GetNoticeUnreadCountResponse {
    /**
     * 
     * @type {number}
     * @memberof GetNoticeUnreadCountResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetNoticeUnreadCountResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {Array<Response>}
     * @memberof GetNoticeUnreadCountResponse
     */
    data?: Array<Response>;
}
/**
 * 
 * @export
 * @interface GetNoticesResponse
 */
export interface GetNoticesResponse {
    /**
     * 
     * @type {number}
     * @memberof GetNoticesResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetNoticesResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {Array<number | Array<object>>}
     * @memberof GetNoticesResponse
     */
    data?: Array<number | Array<object>>;
}
/**
 * 
 * @export
 * @interface GetPastLessonsResponse
 */
export interface GetPastLessonsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPastLessonsResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetPastLessonsResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {LessonList}
     * @memberof GetPastLessonsResponse
     */
    data?: LessonList;
}
/**
 * 
 * @export
 * @interface GetPushMsgLogResponse
 */
export interface GetPushMsgLogResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPushMsgLogResponse
     */
    code: number;
    /**
     * 
     * @type {object}
     * @memberof GetPushMsgLogResponse
     */
    message: object;
    /**
     * 
     * @type {TPushMsgLog}
     * @memberof GetPushMsgLogResponse
     */
    data?: TPushMsgLog;
}
/**
 * 
 * @export
 * @interface GetPushMsgResponse
 */
export interface GetPushMsgResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPushMsgResponse
     */
    code: number;
    /**
     * 
     * @type {object}
     * @memberof GetPushMsgResponse
     */
    message: object;
    /**
     * 
     * @type {TPushMsgQue}
     * @memberof GetPushMsgResponse
     */
    data?: TPushMsgQue;
}
/**
 * 
 * @export
 * @interface GetPushVapidPublicKeyResponse
 */
export interface GetPushVapidPublicKeyResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPushVapidPublicKeyResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetPushVapidPublicKeyResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetPushVapidPublicKeyResponse
     */
    data?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetStudyRecordsResponse
 */
export interface GetStudyRecordsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetStudyRecordsResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof GetStudyRecordsResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {StudyRecordsStoryList}
     * @memberof GetStudyRecordsResponse
     */
    data?: StudyRecordsStoryList;
}
/**
 * 
 * @export
 * @interface GetUnApprovedLessonsResponse
 */
export interface GetUnApprovedLessonsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetUnApprovedLessonsResponse
     */
    code: number;
    /**
     * 
     * @type {object}
     * @memberof GetUnApprovedLessonsResponse
     */
    message: object;
    /**
     * 
     * @type {LessonList}
     * @memberof GetUnApprovedLessonsResponse
     */
    data?: LessonList;
}
/**
 * 
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse200
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200
     */
    message?: string;
    /**
     * 
     * @type {InlineResponse200Data}
     * @memberof InlineResponse200
     */
    data?: InlineResponse200Data;
}
/**
 * 
 * @export
 * @interface InlineResponse200Data
 */
export interface InlineResponse200Data {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse200Data
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200Data
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof InlineResponse200Data
     */
    data?: object;
}
/**
 * 
 * @export
 * @interface IsHighestStageCompleted
 */
export interface IsHighestStageCompleted {
    /**
     * 
     * @type {boolean}
     * @memberof IsHighestStageCompleted
     */
    isHighestStageCompleted: boolean | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum LESSONLOGTYPE {
    Learner = 'ENTERING_LEARNER',
    Teacher = 'ENTERING_TEACHER'
}

/**
 * 
 * @export
 * @interface LearnerEndpoint
 */
export interface LearnerEndpoint {
    /**
     * 
     * @type {string}
     * @memberof LearnerEndpoint
     */
    endpoint: string;
    /**
     * 
     * @type {string}
     * @memberof LearnerEndpoint
     */
    webpush_object: string;
    /**
     * 
     * @type {string}
     * @memberof LearnerEndpoint
     */
    language_code: string;
    /**
     * 
     * @type {string}
     * @memberof LearnerEndpoint
     */
    active_flg: string;
}
/**
 * 
 * @export
 * @interface LearnerFeedbackItem
 */
export interface LearnerFeedbackItem {
    /**
     * 
     * @type {string}
     * @memberof LearnerFeedbackItem
     */
    lesson_id: string;
    /**
     * 
     * @type {number}
     * @memberof LearnerFeedbackItem
     */
    company_id: number;
    /**
     * 
     * @type {string}
     * @memberof LearnerFeedbackItem
     */
    learner_id: string;
    /**
     * 
     * @type {string}
     * @memberof LearnerFeedbackItem
     */
    learner_full_name: string;
    /**
     * 
     * @type {string}
     * @memberof LearnerFeedbackItem
     */
    start_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof LearnerFeedbackItem
     */
    end_datetime: string;
}
/**
 * 
 * @export
 * @interface LearnerFeedbackList
 */
export interface LearnerFeedbackList {
    /**
     * 
     * @type {Array<LearnerFeedbackItem>}
     * @memberof LearnerFeedbackList
     */
    learners: Array<LearnerFeedbackItem>;
    /**
     * 
     * @type {number}
     * @memberof LearnerFeedbackList
     */
    total: number;
}
/**
 * 
 * @export
 * @interface LessonList
 */
export interface LessonList {
    /**
     * 
     * @type {Array<SingleLesson>}
     * @memberof LessonList
     */
    lessons: Array<SingleLesson>;
    /**
     * 
     * @type {number}
     * @memberof LessonList
     */
    total: number;
}
/**
 * 
 * @export
 * @interface LessonLogType
 */
export interface LessonLogType {
    /**
     * 
     * @type {LESSONLOGTYPE}
     * @memberof LessonLogType
     */
    lesson_log_type: LESSONLOGTYPE;
}
/**
 * 
 * @export
 * @interface LessonLoggingInput
 */
export interface LessonLoggingInput {
    /**
     * 
     * @type {string}
     * @memberof LessonLoggingInput
     */
    currentPage: string;
    /**
     * 
     * @type {string}
     * @memberof LessonLoggingInput
     */
    action: string;
    /**
     * 
     * @type {number}
     * @memberof LessonLoggingInput
     */
    timestampMillis: number;
    /**
     * 
     * @type {string}
     * @memberof LessonLoggingInput
     */
    userAgent: string;
    /**
     * 
     * @type {string}
     * @memberof LessonLoggingInput
     */
    options: string;
    /**
     * 
     * @type {string}
     * @memberof LessonLoggingInput
     */
    roomId: string;
    /**
     * 
     * @type {string}
     * @memberof LessonLoggingInput
     */
    lessonId: string;
}
/**
 * 
 * @export
 * @interface LoggingInput
 */
export interface LoggingInput {
    /**
     * 
     * @type {string}
     * @memberof LoggingInput
     */
    currentPage: string;
    /**
     * 
     * @type {string}
     * @memberof LoggingInput
     */
    action: string;
    /**
     * 
     * @type {number}
     * @memberof LoggingInput
     */
    timestampMillis: number;
    /**
     * 
     * @type {string}
     * @memberof LoggingInput
     */
    userAgent: string;
    /**
     * 
     * @type {string}
     * @memberof LoggingInput
     */
    options: string;
}
/**
 * 
 * @export
 * @interface MCompany
 */
export interface MCompany {
    /**
     * 
     * @type {number}
     * @memberof MCompany
     */
    company_id?: number;
    /**
     * 
     * @type {string}
     * @memberof MCompany
     */
    create_datetime?: string;
    /**
     * 
     * @type {string}
     * @memberof MCompany
     */
    create_user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MCompany
     */
    update_datetime?: string;
    /**
     * 
     * @type {string}
     * @memberof MCompany
     */
    update_user_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MCompany
     */
    stop_flg?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MCompany
     */
    delete_flg?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MCompany
     */
    company_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MCompany
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MCompany
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MCompany
     */
    representative?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MCompany
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MCompany
     */
    main_bank_info?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MCompany
     */
    main_bank_account?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MCompany
     */
    trransfer_bank_info?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MCompany
     */
    trransfer_bank_account?: string | null;
}
/**
 * 
 * @export
 * @interface MCompanyUser
 */
export interface MCompanyUser {
    /**
     * 
     * @type {number}
     * @memberof MCompanyUser
     */
    company_id: number;
    /**
     * 
     * @type {string}
     * @memberof MCompanyUser
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof MCompanyUser
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof MCompanyUser
     */
    user_name: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum MESSAGE {
    NoError = 'NO_ERROR',
    InternalServerError = 'INTERNAL_SERVER_ERROR',
    NotAuthorizedUserAccess = 'NOT_AUTHORIZED_USER_ACCESS',
    IdIsDuplicate = 'ID_IS_DUPLICATE',
    MailAddressRegisted = 'MAIL_ADDRESS_REGISTED',
    InvalidArgumentException = 'INVALID_ARGUMENT_EXCEPTION',
    CognitoFailure = 'COGNITO_FAILURE',
    DataConflict = 'DATA_CONFLICT'
}

/**
 * 
 * @export
 * @interface MLearner
 */
export interface MLearner {
    /**
     * 
     * @type {MCompany}
     * @memberof MLearner
     */
    m_company?: MCompany | null;
    /**
     * 
     * @type {number}
     * @memberof MLearner
     */
    company_id: number;
    /**
     * 
     * @type {string}
     * @memberof MLearner
     */
    learner_id: string;
    /**
     * 
     * @type {string}
     * @memberof MLearner
     */
    create_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof MLearner
     */
    create_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof MLearner
     */
    update_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof MLearner
     */
    update_user_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof MLearner
     */
    stop_flg: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MLearner
     */
    delete_flg: boolean;
    /**
     * 
     * @type {string}
     * @memberof MLearner
     */
    nick_name: string;
    /**
     * 
     * @type {string}
     * @memberof MLearner
     */
    full_name: string;
    /**
     * 
     * @type {string}
     * @memberof MLearner
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof MLearner
     */
    email_send_flg: boolean;
    /**
     * 
     * @type {string}
     * @memberof MLearner
     */
    last_login_datetime?: string | null;
}
/**
 * 
 * @export
 * @interface MTeacher
 */
export interface MTeacher {
    /**
     * 
     * @type {string}
     * @memberof MTeacher
     */
    teacher_id: string;
    /**
     * 
     * @type {string}
     * @memberof MTeacher
     */
    create_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof MTeacher
     */
    create_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof MTeacher
     */
    update_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof MTeacher
     */
    update_user_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof MTeacher
     */
    stop_flg: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MTeacher
     */
    delete_flg: boolean;
    /**
     * 
     * @type {string}
     * @memberof MTeacher
     */
    nick_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MTeacher
     */
    full_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MTeacher
     */
    email: string;
    /**
     * 
     * @type {number}
     * @memberof MTeacher
     */
    rank_id: number;
    /**
     * 
     * @type {string}
     * @memberof MTeacher
     */
    bill_to?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MTeacher
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof MTeacher
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof MTeacher
     */
    memo: string;
}
/**
 * 
 * @export
 * @interface PostStudyRecordStoryResponse
 */
export interface PostStudyRecordStoryResponse {
    /**
     * 
     * @type {number}
     * @memberof PostStudyRecordStoryResponse
     */
    code: number;
    /**
     * 
     * @type {object}
     * @memberof PostStudyRecordStoryResponse
     */
    message: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostStudyRecordStoryResponse
     */
    data: Array<string>;
}
/**
 * 
 * @export
 * @interface PushKeys
 */
export interface PushKeys {
    /**
     * 
     * @type {string}
     * @memberof PushKeys
     */
    p256dh: string;
    /**
     * 
     * @type {string}
     * @memberof PushKeys
     */
    auth: string;
}
/**
 * 
 * @export
 * @interface PushMsg
 */
export interface PushMsg {
    /**
     * 
     * @type {number}
     * @memberof PushMsg
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PushMsg
     */
    target_type: string;
    /**
     * 
     * @type {string}
     * @memberof PushMsg
     */
    target_id: string;
    /**
     * 
     * @type {string}
     * @memberof PushMsg
     */
    language_code: string;
    /**
     * 
     * @type {string}
     * @memberof PushMsg
     */
    msg_type: string;
    /**
     * 
     * @type {string}
     * @memberof PushMsg
     */
    msg: string;
    /**
     * 
     * @type {string}
     * @memberof PushMsg
     */
    send_at: string;
    /**
     * 
     * @type {string}
     * @memberof PushMsg
     */
    sent_at: string;
}
/**
 * 
 * @export
 * @interface PushMsgLog
 */
export interface PushMsgLog {
    /**
     * 
     * @type {number}
     * @memberof PushMsgLog
     */
    push_msg_q_id: number;
    /**
     * 
     * @type {string}
     * @memberof PushMsgLog
     */
    learner_id: string;
    /**
     * 
     * @type {string}
     * @memberof PushMsgLog
     */
    endpoint: string;
    /**
     * 
     * @type {number}
     * @memberof PushMsgLog
     */
    http_result: number;
}
/**
 * 
 * @export
 * @interface PushSubscribeDto
 */
export interface PushSubscribeDto {
    /**
     * 
     * @type {string}
     * @memberof PushSubscribeDto
     */
    endpoint: string;
    /**
     * 
     * @type {number}
     * @memberof PushSubscribeDto
     */
    expirationTime: number | null;
    /**
     * 
     * @type {PushKeys}
     * @memberof PushSubscribeDto
     */
    keys: PushKeys;
}
/**
 * 
 * @export
 * @interface PushUnsubscribeDto
 */
export interface PushUnsubscribeDto {
    /**
     * 
     * @type {string}
     * @memberof PushUnsubscribeDto
     */
    endpoint: string;
}
/**
 * 
 * @export
 * @interface PutDrillRecordResponse
 */
export interface PutDrillRecordResponse {
    /**
     * 
     * @type {number}
     * @memberof PutDrillRecordResponse
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof PutDrillRecordResponse
     */
    message: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PutDrillRecordResponse
     */
    data: Array<string>;
}
/**
 * 
 * @export
 * @interface PutNoticeReadResponse
 */
export interface PutNoticeReadResponse {
    /**
     * 
     * @type {number}
     * @memberof PutNoticeReadResponse
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof PutNoticeReadResponse
     */
    message: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PutNoticeReadResponse
     */
    data?: Array<string>;
}
/**
 * 
 * @export
 * @interface PutStudyRecordRecordResponse
 */
export interface PutStudyRecordRecordResponse {
    /**
     * 
     * @type {number}
     * @memberof PutStudyRecordRecordResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof PutStudyRecordRecordResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {Array<string>}
     * @memberof PutStudyRecordRecordResponse
     */
    data: Array<string>;
}
/**
 * 
 * @export
 * @interface RecordStudySessionInput
 */
export interface RecordStudySessionInput {
    /**
     * 
     * @type {number}
     * @memberof RecordStudySessionInput
     */
    actionType: number;
    /**
     * 
     * @type {number}
     * @memberof RecordStudySessionInput
     */
    sessionId: number;
}
/**
 * 
 * @export
 * @interface RecordStudySessionResponse
 */
export interface RecordStudySessionResponse {
    /**
     * 
     * @type {number}
     * @memberof RecordStudySessionResponse
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof RecordStudySessionResponse
     */
    message: string;
    /**
     * 
     * @type {object}
     * @memberof RecordStudySessionResponse
     */
    data: object;
}
/**
 * 
 * @export
 * @interface ResetCompanyUserPasswordInput
 */
export interface ResetCompanyUserPasswordInput {
    /**
     * 
     * @type {string}
     * @memberof ResetCompanyUserPasswordInput
     */
    password: string;
}
/**
 * 
 * @export
 * @interface ResetLearnerPasswordInput
 */
export interface ResetLearnerPasswordInput {
    /**
     * 
     * @type {string}
     * @memberof ResetLearnerPasswordInput
     */
    password: string;
}
/**
 * 
 * @export
 * @interface Response
 */
export interface Response {
    /**
     * 
     * @type {string}
     * @memberof Response
     */
    count: string;
}
/**
 * 
 * @export
 * @interface ResponseData
 */
export interface ResponseData {
    /**
     * 
     * @type {string}
     * @memberof ResponseData
     */
    CLIENT_ID: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum SURVEYOPTIONNEXTACTIONENUM {
    Continue = 'continue',
    End = 'end'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum SURVEYQUESTIONTYPEENUM {
    SingleChoice = 'single_choice',
    MultipleChoice = 'multiple_choice'
}

/**
 * 
 * @export
 * @interface SaveStudyRecordStageInput
 */
export interface SaveStudyRecordStageInput {
    /**
     * 
     * @type {string}
     * @memberof SaveStudyRecordStageInput
     */
    jlptLevel: string;
    /**
     * 
     * @type {number}
     * @memberof SaveStudyRecordStageInput
     */
    stage: number;
    /**
     * 
     * @type {number}
     * @memberof SaveStudyRecordStageInput
     */
    recordType: SaveStudyRecordStageInputRecordTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SaveStudyRecordStageInput
     */
    correctCount: number;
    /**
     * 
     * @type {number}
     * @memberof SaveStudyRecordStageInput
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof SaveStudyRecordStageInput
     */
    sessionId: number;
    /**
     * 
     * @type {Array<StudyRecordsStageDetailsDto>}
     * @memberof SaveStudyRecordStageInput
     */
    stageDetails: Array<StudyRecordsStageDetailsDto>;
    /**
     * 
     * @type {number}
     * @memberof SaveStudyRecordStageInput
     */
    mode: SaveStudyRecordStageInputModeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SaveStudyRecordStageInput
     */
    passedStatus: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum SaveStudyRecordStageInputRecordTypeEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}
/**
    * @export
    * @enum {string}
    */
export enum SaveStudyRecordStageInputModeEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2
}

/**
 * 
 * @export
 * @interface SessionTypeDetailDto
 */
export interface SessionTypeDetailDto {
    /**
     * セッション種別 (1: ストーリー, 2: ドリル, 3: ひらがな, 4: カタカナ, 5: JLPT対策, 6: レッスン, 7: その他)
     * @type {number}
     * @memberof SessionTypeDetailDto
     */
    typeLevel1: SessionTypeDetailDtoTypeLevel1Enum;
    /**
     * 
     * @type {number}
     * @memberof SessionTypeDetailDto
     */
    totalMinutes: number;
}

/**
    * @export
    * @enum {string}
    */
export enum SessionTypeDetailDtoTypeLevel1Enum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5,
    NUMBER_6 = 6,
    NUMBER_7 = 7
}

/**
 * 
 * @export
 * @interface SingleLesson
 */
export interface SingleLesson {
    /**
     * 
     * @type {MCompany}
     * @memberof SingleLesson
     */
    m_company?: MCompany;
    /**
     * 
     * @type {TPaymentCompany}
     * @memberof SingleLesson
     */
    t_payment_company?: TPaymentCompany;
    /**
     * 
     * @type {number}
     * @memberof SingleLesson
     */
    company_id: number;
    /**
     * 
     * @type {string}
     * @memberof SingleLesson
     */
    lesson_id: string;
    /**
     * 
     * @type {string}
     * @memberof SingleLesson
     */
    create_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof SingleLesson
     */
    create_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof SingleLesson
     */
    update_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof SingleLesson
     */
    update_user_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof SingleLesson
     */
    delete_flg: boolean;
    /**
     * 
     * @type {string}
     * @memberof SingleLesson
     */
    room_id: string;
    /**
     * 
     * @type {string}
     * @memberof SingleLesson
     */
    start_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof SingleLesson
     */
    end_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof SingleLesson
     */
    note: string;
    /**
     * 
     * @type {number}
     * @memberof SingleLesson
     */
    payment_id: number;
    /**
     * 
     * @type {boolean}
     * @memberof SingleLesson
     */
    approval_flg: boolean;
    /**
     * 
     * @type {number}
     * @memberof SingleLesson
     */
    cancel_flg: number;
    /**
     * 
     * @type {string}
     * @memberof SingleLesson
     */
    theme?: string | null;
    /**
     * 
     * @type {Array<TLessonLearner>}
     * @memberof SingleLesson
     */
    t_lesson_learner: Array<TLessonLearner>;
    /**
     * 
     * @type {Array<TLessonTeacher>}
     * @memberof SingleLesson
     */
    t_lesson_teacher: Array<TLessonTeacher>;
    /**
     * 
     * @type {string}
     * @memberof SingleLesson
     */
    lesson_day?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleLesson
     */
    start_time?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleLesson
     */
    end_time?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleLesson
     */
    learner_names?: string;
}
/**
 * 
 * @export
 * @interface StartStudySessionInput
 */
export interface StartStudySessionInput {
    /**
     * 
     * @type {number}
     * @memberof StartStudySessionInput
     */
    sessionType: number;
    /**
     * 
     * @type {string}
     * @memberof StartStudySessionInput
     */
    sessionTypeLevel2?: string;
}
/**
 * 
 * @export
 * @interface StartStudySessionResponse
 */
export interface StartStudySessionResponse {
    /**
     * 
     * @type {number}
     * @memberof StartStudySessionResponse
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof StartStudySessionResponse
     */
    message: string;
    /**
     * 
     * @type {StartStudySessionResponseData}
     * @memberof StartStudySessionResponse
     */
    data: StartStudySessionResponseData;
}
/**
 * 
 * @export
 * @interface StartStudySessionResponseData
 */
export interface StartStudySessionResponseData {
    /**
     * 
     * @type {number}
     * @memberof StartStudySessionResponseData
     */
    sessionId: number;
}
/**
 * 
 * @export
 * @interface StudyRecordsStageDetailsDto
 */
export interface StudyRecordsStageDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof StudyRecordsStageDetailsDto
     */
    questionId: string;
    /**
     * 
     * @type {string}
     * @memberof StudyRecordsStageDetailsDto
     */
    givenAnswer: string;
    /**
     * 
     * @type {boolean}
     * @memberof StudyRecordsStageDetailsDto
     */
    isCorrect: boolean;
    /**
     * 
     * @type {number}
     * @memberof StudyRecordsStageDetailsDto
     */
    questionType: number;
}
/**
 * 
 * @export
 * @interface StudyRecordsStoryList
 */
export interface StudyRecordsStoryList {
    /**
     * 
     * @type {Array<TStudyRecordsStory>}
     * @memberof StudyRecordsStoryList
     */
    records: Array<TStudyRecordsStory>;
    /**
     * 
     * @type {number}
     * @memberof StudyRecordsStoryList
     */
    total: number;
}
/**
 * 
 * @export
 * @interface StudyResult
 */
export interface StudyResult {
    /**
     * 
     * @type {string}
     * @memberof StudyResult
     */
    chapter_id: string;
    /**
     * 
     * @type {number}
     * @memberof StudyResult
     */
    total_count: number;
}
/**
 * 
 * @export
 * @interface StudyTimeInfo
 */
export interface StudyTimeInfo {
    /**
     * 
     * @type {Array<DailyStudyData>}
     * @memberof StudyTimeInfo
     */
    lastSevenDaysStudyTime: Array<DailyStudyData>;
    /**
     * 
     * @type {number}
     * @memberof StudyTimeInfo
     */
    totalStudyTime: number;
    /**
     * 
     * @type {Array<DailyStudyData>}
     * @memberof StudyTimeInfo
     */
    thisMonthStudyTime: Array<DailyStudyData>;
}
/**
 * 
 * @export
 * @interface SurveyDto
 */
export interface SurveyDto {
    /**
     * 
     * @type {number}
     * @memberof SurveyDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyDto
     */
    title: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SurveyDto
     */
    selected_option_texts: Array<string>;
    /**
     * 
     * @type {Array<SurveyQuestionDto>}
     * @memberof SurveyDto
     */
    questions: Array<SurveyQuestionDto>;
}
/**
 * 
 * @export
 * @interface SurveyOptionDto
 */
export interface SurveyOptionDto {
    /**
     * 
     * @type {number}
     * @memberof SurveyOptionDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyOptionDto
     */
    option_text: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyOptionDto
     */
    sort_order: number;
    /**
     * 
     * @type {SURVEYOPTIONNEXTACTIONENUM}
     * @memberof SurveyOptionDto
     */
    next_action: SURVEYOPTIONNEXTACTIONENUM;
}
/**
 * 
 * @export
 * @interface SurveyQuestionDto
 */
export interface SurveyQuestionDto {
    /**
     * 
     * @type {number}
     * @memberof SurveyQuestionDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionDto
     */
    question_text: string | null;
    /**
     * 
     * @type {SURVEYQUESTIONTYPEENUM}
     * @memberof SurveyQuestionDto
     */
    question_type: SURVEYQUESTIONTYPEENUM;
    /**
     * 
     * @type {number}
     * @memberof SurveyQuestionDto
     */
    sort_order: number;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyQuestionDto
     */
    is_required: boolean;
    /**
     * 
     * @type {Array<SurveyOptionDto>}
     * @memberof SurveyQuestionDto
     */
    options: Array<SurveyOptionDto>;
}
/**
 * 
 * @export
 * @interface TLearnerUser
 */
export interface TLearnerUser {
    /**
     * 
     * @type {string}
     * @memberof TLearnerUser
     */
    learner_id: string;
    /**
     * 
     * @type {string}
     * @memberof TLearnerUser
     */
    full_name: string;
    /**
     * 
     * @type {string}
     * @memberof TLearnerUser
     */
    email: string;
}
/**
 * 
 * @export
 * @interface TLesson
 */
export interface TLesson {
    /**
     * 
     * @type {MCompany}
     * @memberof TLesson
     */
    m_company?: MCompany | null;
    /**
     * 
     * @type {TPaymentCompany}
     * @memberof TLesson
     */
    t_payment_company?: TPaymentCompany | null;
}
/**
 * 
 * @export
 * @interface TLessonLearner
 */
export interface TLessonLearner {
    /**
     * 
     * @type {MCompany}
     * @memberof TLessonLearner
     */
    m_company?: MCompany | null;
    /**
     * 
     * @type {TLesson}
     * @memberof TLessonLearner
     */
    t_lesson?: TLesson;
    /**
     * 
     * @type {MLearner}
     * @memberof TLessonLearner
     */
    m_learner?: MLearner;
    /**
     * 
     * @type {number}
     * @memberof TLessonLearner
     */
    company_id: number;
    /**
     * 
     * @type {string}
     * @memberof TLessonLearner
     */
    lesson_id: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonLearner
     */
    learner_id: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonLearner
     */
    create_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonLearner
     */
    create_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonLearner
     */
    update_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonLearner
     */
    update_user_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof TLessonLearner
     */
    stop_flg: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TLessonLearner
     */
    delete_flg: boolean;
    /**
     * 
     * @type {string}
     * @memberof TLessonLearner
     */
    connection_id: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonLearner
     */
    feed_back?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TLessonLearner
     */
    cancel_status: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonLearner
     */
    participation_status: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonLearner
     */
    cancel_reason?: string | null;
}
/**
 * 
 * @export
 * @interface TLessonLogs
 */
export interface TLessonLogs {
    /**
     * 
     * @type {number}
     * @memberof TLessonLogs
     */
    company_id: number;
    /**
     * 
     * @type {string}
     * @memberof TLessonLogs
     */
    lesson_id: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonLogs
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonLogs
     */
    event_datetime: string;
    /**
     * 
     * @type {object}
     * @memberof TLessonLogs
     */
    lesson_log_type: object;
    /**
     * 
     * @type {string}
     * @memberof TLessonLogs
     */
    create_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonLogs
     */
    create_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonLogs
     */
    update_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonLogs
     */
    update_user_id: string;
}
/**
 * 
 * @export
 * @interface TLessonTeacher
 */
export interface TLessonTeacher {
    /**
     * 
     * @type {MCompany}
     * @memberof TLessonTeacher
     */
    m_company?: MCompany | null;
    /**
     * 
     * @type {TLesson}
     * @memberof TLessonTeacher
     */
    t_lesson: TLesson;
    /**
     * 
     * @type {MTeacher}
     * @memberof TLessonTeacher
     */
    m_teacher: MTeacher;
    /**
     * 
     * @type {number}
     * @memberof TLessonTeacher
     */
    company_id: number;
    /**
     * 
     * @type {string}
     * @memberof TLessonTeacher
     */
    lesson_id: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonTeacher
     */
    teacher_id: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonTeacher
     */
    create_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonTeacher
     */
    create_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonTeacher
     */
    update_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof TLessonTeacher
     */
    update_user_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof TLessonTeacher
     */
    delete_flg: boolean;
    /**
     * 
     * @type {string}
     * @memberof TLessonTeacher
     */
    connection_id: string;
}
/**
 * 
 * @export
 * @interface TPaymentCompany
 */
export interface TPaymentCompany {
    /**
     * 
     * @type {MCompany}
     * @memberof TPaymentCompany
     */
    m_company?: MCompany | null;
}
/**
 * 
 * @export
 * @interface TPushMsgLog
 */
export interface TPushMsgLog {
    /**
     * 
     * @type {number}
     * @memberof TPushMsgLog
     */
    push_msg_que_id: number;
    /**
     * 
     * @type {number}
     * @memberof TPushMsgLog
     */
    lesson_id: number;
    /**
     * 
     * @type {number}
     * @memberof TPushMsgLog
     */
    learner_id: number;
    /**
     * 
     * @type {string}
     * @memberof TPushMsgLog
     */
    create_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof TPushMsgLog
     */
    create_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof TPushMsgLog
     */
    update_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof TPushMsgLog
     */
    update_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof TPushMsgLog
     */
    endpoint?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TPushMsgLog
     */
    http_result: string;
    /**
     * 
     * @type {number}
     * @memberof TPushMsgLog
     */
    company_id: number;
}
/**
 * 
 * @export
 * @interface TPushMsgQue
 */
export interface TPushMsgQue {
    /**
     * 
     * @type {number}
     * @memberof TPushMsgQue
     */
    push_msg_que_id: number;
    /**
     * 
     * @type {string}
     * @memberof TPushMsgQue
     */
    create_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof TPushMsgQue
     */
    create_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof TPushMsgQue
     */
    update_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof TPushMsgQue
     */
    update_user_id: string;
    /**
     * 
     * @type {number}
     * @memberof TPushMsgQue
     */
    company_id: number;
    /**
     * 
     * @type {string}
     * @memberof TPushMsgQue
     */
    target_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TPushMsgQue
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof TPushMsgQue
     */
    dend_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof TPushMsgQue
     */
    dent_datetime?: string | null;
}
/**
 * 
 * @export
 * @interface TStudyRecordsStory
 */
export interface TStudyRecordsStory {
    /**
     * 
     * @type {MCompany}
     * @memberof TStudyRecordsStory
     */
    m_company?: MCompany | null;
    /**
     * 
     * @type {MLearner}
     * @memberof TStudyRecordsStory
     */
    m_learner?: MLearner | null;
    /**
     * 
     * @type {number}
     * @memberof TStudyRecordsStory
     */
    company_id: number;
    /**
     * 
     * @type {string}
     * @memberof TStudyRecordsStory
     */
    learner_id: string;
    /**
     * 
     * @type {string}
     * @memberof TStudyRecordsStory
     */
    chapter_id: string;
    /**
     * 
     * @type {string}
     * @memberof TStudyRecordsStory
     */
    year_month: string;
    /**
     * 
     * @type {string}
     * @memberof TStudyRecordsStory
     */
    create_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof TStudyRecordsStory
     */
    create_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof TStudyRecordsStory
     */
    update_datetime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TStudyRecordsStory
     */
    update_user_id: string;
    /**
     * 
     * @type {number}
     * @memberof TStudyRecordsStory
     */
    correct_count: number;
    /**
     * 
     * @type {number}
     * @memberof TStudyRecordsStory
     */
    total_count: number;
    /**
     * 
     * @type {string}
     * @memberof TStudyRecordsStory
     */
    start_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof TStudyRecordsStory
     */
    end_datetime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TStudyRecordsStory
     */
    quiz_attempt: number;
}
/**
 * 
 * @export
 * @interface TotalLessonsVsParticipatedLessons
 */
export interface TotalLessonsVsParticipatedLessons {
    /**
     * 
     * @type {number}
     * @memberof TotalLessonsVsParticipatedLessons
     */
    totalLessons: number;
    /**
     * 
     * @type {number}
     * @memberof TotalLessonsVsParticipatedLessons
     */
    participatedLessons: number;
}
/**
 * 
 * @export
 * @interface UpdateAffiliationNodeDto
 */
export interface UpdateAffiliationNodeDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateAffiliationNodeDto
     */
    type_id?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAffiliationNodeDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAffiliationNodeDto
     */
    sort_order?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAffiliationNodeDto
     */
    academic_year?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAffiliationNodeDto
     */
    valid_from?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAffiliationNodeDto
     */
    valid_to?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAffiliationNodeDto
     */
    successor_id?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateAffiliationTypeDto
 */
export interface UpdateAffiliationTypeDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateAffiliationTypeDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAffiliationTypeDto
     */
    sort_order?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAffiliationTypeDto
     */
    is_year_bound?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateAgreementInput
 */
export interface UpdateAgreementInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateAgreementInput
     */
    plan_name: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAgreementInput
     */
    company_id: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAgreementInput
     */
    payment_id: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgreementInput
     */
    target_month?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAgreementInput
     */
    period_month: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAgreementInput
     */
    account_count: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAgreementInput
     */
    lesson_count: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAgreementInput
     */
    billed_amount: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAgreementInput
     */
    tax: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAgreementInput
     */
    discount: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgreementInput
     */
    update_datetime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgreementInput
     */
    update_user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgreementInput
     */
    fee_code: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAgreementInput
     */
    normal_edit: boolean;
}
/**
 * 
 * @export
 * @interface UpdateCompanyInput
 */
export interface UpdateCompanyInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyInput
     */
    company_name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyInput
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyInput
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyInput
     */
    representative?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyInput
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyInput
     */
    update_datetime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyInput
     */
    update_user_id?: string;
}
/**
 * 
 * @export
 * @interface UpdateDrillResult
 */
export interface UpdateDrillResult {
    /**
     * 
     * @type {number}
     * @memberof UpdateDrillResult
     */
    drill_id: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDrillResult
     */
    correct_count: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDrillResult
     */
    total_count: number;
}
/**
 * 
 * @export
 * @interface UpdateLearnerConnectionIdResponse
 */
export interface UpdateLearnerConnectionIdResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdateLearnerConnectionIdResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof UpdateLearnerConnectionIdResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateLearnerConnectionIdResponse
     */
    data?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateLearnerEmailResponse
 */
export interface UpdateLearnerEmailResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdateLearnerEmailResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof UpdateLearnerEmailResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {Array<ResponseData>}
     * @memberof UpdateLearnerEmailResponse
     */
    data?: Array<ResponseData>;
}
/**
 * 
 * @export
 * @interface UpdateLearnerEmailSendFlgResponse
 */
export interface UpdateLearnerEmailSendFlgResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdateLearnerEmailSendFlgResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof UpdateLearnerEmailSendFlgResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateLearnerEmailSendFlgResponse
     */
    data?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateLearnerInput
 */
export interface UpdateLearnerInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateLearnerInput
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLearnerInput
     */
    full_name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLearnerInput
     */
    nick_name: string;
}
/**
 * 
 * @export
 * @interface UpdateLessonLearnerInput
 */
export interface UpdateLessonLearnerInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateLessonLearnerInput
     */
    cancelStatus: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLessonLearnerInput
     */
    participationStatus: string;
}
/**
 * 
 * @export
 * @interface UpdateLessonNoteInput
 */
export interface UpdateLessonNoteInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateLessonNoteInput
     */
    note: string;
}
/**
 * 
 * @export
 * @interface UpdateStudyResult
 */
export interface UpdateStudyResult {
    /**
     * 
     * @type {string}
     * @memberof UpdateStudyResult
     */
    chapter_id: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateStudyResult
     */
    correct_count: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateStudyResult
     */
    total_count: number;
}
/**
 * 
 * @export
 * @interface UpdateTeacherInput
 */
export interface UpdateTeacherInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherInput
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherInput
     */
    full_name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherInput
     */
    nick_name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherInput
     */
    update_datetime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeacherInput
     */
    update_user_id?: string;
}
/**
 * 
 * @export
 * @interface UpsertLearnerEndPointResponse
 */
export interface UpsertLearnerEndPointResponse {
    /**
     * 
     * @type {number}
     * @memberof UpsertLearnerEndPointResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof UpsertLearnerEndPointResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertLearnerEndPointResponse
     */
    data?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpsertPushMsgLogResponse
 */
export interface UpsertPushMsgLogResponse {
    /**
     * 
     * @type {number}
     * @memberof UpsertPushMsgLogResponse
     */
    code: number;
    /**
     * 
     * @type {object}
     * @memberof UpsertPushMsgLogResponse
     */
    message: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertPushMsgLogResponse
     */
    data?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpsertPushMsgResponse
 */
export interface UpsertPushMsgResponse {
    /**
     * 
     * @type {number}
     * @memberof UpsertPushMsgResponse
     */
    code: number;
    /**
     * 
     * @type {object}
     * @memberof UpsertPushMsgResponse
     */
    message: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertPushMsgResponse
     */
    data?: Array<string>;
}
/**
 * 
 * @export
 * @interface VerifyCognitoUserEmailResponse
 */
export interface VerifyCognitoUserEmailResponse {
    /**
     * 
     * @type {number}
     * @memberof VerifyCognitoUserEmailResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof VerifyCognitoUserEmailResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {Array<string>}
     * @memberof VerifyCognitoUserEmailResponse
     */
    data?: Array<string>;
}
/**
 * 
 * @export
 * @interface VerifyInfo
 */
export interface VerifyInfo {
    /**
     * 
     * @type {string}
     * @memberof VerifyInfo
     */
    verifyCode: string;
    /**
     * 
     * @type {string}
     * @memberof VerifyInfo
     */
    accessToken: string;
}
/**
 * 
 * @export
 * @interface VerifyLearnerEmailResponse
 */
export interface VerifyLearnerEmailResponse {
    /**
     * 
     * @type {number}
     * @memberof VerifyLearnerEmailResponse
     */
    code: number;
    /**
     * 
     * @type {MESSAGE}
     * @memberof VerifyLearnerEmailResponse
     */
    message: MESSAGE;
    /**
     * 
     * @type {Array<string>}
     * @memberof VerifyLearnerEmailResponse
     */
    data?: Array<string>;
}

/**
 * APIApi - axios parameter creator
 * @export
 */
export const APIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} companyId 
         * @param {ApplyAffiliationTypeTemplateDto} applyAffiliationTypeTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerApplyTypeTemplate: async (companyId: string, applyAffiliationTypeTemplateDto: ApplyAffiliationTypeTemplateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('affiliationsControllerApplyTypeTemplate', 'companyId', companyId)
            // verify required parameter 'applyAffiliationTypeTemplateDto' is not null or undefined
            assertParamExists('affiliationsControllerApplyTypeTemplate', 'applyAffiliationTypeTemplateDto', applyAffiliationTypeTemplateDto)
            const localVarPath = `/api/affiliations/{companyId}/types/template`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyAffiliationTypeTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {AssignAffiliationDto} assignAffiliationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerAssign: async (companyId: string, assignAffiliationDto: AssignAffiliationDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('affiliationsControllerAssign', 'companyId', companyId)
            // verify required parameter 'assignAffiliationDto' is not null or undefined
            assertParamExists('affiliationsControllerAssign', 'assignAffiliationDto', assignAffiliationDto)
            const localVarPath = `/api/affiliations/{companyId}/assignments`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignAffiliationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} assignmentId 
         * @param {ChangeAffiliationRoleDto} changeAffiliationRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerChangeAssignmentRole: async (companyId: string, assignmentId: number, changeAffiliationRoleDto: ChangeAffiliationRoleDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('affiliationsControllerChangeAssignmentRole', 'companyId', companyId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('affiliationsControllerChangeAssignmentRole', 'assignmentId', assignmentId)
            // verify required parameter 'changeAffiliationRoleDto' is not null or undefined
            assertParamExists('affiliationsControllerChangeAssignmentRole', 'changeAffiliationRoleDto', changeAffiliationRoleDto)
            const localVarPath = `/api/affiliations/{companyId}/assignments/{assignmentId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeAffiliationRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CreateAffiliationNodeDto} createAffiliationNodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerCreateNode: async (companyId: string, createAffiliationNodeDto: CreateAffiliationNodeDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('affiliationsControllerCreateNode', 'companyId', companyId)
            // verify required parameter 'createAffiliationNodeDto' is not null or undefined
            assertParamExists('affiliationsControllerCreateNode', 'createAffiliationNodeDto', createAffiliationNodeDto)
            const localVarPath = `/api/affiliations/{companyId}/nodes`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAffiliationNodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CreateAffiliationTypeDto} createAffiliationTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerCreateType: async (companyId: string, createAffiliationTypeDto: CreateAffiliationTypeDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('affiliationsControllerCreateType', 'companyId', companyId)
            // verify required parameter 'createAffiliationTypeDto' is not null or undefined
            assertParamExists('affiliationsControllerCreateType', 'createAffiliationTypeDto', createAffiliationTypeDto)
            const localVarPath = `/api/affiliations/{companyId}/types`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAffiliationTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} affiliationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerDeleteNode: async (companyId: string, affiliationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('affiliationsControllerDeleteNode', 'companyId', companyId)
            // verify required parameter 'affiliationId' is not null or undefined
            assertParamExists('affiliationsControllerDeleteNode', 'affiliationId', affiliationId)
            const localVarPath = `/api/affiliations/{companyId}/nodes/{affiliationId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"affiliationId"}}`, encodeURIComponent(String(affiliationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} typeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerDeleteType: async (companyId: string, typeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('affiliationsControllerDeleteType', 'companyId', companyId)
            // verify required parameter 'typeId' is not null or undefined
            assertParamExists('affiliationsControllerDeleteType', 'typeId', typeId)
            const localVarPath = `/api/affiliations/{companyId}/types/{typeId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"typeId"}}`, encodeURIComponent(String(typeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerGetMyAffiliations: async (companyId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('affiliationsControllerGetMyAffiliations', 'companyId', companyId)
            const localVarPath = `/api/affiliations/{companyId}/me`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerGetTree: async (companyId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('affiliationsControllerGetTree', 'companyId', companyId)
            const localVarPath = `/api/affiliations/{companyId}/tree`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} dryRun 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerImportLearnerAffiliations: async (companyId: string, dryRun: string, file: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('affiliationsControllerImportLearnerAffiliations', 'companyId', companyId)
            // verify required parameter 'dryRun' is not null or undefined
            assertParamExists('affiliationsControllerImportLearnerAffiliations', 'dryRun', dryRun)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('affiliationsControllerImportLearnerAffiliations', 'file', file)
            const localVarPath = `/api/affiliations/{companyId}/import/learners`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dryRun !== undefined) {
                localVarQueryParameter['dry_run'] = dryRun;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {'LEARNER' | 'COMPANY_USER'} [userType] 
         * @param {string} [userId] 
         * @param {number} [affiliationId] 
         * @param {boolean} [includeDescendants] affiliation_id 指定時、配下の所属も含める
         * @param {string} [searchStr] 氏名・ニックネーム・メールアドレスの部分一致
         * @param {number} [limit] 1ページの件数(既定 50、最大 1000)
         * @param {number} [page] ページ番号(1始まり)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerListAssignments: async (companyId: string, userType?: 'LEARNER' | 'COMPANY_USER', userId?: string, affiliationId?: number, includeDescendants?: boolean, searchStr?: string, limit?: number, page?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('affiliationsControllerListAssignments', 'companyId', companyId)
            const localVarPath = `/api/affiliations/{companyId}/assignments`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (affiliationId !== undefined) {
                localVarQueryParameter['affiliation_id'] = affiliationId;
            }

            if (includeDescendants !== undefined) {
                localVarQueryParameter['include_descendants'] = includeDescendants;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['search_str'] = searchStr;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerUnassign: async (companyId: string, assignmentId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('affiliationsControllerUnassign', 'companyId', companyId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('affiliationsControllerUnassign', 'assignmentId', assignmentId)
            const localVarPath = `/api/affiliations/{companyId}/assignments/{assignmentId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} affiliationId 
         * @param {UpdateAffiliationNodeDto} updateAffiliationNodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerUpdateNode: async (companyId: string, affiliationId: number, updateAffiliationNodeDto: UpdateAffiliationNodeDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('affiliationsControllerUpdateNode', 'companyId', companyId)
            // verify required parameter 'affiliationId' is not null or undefined
            assertParamExists('affiliationsControllerUpdateNode', 'affiliationId', affiliationId)
            // verify required parameter 'updateAffiliationNodeDto' is not null or undefined
            assertParamExists('affiliationsControllerUpdateNode', 'updateAffiliationNodeDto', updateAffiliationNodeDto)
            const localVarPath = `/api/affiliations/{companyId}/nodes/{affiliationId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"affiliationId"}}`, encodeURIComponent(String(affiliationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAffiliationNodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} typeId 
         * @param {UpdateAffiliationTypeDto} updateAffiliationTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerUpdateType: async (companyId: string, typeId: number, updateAffiliationTypeDto: UpdateAffiliationTypeDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('affiliationsControllerUpdateType', 'companyId', companyId)
            // verify required parameter 'typeId' is not null or undefined
            assertParamExists('affiliationsControllerUpdateType', 'typeId', typeId)
            // verify required parameter 'updateAffiliationTypeDto' is not null or undefined
            assertParamExists('affiliationsControllerUpdateType', 'updateAffiliationTypeDto', updateAffiliationTypeDto)
            const localVarPath = `/api/affiliations/{companyId}/types/{typeId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"typeId"}}`, encodeURIComponent(String(typeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAffiliationTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForgotCompanyPasswordInput} forgotCompanyPasswordInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyAuthControllerForgotCompanyPassword: async (forgotCompanyPasswordInput: ForgotCompanyPasswordInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'forgotCompanyPasswordInput' is not null or undefined
            assertParamExists('companyAuthControllerForgotCompanyPassword', 'forgotCompanyPasswordInput', forgotCompanyPasswordInput)
            const localVarPath = `/api/company-auth/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forgotCompanyPasswordInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerGetLearners: async (companyId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('dashboardControllerGetLearners', 'companyId', companyId)
            const localVarPath = `/api/dashboard/{companyId}/learners`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerGetMe: async (companyId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('dashboardControllerGetMe', 'companyId', companyId)
            const localVarPath = `/api/dashboard/{companyId}/me`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateForBeginnersInquiryInput} createForBeginnersInquiryInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inquiryControllerSendForBeginnersInquiryEmail: async (createForBeginnersInquiryInput: CreateForBeginnersInquiryInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createForBeginnersInquiryInput' is not null or undefined
            assertParamExists('inquiryControllerSendForBeginnersInquiryEmail', 'createForBeginnersInquiryInput', createForBeginnersInquiryInput)
            const localVarPath = `/api/inquiry/for-beginners/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createForBeginnersInquiryInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateInquiryInput} createInquiryInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inquiryControllerSendInquiryEmail: async (createInquiryInput: CreateInquiryInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createInquiryInput' is not null or undefined
            assertParamExists('inquiryControllerSendInquiryEmail', 'createInquiryInput', createInquiryInput)
            const localVarPath = `/api/inquiry/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInquiryInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForgotLearnerPasswordInput} forgotLearnerPasswordInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learnerAuthControllerForgotLearnerPassword: async (forgotLearnerPasswordInput: ForgotLearnerPasswordInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'forgotLearnerPasswordInput' is not null or undefined
            assertParamExists('learnerAuthControllerForgotLearnerPassword', 'forgotLearnerPasswordInput', forgotLearnerPasswordInput)
            const localVarPath = `/api/learner-auth/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forgotLearnerPasswordInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learnerControllerCompleteCheckTest: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/learners/check-test/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learnerControllerGetCheckTestStatus: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/learners/check-test/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} learnerId 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learnerControllerGetLearnerStudyTimeInfo: async (learnerId: string, companyId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('learnerControllerGetLearnerStudyTimeInfo', 'learnerId', learnerId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('learnerControllerGetLearnerStudyTimeInfo', 'companyId', companyId)
            const localVarPath = `/api/learners/get-study-time-info/{learnerId}/companyId/{companyId}`
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} learnerId 
         * @param {number} companyId 
         * @param {number} [paymentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learnerControllerGetLearnerTotalLessonsVsParticipatedLessons: async (learnerId: string, companyId: number, paymentId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('learnerControllerGetLearnerTotalLessonsVsParticipatedLessons', 'learnerId', learnerId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('learnerControllerGetLearnerTotalLessonsVsParticipatedLessons', 'companyId', companyId)
            const localVarPath = `/api/learners/get-lesson-participation-info/{learnerId}/company/{companyId}`
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (paymentId !== undefined) {
                localVarQueryParameter['paymentId'] = paymentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learnerControllerIsHighestStageCompleted: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/learners/highest-stage/completed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lessonControllerGetDownloadUrl: async (fileUrl: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileUrl' is not null or undefined
            assertParamExists('lessonControllerGetDownloadUrl', 'fileUrl', fileUrl)
            const localVarPath = `/api/lesson/file/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileUrl !== undefined) {
                localVarQueryParameter['fileUrl'] = fileUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} lessonId 
         * @param {string} roomId 
         * @param {number} timestamp 
         * @param {string} mimeType 
         * @param {string} targetUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lessonControllerGetUploadUrlOfRecordedFile: async (lessonId: string, roomId: string, timestamp: number, mimeType: string, targetUserId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('lessonControllerGetUploadUrlOfRecordedFile', 'lessonId', lessonId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('lessonControllerGetUploadUrlOfRecordedFile', 'roomId', roomId)
            // verify required parameter 'timestamp' is not null or undefined
            assertParamExists('lessonControllerGetUploadUrlOfRecordedFile', 'timestamp', timestamp)
            // verify required parameter 'mimeType' is not null or undefined
            assertParamExists('lessonControllerGetUploadUrlOfRecordedFile', 'mimeType', mimeType)
            // verify required parameter 'targetUserId' is not null or undefined
            assertParamExists('lessonControllerGetUploadUrlOfRecordedFile', 'targetUserId', targetUserId)
            const localVarPath = `/api/lesson/record/upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (lessonId !== undefined) {
                localVarQueryParameter['lesson-id'] = lessonId;
            }

            if (roomId !== undefined) {
                localVarQueryParameter['room-id'] = roomId;
            }

            if (timestamp !== undefined) {
                localVarQueryParameter['timestamp'] = timestamp;
            }

            if (mimeType !== undefined) {
                localVarQueryParameter['mimeType'] = mimeType;
            }

            if (targetUserId !== undefined) {
                localVarQueryParameter['target-user-id'] = targetUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerCreateActiveLearnerLog: async (learnerId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('mobileAppControllerCreateActiveLearnerLog', 'learnerId', learnerId)
            const localVarPath = `/api/appService/active/learner/{learnerId}`
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} lessonId 
         * @param {string} companyId 
         * @param {string} userId 
         * @param {LessonLogType} lessonLogType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerCreateLessonLog: async (lessonId: string, companyId: string, userId: string, lessonLogType: LessonLogType, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('mobileAppControllerCreateLessonLog', 'lessonId', lessonId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileAppControllerCreateLessonLog', 'companyId', companyId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('mobileAppControllerCreateLessonLog', 'userId', userId)
            // verify required parameter 'lessonLogType' is not null or undefined
            assertParamExists('mobileAppControllerCreateLessonLog', 'lessonLogType', lessonLogType)
            const localVarPath = `/api/appService/lesson/{lessonId}/log/{companyId}/{userId}`
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lessonLogType, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerDeactivateLearnerEndpoints: async (companyId: string, learnerId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileAppControllerDeactivateLearnerEndpoints', 'companyId', companyId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('mobileAppControllerDeactivateLearnerEndpoints', 'learnerId', learnerId)
            const localVarPath = `/api/appService/{companyId}/DeactivateLearnerEndpoints/{learnerId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} learnerId 
         * @param {boolean} onlyFuture 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetApprovedLessons: async (learnerId: string, onlyFuture: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('mobileAppControllerGetApprovedLessons', 'learnerId', learnerId)
            // verify required parameter 'onlyFuture' is not null or undefined
            assertParamExists('mobileAppControllerGetApprovedLessons', 'onlyFuture', onlyFuture)
            const localVarPath = `/api/appService/lessons/{learnerId}/approved`
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (onlyFuture !== undefined) {
                localVarQueryParameter['onlyFuture'] = onlyFuture;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetLearnerActiveEndpointCount: async (companyId: string, learnerId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileAppControllerGetLearnerActiveEndpointCount', 'companyId', companyId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('mobileAppControllerGetLearnerActiveEndpointCount', 'learnerId', learnerId)
            const localVarPath = `/api/appService/{companyId}/learnerActiveEndpointCount/{learnerId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetLearnerByEmail: async (companyId: string, email: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileAppControllerGetLearnerByEmail', 'companyId', companyId)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('mobileAppControllerGetLearnerByEmail', 'email', email)
            const localVarPath = `/api/appService/{companyId}/getUserName/{email}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetLearnerEndpoint: async (companyId: string, learnerId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileAppControllerGetLearnerEndpoint', 'companyId', companyId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('mobileAppControllerGetLearnerEndpoint', 'learnerId', learnerId)
            const localVarPath = `/api/appService/{companyId}/learnerEndpoint/{learnerId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetLernerById: async (companyId: string, learnerId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileAppControllerGetLernerById', 'companyId', companyId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('mobileAppControllerGetLernerById', 'learnerId', learnerId)
            const localVarPath = `/api/appService/{companyId}/learner/{learnerId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetLoginedLearnerDetail: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/appService/learner/detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetMostRecentScheduledLesson: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/appService/most-recent-scheduled-lesson`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} noticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetNoticeRead: async (noticeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'noticeId' is not null or undefined
            assertParamExists('mobileAppControllerGetNoticeRead', 'noticeId', noticeId)
            const localVarPath = `/api/appService/noticeRead/{noticeId}`
                .replace(`{${"noticeId"}}`, encodeURIComponent(String(noticeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetNoticeUnreadCount: async (userName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userName' is not null or undefined
            assertParamExists('mobileAppControllerGetNoticeUnreadCount', 'userName', userName)
            const localVarPath = `/api/appService/noticeUnreadCount/{userName}`
                .replace(`{${"userName"}}`, encodeURIComponent(String(userName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetNotices: async (limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('mobileAppControllerGetNotices', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('mobileAppControllerGetNotices', 'page', page)
            const localVarPath = `/api/appService/notices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetPastLessons: async (limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('mobileAppControllerGetPastLessons', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('mobileAppControllerGetPastLessons', 'page', page)
            const localVarPath = `/api/appService/lessons/past`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetPushMsg: async (companyId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileAppControllerGetPushMsg', 'companyId', companyId)
            const localVarPath = `/api/appService/{companyId}/pushmsg`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} pushMsgQId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetPushMsgLog: async (companyId: string, pushMsgQId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileAppControllerGetPushMsgLog', 'companyId', companyId)
            // verify required parameter 'pushMsgQId' is not null or undefined
            assertParamExists('mobileAppControllerGetPushMsgLog', 'pushMsgQId', pushMsgQId)
            const localVarPath = `/api/appService/{companyId}/pushmsglog/{pushMsgQId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"pushMsgQId"}}`, encodeURIComponent(String(pushMsgQId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetPushVapidPublicKey: async (companyId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileAppControllerGetPushVapidPublicKey', 'companyId', companyId)
            const localVarPath = `/api/appService/{companyId}/pushVapidPublicKey`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetStudyRecords: async (userName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userName' is not null or undefined
            assertParamExists('mobileAppControllerGetStudyRecords', 'userName', userName)
            const localVarPath = `/api/appService/studyRecords/{userName}`
                .replace(`{${"userName"}}`, encodeURIComponent(String(userName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DrillParam} drillParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerPostStudyRecordDrill: async (drillParam: DrillParam, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'drillParam' is not null or undefined
            assertParamExists('mobileAppControllerPostStudyRecordDrill', 'drillParam', drillParam)
            const localVarPath = `/api/appService/studyRecordDrill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(drillParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StudyResult} studyResult 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerPostStudyRecordStory: async (studyResult: StudyResult, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'studyResult' is not null or undefined
            assertParamExists('mobileAppControllerPostStudyRecordStory', 'studyResult', studyResult)
            const localVarPath = `/api/appService/studyRecordStory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(studyResult, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateDrillResult} updateDrillResult 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerPutDrillRecord: async (updateDrillResult: UpdateDrillResult, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateDrillResult' is not null or undefined
            assertParamExists('mobileAppControllerPutDrillRecord', 'updateDrillResult', updateDrillResult)
            const localVarPath = `/api/appService/studyRecordDrill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDrillResult, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} noticeId 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerPutNoticeRead: async (companyId: string, noticeId: number, userName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileAppControllerPutNoticeRead', 'companyId', companyId)
            // verify required parameter 'noticeId' is not null or undefined
            assertParamExists('mobileAppControllerPutNoticeRead', 'noticeId', noticeId)
            // verify required parameter 'userName' is not null or undefined
            assertParamExists('mobileAppControllerPutNoticeRead', 'userName', userName)
            const localVarPath = `/api/appService/{companyId}/noticeRead/{noticeId}/{userName}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"noticeId"}}`, encodeURIComponent(String(noticeId)))
                .replace(`{${"userName"}}`, encodeURIComponent(String(userName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateStudyResult} updateStudyResult 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerPutStudyRecord: async (updateStudyResult: UpdateStudyResult, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateStudyResult' is not null or undefined
            assertParamExists('mobileAppControllerPutStudyRecord', 'updateStudyResult', updateStudyResult)
            const localVarPath = `/api/appService/studyRecordStory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStudyResult, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RecordStudySessionInput} recordStudySessionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerRecordStudySession: async (recordStudySessionInput: RecordStudySessionInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordStudySessionInput' is not null or undefined
            assertParamExists('mobileAppControllerRecordStudySession', 'recordStudySessionInput', recordStudySessionInput)
            const localVarPath = `/api/appService/study-session/record`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordStudySessionInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartStudySessionInput} startStudySessionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerStartStudySession: async (startStudySessionInput: StartStudySessionInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'startStudySessionInput' is not null or undefined
            assertParamExists('mobileAppControllerStartStudySession', 'startStudySessionInput', startStudySessionInput)
            const localVarPath = `/api/appService/study-session/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startStudySessionInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {ConnectionId} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerUpdateLearnerConnectionId: async (companyId: string, learnerId: string, connectionId: ConnectionId, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileAppControllerUpdateLearnerConnectionId', 'companyId', companyId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('mobileAppControllerUpdateLearnerConnectionId', 'learnerId', learnerId)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('mobileAppControllerUpdateLearnerConnectionId', 'connectionId', connectionId)
            const localVarPath = `/api/appService/{companyId}/{learnerId}/connectionId`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectionId, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerUpdateLearnerEmail: async (companyId: string, learnerId: string, email: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileAppControllerUpdateLearnerEmail', 'companyId', companyId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('mobileAppControllerUpdateLearnerEmail', 'learnerId', learnerId)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('mobileAppControllerUpdateLearnerEmail', 'email', email)
            const localVarPath = `/api/appService/{companyId}/{learnerId}/changeEmail/{email}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)))
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {string} emailSendFlg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerUpdateLearnerEmailSendFlg: async (companyId: string, learnerId: string, emailSendFlg: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileAppControllerUpdateLearnerEmailSendFlg', 'companyId', companyId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('mobileAppControllerUpdateLearnerEmailSendFlg', 'learnerId', learnerId)
            // verify required parameter 'emailSendFlg' is not null or undefined
            assertParamExists('mobileAppControllerUpdateLearnerEmailSendFlg', 'emailSendFlg', emailSendFlg)
            const localVarPath = `/api/appService/{companyId}/{learnerId}/changeEmailSendFlg/{emailSendFlg}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)))
                .replace(`{${"emailSendFlg"}}`, encodeURIComponent(String(emailSendFlg)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {LearnerEndpoint} learnerEndpoint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerUpsertLearnerEndpoint: async (companyId: string, learnerId: string, learnerEndpoint: LearnerEndpoint, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileAppControllerUpsertLearnerEndpoint', 'companyId', companyId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('mobileAppControllerUpsertLearnerEndpoint', 'learnerId', learnerId)
            // verify required parameter 'learnerEndpoint' is not null or undefined
            assertParamExists('mobileAppControllerUpsertLearnerEndpoint', 'learnerEndpoint', learnerEndpoint)
            const localVarPath = `/api/appService/{companyId}/LearnerEndpoint/{learnerId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(learnerEndpoint, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {PushMsg} pushMsg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerUpsertPushMsg: async (companyId: string, pushMsg: PushMsg, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileAppControllerUpsertPushMsg', 'companyId', companyId)
            // verify required parameter 'pushMsg' is not null or undefined
            assertParamExists('mobileAppControllerUpsertPushMsg', 'pushMsg', pushMsg)
            const localVarPath = `/api/appService/{companyId}/pushmsg`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pushMsg, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {PushMsgLog} pushMsgLog 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerUpsertPushMsgLog: async (companyId: string, pushMsgLog: PushMsgLog, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileAppControllerUpsertPushMsgLog', 'companyId', companyId)
            // verify required parameter 'pushMsgLog' is not null or undefined
            assertParamExists('mobileAppControllerUpsertPushMsgLog', 'pushMsgLog', pushMsgLog)
            const localVarPath = `/api/appService/{companyId}/pushmsglog`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pushMsgLog, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerVerifyCognitoUserEmail: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/appService/verifyEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {string} email 
         * @param {VerifyInfo} verifyInfo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerVerifyLearnerEmail: async (companyId: string, learnerId: string, email: string, verifyInfo: VerifyInfo, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('mobileAppControllerVerifyLearnerEmail', 'companyId', companyId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('mobileAppControllerVerifyLearnerEmail', 'learnerId', learnerId)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('mobileAppControllerVerifyLearnerEmail', 'email', email)
            // verify required parameter 'verifyInfo' is not null or undefined
            assertParamExists('mobileAppControllerVerifyLearnerEmail', 'verifyInfo', verifyInfo)
            const localVarPath = `/api/appService/{companyId}/{learnerId}/verifyEmail/{email}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)))
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerApprovalLessonTeacher: async (companyId: string, lessonId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerApprovalLessonTeacher', 'companyId', companyId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerApprovalLessonTeacher', 'lessonId', lessonId)
            const localVarPath = `/api/organizations/update/{companyId}/agreementLesson/{lessonId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {CancelLessonInput} cancelLessonInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCancelLesson: async (companyId: string, lessonId: string, cancelLessonInput: CancelLessonInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerCancelLesson', 'companyId', companyId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerCancelLesson', 'lessonId', lessonId)
            // verify required parameter 'cancelLessonInput' is not null or undefined
            assertParamExists('organizationsControllerCancelLesson', 'cancelLessonInput', cancelLessonInput)
            const localVarPath = `/api/organizations/delete/{companyId}/lesson/{lessonId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelLessonInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} teacherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerChangeLessonTeacher: async (companyId: string, lessonId: string, teacherId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerChangeLessonTeacher', 'companyId', companyId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerChangeLessonTeacher', 'lessonId', lessonId)
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerChangeLessonTeacher', 'teacherId', teacherId)
            const localVarPath = `/api/organizations/update/{companyId}/changeLessonTeacher/{lessonId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (teacherId !== undefined) {
                localVarQueryParameter['teacherId'] = teacherId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateActiveCompanyUserLog: async (userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('organizationsControllerCreateActiveCompanyUserLog', 'userId', userId)
            const localVarPath = `/api/organizations/active/companyUser/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CreateAgreementInput} createAgreementInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateAgreement: async (companyId: string, createAgreementInput: CreateAgreementInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerCreateAgreement', 'companyId', companyId)
            // verify required parameter 'createAgreementInput' is not null or undefined
            assertParamExists('organizationsControllerCreateAgreement', 'createAgreementInput', createAgreementInput)
            const localVarPath = `/api/organizations/create/{companyId}/paymentList`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAgreementInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CreateCompanyInput} createCompanyInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateCompany: async (companyId: string, createCompanyInput: CreateCompanyInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerCreateCompany', 'companyId', companyId)
            // verify required parameter 'createCompanyInput' is not null or undefined
            assertParamExists('organizationsControllerCreateCompany', 'createCompanyInput', createCompanyInput)
            const localVarPath = `/api/organizations/create/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CreateCompanyUserInput} createCompanyUserInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateCompanyUser: async (companyId: string, createCompanyUserInput: CreateCompanyUserInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerCreateCompanyUser', 'companyId', companyId)
            // verify required parameter 'createCompanyUserInput' is not null or undefined
            assertParamExists('organizationsControllerCreateCompanyUser', 'createCompanyUserInput', createCompanyUserInput)
            const localVarPath = `/api/organizations/create/companyUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyUserInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateErrorLog} createErrorLog 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateErrorLog: async (createErrorLog: CreateErrorLog, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createErrorLog' is not null or undefined
            assertParamExists('organizationsControllerCreateErrorLog', 'createErrorLog', createErrorLog)
            const localVarPath = `/api/organizations/create/log/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createErrorLog, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {CreateLearnerInput} createLearnerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateLearnerUser: async (companyId: string, paymentId: number, createLearnerInput: CreateLearnerInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerCreateLearnerUser', 'companyId', companyId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('organizationsControllerCreateLearnerUser', 'paymentId', paymentId)
            // verify required parameter 'createLearnerInput' is not null or undefined
            assertParamExists('organizationsControllerCreateLearnerUser', 'createLearnerInput', createLearnerInput)
            const localVarPath = `/api/organizations/create/learner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (paymentId !== undefined) {
                localVarQueryParameter['paymentId'] = paymentId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLearnerInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} startDatetime 
         * @param {string} endDatetime 
         * @param {CreateLessonInput} createLessonInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateLesson: async (companyId: string, teacherId: string, startDatetime: string, endDatetime: string, createLessonInput: CreateLessonInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerCreateLesson', 'companyId', companyId)
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerCreateLesson', 'teacherId', teacherId)
            // verify required parameter 'startDatetime' is not null or undefined
            assertParamExists('organizationsControllerCreateLesson', 'startDatetime', startDatetime)
            // verify required parameter 'endDatetime' is not null or undefined
            assertParamExists('organizationsControllerCreateLesson', 'endDatetime', endDatetime)
            // verify required parameter 'createLessonInput' is not null or undefined
            assertParamExists('organizationsControllerCreateLesson', 'createLessonInput', createLessonInput)
            const localVarPath = `/api/organizations/create/{companyId}/lesson`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (teacherId !== undefined) {
                localVarQueryParameter['teacherId'] = teacherId;
            }

            if (startDatetime !== undefined) {
                localVarQueryParameter['start_datetime'] = (startDatetime as any instanceof Date) ?
                    (startDatetime as any).toISOString() :
                    startDatetime;
            }

            if (endDatetime !== undefined) {
                localVarQueryParameter['end_datetime'] = (endDatetime as any instanceof Date) ?
                    (endDatetime as any).toISOString() :
                    endDatetime;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLessonInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {CreateLessonFeeInput} createLessonFeeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateLessonFee: async (teacherId: string, createLessonFeeInput: CreateLessonFeeInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerCreateLessonFee', 'teacherId', teacherId)
            // verify required parameter 'createLessonFeeInput' is not null or undefined
            assertParamExists('organizationsControllerCreateLessonFee', 'createLessonFeeInput', createLessonFeeInput)
            const localVarPath = `/api/organizations/create/lessonFeeOption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (teacherId !== undefined) {
                localVarQueryParameter['teacherId'] = teacherId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLessonFeeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {CreateLessonFeeHistoryInput} createLessonFeeHistoryInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateLessonFeeHistory: async (teacherId: string, createLessonFeeHistoryInput: CreateLessonFeeHistoryInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerCreateLessonFeeHistory', 'teacherId', teacherId)
            // verify required parameter 'createLessonFeeHistoryInput' is not null or undefined
            assertParamExists('organizationsControllerCreateLessonFeeHistory', 'createLessonFeeHistoryInput', createLessonFeeHistoryInput)
            const localVarPath = `/api/organizations/create/lessonFeeHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (teacherId !== undefined) {
                localVarQueryParameter['teacherId'] = teacherId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLessonFeeHistoryInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateMaintenanceInput} createMaintenanceInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateMaintenance: async (createMaintenanceInput: CreateMaintenanceInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMaintenanceInput' is not null or undefined
            assertParamExists('organizationsControllerCreateMaintenance', 'createMaintenanceInput', createMaintenanceInput)
            const localVarPath = `/api/organizations/maintenance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMaintenanceInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dummy 
         * @param {CreateManagerInput} createManagerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateManagerUser: async (dummy: string, createManagerInput: CreateManagerInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dummy' is not null or undefined
            assertParamExists('organizationsControllerCreateManagerUser', 'dummy', dummy)
            // verify required parameter 'createManagerInput' is not null or undefined
            assertParamExists('organizationsControllerCreateManagerUser', 'createManagerInput', createManagerInput)
            const localVarPath = `/api/organizations/create/managerUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dummy !== undefined) {
                localVarQueryParameter['dummy'] = dummy;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManagerInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dummy 
         * @param {CreateNoticeInput} createNoticeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateNotice: async (dummy: string, createNoticeInput: CreateNoticeInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dummy' is not null or undefined
            assertParamExists('organizationsControllerCreateNotice', 'dummy', dummy)
            // verify required parameter 'createNoticeInput' is not null or undefined
            assertParamExists('organizationsControllerCreateNotice', 'createNoticeInput', createNoticeInput)
            const localVarPath = `/api/organizations/create/create/notice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dummy !== undefined) {
                localVarQueryParameter['dummy'] = dummy;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNoticeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateNoticeCompanyInput} createNoticeCompanyInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateNoticeCompany: async (createNoticeCompanyInput: CreateNoticeCompanyInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createNoticeCompanyInput' is not null or undefined
            assertParamExists('organizationsControllerCreateNoticeCompany', 'createNoticeCompanyInput', createNoticeCompanyInput)
            const localVarPath = `/api/organizations/notice/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNoticeCompanyInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {CreateTeacherInput} createTeacherInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateTeacherUser: async (teacherId: string, createTeacherInput: CreateTeacherInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerCreateTeacherUser', 'teacherId', teacherId)
            // verify required parameter 'createTeacherInput' is not null or undefined
            assertParamExists('organizationsControllerCreateTeacherUser', 'createTeacherInput', createTeacherInput)
            const localVarPath = `/api/organizations/create/teacher`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (teacherId !== undefined) {
                localVarQueryParameter['teacherId'] = teacherId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTeacherInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteAgreement: async (companyId: string, paymentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerDeleteAgreement', 'companyId', companyId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('organizationsControllerDeleteAgreement', 'paymentId', paymentId)
            const localVarPath = `/api/organizations/delete/{companyId}/paymentList`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (paymentId !== undefined) {
                localVarQueryParameter['paymentId'] = paymentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteCompany: async (companyId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerDeleteCompany', 'companyId', companyId)
            const localVarPath = `/api/organizations/delete/company/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteCompanyUser: async (companyId: string, userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerDeleteCompanyUser', 'companyId', companyId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('organizationsControllerDeleteCompanyUser', 'userId', userId)
            const localVarPath = `/api/organizations/delete/{companyId}/company/{userId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteLearnerUser: async (companyId: string, learnerId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerDeleteLearnerUser', 'companyId', companyId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerDeleteLearnerUser', 'learnerId', learnerId)
            const localVarPath = `/api/organizations/delete/{companyId}/learnerUser/{learnerId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteLessonFeeOption: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationsControllerDeleteLessonFeeOption', 'id', id)
            const localVarPath = `/api/organizations/delete/lessonFeeOption/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {DeleteLessonLearnerInput} deleteLessonLearnerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteLessonLearner: async (companyId: string, lessonId: string, deleteLessonLearnerInput: DeleteLessonLearnerInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerDeleteLessonLearner', 'companyId', companyId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerDeleteLessonLearner', 'lessonId', lessonId)
            // verify required parameter 'deleteLessonLearnerInput' is not null or undefined
            assertParamExists('organizationsControllerDeleteLessonLearner', 'deleteLessonLearnerInput', deleteLessonLearnerInput)
            const localVarPath = `/api/organizations/cancel-lesson/{companyId}/lesson/{lessonId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteLessonLearnerInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} maintenanceId 
         * @param {string} maintenanceStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteMaintenance: async (maintenanceId: number, maintenanceStatus: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'maintenanceId' is not null or undefined
            assertParamExists('organizationsControllerDeleteMaintenance', 'maintenanceId', maintenanceId)
            // verify required parameter 'maintenanceStatus' is not null or undefined
            assertParamExists('organizationsControllerDeleteMaintenance', 'maintenanceStatus', maintenanceStatus)
            const localVarPath = `/api/organizations/maintenance/{maintenance_id}`
                .replace(`{${"maintenance_id"}}`, encodeURIComponent(String(maintenanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (maintenanceStatus !== undefined) {
                localVarQueryParameter['maintenance_status'] = maintenanceStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} managerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteManagerUser: async (managerId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'managerId' is not null or undefined
            assertParamExists('organizationsControllerDeleteManagerUser', 'managerId', managerId)
            const localVarPath = `/api/organizations/delete/manager/{managerId}`
                .replace(`{${"managerId"}}`, encodeURIComponent(String(managerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {DeleteAgreementInput} deleteAgreementInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteMonthlyAgreement: async (companyId: string, deleteAgreementInput: DeleteAgreementInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerDeleteMonthlyAgreement', 'companyId', companyId)
            // verify required parameter 'deleteAgreementInput' is not null or undefined
            assertParamExists('organizationsControllerDeleteMonthlyAgreement', 'deleteAgreementInput', deleteAgreementInput)
            const localVarPath = `/api/organizations/deleteMonthlyAgreement/{companyId}/paymentList`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAgreementInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteNotice: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationsControllerDeleteNotice', 'id', id)
            const localVarPath = `/api/organizations/delete/noticeList/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteTeacherUser: async (teacherId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerDeleteTeacherUser', 'teacherId', teacherId)
            const localVarPath = `/api/organizations/delete/teacher/{teacherId}`
                .replace(`{${"teacherId"}}`, encodeURIComponent(String(teacherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExistsLearnerInput} existsLearnerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerExistsLearner: async (existsLearnerInput: ExistsLearnerInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'existsLearnerInput' is not null or undefined
            assertParamExists('organizationsControllerExistsLearner', 'existsLearnerInput', existsLearnerInput)
            const localVarPath = `/api/organizations/learners/exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(existsLearnerInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExistsLearnerInPlanInput} existsLearnerInPlanInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerExistsLearnerInPlan: async (existsLearnerInPlanInput: ExistsLearnerInPlanInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'existsLearnerInPlanInput' is not null or undefined
            assertParamExists('organizationsControllerExistsLearnerInPlan', 'existsLearnerInPlanInput', existsLearnerInPlanInput)
            const localVarPath = `/api/organizations/plan/learners/exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(existsLearnerInPlanInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetAvailableCompanies: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations/available-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetCompany: async (companyId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetCompany', 'companyId', companyId)
            const localVarPath = `/api/organizations/company/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} sortStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetCompanyList: async (companyId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, sortStr: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetCompanyList', 'companyId', companyId)
            // verify required parameter 'searchStatus' is not null or undefined
            assertParamExists('organizationsControllerGetCompanyList', 'searchStatus', searchStatus)
            // verify required parameter 'searchField' is not null or undefined
            assertParamExists('organizationsControllerGetCompanyList', 'searchField', searchField)
            // verify required parameter 'searchStr' is not null or undefined
            assertParamExists('organizationsControllerGetCompanyList', 'searchStr', searchStr)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('organizationsControllerGetCompanyList', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetCompanyList', 'page', page)
            // verify required parameter 'sortStr' is not null or undefined
            assertParamExists('organizationsControllerGetCompanyList', 'sortStr', sortStr)
            const localVarPath = `/api/organizations/get/companyList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (searchStatus !== undefined) {
                localVarQueryParameter['searchStatus'] = searchStatus;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['searchStr'] = searchStr;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortStr !== undefined) {
                localVarQueryParameter['sortStr'] = sortStr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetCompanyPlans: async (companyId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetCompanyPlans', 'companyId', companyId)
            const localVarPath = `/api/organizations/companies/{companyId}/plans`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetCompanyUserList: async (companyId: string, limit: number, page: number, searchStr: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetCompanyUserList', 'companyId', companyId)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('organizationsControllerGetCompanyUserList', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetCompanyUserList', 'page', page)
            // verify required parameter 'searchStr' is not null or undefined
            assertParamExists('organizationsControllerGetCompanyUserList', 'searchStr', searchStr)
            const localVarPath = `/api/organizations/get/companyUser/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['search_str'] = searchStr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetConnectionIdByRoomId: async (companyId: string, roomId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetConnectionIdByRoomId', 'companyId', companyId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('organizationsControllerGetConnectionIdByRoomId', 'roomId', roomId)
            const localVarPath = `/api/organizations/{companyId}/{roomId}/connectionId`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetEachLearnerStudyRecordsPdf: async (companyId: string, paymentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetEachLearnerStudyRecordsPdf', 'companyId', companyId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('organizationsControllerGetEachLearnerStudyRecordsPdf', 'paymentId', paymentId)
            const localVarPath = `/api/organizations/learnerStudyRecordsPDF/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (paymentId !== undefined) {
                localVarQueryParameter['paymentId'] = paymentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} teacherId 
         * @param {string} learnerId 
         * @param {string} lessonId 
         * @param {number} approvalFlg 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} futureOnly 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetFutureLessonList: async (companyId: string, paymentId: number, teacherId: string, learnerId: string, lessonId: string, approvalFlg: number, startPeriod: string, endPeriod: string, futureOnly: number, limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonList', 'companyId', companyId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonList', 'paymentId', paymentId)
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonList', 'teacherId', teacherId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonList', 'learnerId', learnerId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonList', 'lessonId', lessonId)
            // verify required parameter 'approvalFlg' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonList', 'approvalFlg', approvalFlg)
            // verify required parameter 'startPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonList', 'startPeriod', startPeriod)
            // verify required parameter 'endPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonList', 'endPeriod', endPeriod)
            // verify required parameter 'futureOnly' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonList', 'futureOnly', futureOnly)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonList', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonList', 'page', page)
            const localVarPath = `/api/organizations/get/futureLessonList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (paymentId !== undefined) {
                localVarQueryParameter['paymentId'] = paymentId;
            }

            if (teacherId !== undefined) {
                localVarQueryParameter['teacherId'] = teacherId;
            }

            if (learnerId !== undefined) {
                localVarQueryParameter['learnerId'] = learnerId;
            }

            if (lessonId !== undefined) {
                localVarQueryParameter['lessonId'] = lessonId;
            }

            if (approvalFlg !== undefined) {
                localVarQueryParameter['approvalFlg'] = approvalFlg;
            }

            if (startPeriod !== undefined) {
                localVarQueryParameter['startPeriod'] = startPeriod;
            }

            if (endPeriod !== undefined) {
                localVarQueryParameter['endPeriod'] = endPeriod;
            }

            if (futureOnly !== undefined) {
                localVarQueryParameter['futureOnly'] = futureOnly;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} learner 
         * @param {string} learnerId 
         * @param {string} company 
         * @param {string} searchStatus 
         * @param {string} lessonId 
         * @param {number} approvalFlg 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetFutureLessonListBgd: async (companyId: string, teacherId: string, learner: string, learnerId: string, company: string, searchStatus: string, lessonId: string, approvalFlg: number, startPeriod: string, endPeriod: string, limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonListBgd', 'companyId', companyId)
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonListBgd', 'teacherId', teacherId)
            // verify required parameter 'learner' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonListBgd', 'learner', learner)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonListBgd', 'learnerId', learnerId)
            // verify required parameter 'company' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonListBgd', 'company', company)
            // verify required parameter 'searchStatus' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonListBgd', 'searchStatus', searchStatus)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonListBgd', 'lessonId', lessonId)
            // verify required parameter 'approvalFlg' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonListBgd', 'approvalFlg', approvalFlg)
            // verify required parameter 'startPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonListBgd', 'startPeriod', startPeriod)
            // verify required parameter 'endPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonListBgd', 'endPeriod', endPeriod)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonListBgd', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetFutureLessonListBgd', 'page', page)
            const localVarPath = `/api/organizations/get/futureLessonList_bgd`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (teacherId !== undefined) {
                localVarQueryParameter['teacherId'] = teacherId;
            }

            if (learner !== undefined) {
                localVarQueryParameter['learner'] = learner;
            }

            if (learnerId !== undefined) {
                localVarQueryParameter['learnerId'] = learnerId;
            }

            if (company !== undefined) {
                localVarQueryParameter['company'] = company;
            }

            if (searchStatus !== undefined) {
                localVarQueryParameter['searchStatus'] = searchStatus;
            }

            if (lessonId !== undefined) {
                localVarQueryParameter['lessonId'] = lessonId;
            }

            if (approvalFlg !== undefined) {
                localVarQueryParameter['approvalFlg'] = approvalFlg;
            }

            if (startPeriod !== undefined) {
                localVarQueryParameter['startPeriod'] = startPeriod;
            }

            if (endPeriod !== undefined) {
                localVarQueryParameter['endPeriod'] = endPeriod;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLatestPastLessonNote: async (companyId: string, learnerId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetLatestPastLessonNote', 'companyId', companyId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerGetLatestPastLessonNote', 'learnerId', learnerId)
            // verify required parameter 'startPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetLatestPastLessonNote', 'startPeriod', startPeriod)
            // verify required parameter 'endPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetLatestPastLessonNote', 'endPeriod', endPeriod)
            // verify required parameter 'searchField' is not null or undefined
            assertParamExists('organizationsControllerGetLatestPastLessonNote', 'searchField', searchField)
            // verify required parameter 'searchStr' is not null or undefined
            assertParamExists('organizationsControllerGetLatestPastLessonNote', 'searchStr', searchStr)
            const localVarPath = `/api/organizations/get/{companyId}/lessonNote/{learnerId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startPeriod !== undefined) {
                localVarQueryParameter['startPeriod'] = startPeriod;
            }

            if (endPeriod !== undefined) {
                localVarQueryParameter['endPeriod'] = endPeriod;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['search_str'] = searchStr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLeanerUserListByLesson: async (companyId: string, lessonId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetLeanerUserListByLesson', 'companyId', companyId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerGetLeanerUserListByLesson', 'lessonId', lessonId)
            const localVarPath = `/api/organizations/learnerListByLesson`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (lessonId !== undefined) {
                localVarQueryParameter['lessonId'] = lessonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLearnerStudyRecords: async (companyId: string, learnerId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetLearnerStudyRecords', 'companyId', companyId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerGetLearnerStudyRecords', 'learnerId', learnerId)
            const localVarPath = `/api/organizations/get/{companyId}/{learnerId}/StudyRecords`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLearnerUserList: async (companyId: string, learnerId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetLearnerUserList', 'companyId', companyId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerGetLearnerUserList', 'learnerId', learnerId)
            // verify required parameter 'searchStatus' is not null or undefined
            assertParamExists('organizationsControllerGetLearnerUserList', 'searchStatus', searchStatus)
            // verify required parameter 'searchField' is not null or undefined
            assertParamExists('organizationsControllerGetLearnerUserList', 'searchField', searchField)
            // verify required parameter 'searchStr' is not null or undefined
            assertParamExists('organizationsControllerGetLearnerUserList', 'searchStr', searchStr)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('organizationsControllerGetLearnerUserList', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetLearnerUserList', 'page', page)
            const localVarPath = `/api/organizations/get/learnerList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (learnerId !== undefined) {
                localVarQueryParameter['learnerId'] = learnerId;
            }

            if (searchStatus !== undefined) {
                localVarQueryParameter['search_status'] = searchStatus;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['search_str'] = searchStr;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} lessonId 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLesson: async (companyId: string, teacherId: string, lessonId: string, searchField: string, searchStr: string, startPeriod: string, endPeriod: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetLesson', 'companyId', companyId)
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerGetLesson', 'teacherId', teacherId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerGetLesson', 'lessonId', lessonId)
            // verify required parameter 'searchField' is not null or undefined
            assertParamExists('organizationsControllerGetLesson', 'searchField', searchField)
            // verify required parameter 'searchStr' is not null or undefined
            assertParamExists('organizationsControllerGetLesson', 'searchStr', searchStr)
            // verify required parameter 'startPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetLesson', 'startPeriod', startPeriod)
            // verify required parameter 'endPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetLesson', 'endPeriod', endPeriod)
            const localVarPath = `/api/organizations/get/{companyId}/lesson/{lessonId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (teacherId !== undefined) {
                localVarQueryParameter['teacherId'] = teacherId;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['search_str'] = searchStr;
            }

            if (startPeriod !== undefined) {
                localVarQueryParameter['startPeriod'] = startPeriod;
            }

            if (endPeriod !== undefined) {
                localVarQueryParameter['endPeriod'] = endPeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonByCompanyNLessonID: async (companyId: string, lessonId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonByCompanyNLessonID', 'companyId', companyId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonByCompanyNLessonID', 'lessonId', lessonId)
            const localVarPath = `/api/organizations/{companyId}/lessons/{lessonId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonByRoomId: async (companyId: string, roomId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonByRoomId', 'companyId', companyId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonByRoomId', 'roomId', roomId)
            const localVarPath = `/api/organizations/{companyId}/roomId/{roomId}/lesson`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} learnerId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonFeedback: async (companyId: string, lessonId: string, learnerId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedback', 'companyId', companyId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedback', 'lessonId', lessonId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedback', 'learnerId', learnerId)
            // verify required parameter 'startPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedback', 'startPeriod', startPeriod)
            // verify required parameter 'endPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedback', 'endPeriod', endPeriod)
            // verify required parameter 'searchField' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedback', 'searchField', searchField)
            // verify required parameter 'searchStr' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedback', 'searchStr', searchStr)
            const localVarPath = `/api/organizations/{companyId}/lessonFeedback/{lessonId}/{learnerId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startPeriod !== undefined) {
                localVarQueryParameter['startPeriod'] = startPeriod;
            }

            if (endPeriod !== undefined) {
                localVarQueryParameter['endPeriod'] = endPeriod;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['search_str'] = searchStr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} learnerId 
         * @param {number} lessonId 
         * @param {string} teacherId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} noneLessonFeedback 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonFeedbackList: async (companyId: string, paymentId: number, learnerId: string, lessonId: number, teacherId: string, startPeriod: string, endPeriod: string, noneLessonFeedback: number, limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackList', 'companyId', companyId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackList', 'paymentId', paymentId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackList', 'learnerId', learnerId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackList', 'lessonId', lessonId)
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackList', 'teacherId', teacherId)
            // verify required parameter 'startPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackList', 'startPeriod', startPeriod)
            // verify required parameter 'endPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackList', 'endPeriod', endPeriod)
            // verify required parameter 'noneLessonFeedback' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackList', 'noneLessonFeedback', noneLessonFeedback)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackList', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackList', 'page', page)
            const localVarPath = `/api/organizations/get/lessonFeedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (paymentId !== undefined) {
                localVarQueryParameter['paymentId'] = paymentId;
            }

            if (learnerId !== undefined) {
                localVarQueryParameter['learnerId'] = learnerId;
            }

            if (lessonId !== undefined) {
                localVarQueryParameter['lessonId'] = lessonId;
            }

            if (teacherId !== undefined) {
                localVarQueryParameter['teacherId'] = teacherId;
            }

            if (startPeriod !== undefined) {
                localVarQueryParameter['startPeriod'] = startPeriod;
            }

            if (endPeriod !== undefined) {
                localVarQueryParameter['endPeriod'] = endPeriod;
            }

            if (noneLessonFeedback !== undefined) {
                localVarQueryParameter['none_lesson_feedback'] = noneLessonFeedback;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} learnerId 
         * @param {string} teacherId 
         * @param {string} companyName 
         * @param {string} learnerName 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonFeedbackListBgd: async (companyId: string, paymentId: number, learnerId: string, teacherId: string, companyName: string, learnerName: string, startPeriod: string, endPeriod: string, limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackListBgd', 'companyId', companyId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackListBgd', 'paymentId', paymentId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackListBgd', 'learnerId', learnerId)
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackListBgd', 'teacherId', teacherId)
            // verify required parameter 'companyName' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackListBgd', 'companyName', companyName)
            // verify required parameter 'learnerName' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackListBgd', 'learnerName', learnerName)
            // verify required parameter 'startPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackListBgd', 'startPeriod', startPeriod)
            // verify required parameter 'endPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackListBgd', 'endPeriod', endPeriod)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackListBgd', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetLessonFeedbackListBgd', 'page', page)
            const localVarPath = `/api/organizations/get/lessonFeedback_bgd`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (paymentId !== undefined) {
                localVarQueryParameter['paymentId'] = paymentId;
            }

            if (learnerId !== undefined) {
                localVarQueryParameter['learnerId'] = learnerId;
            }

            if (teacherId !== undefined) {
                localVarQueryParameter['teacherId'] = teacherId;
            }

            if (companyName !== undefined) {
                localVarQueryParameter['companyName'] = companyName;
            }

            if (learnerName !== undefined) {
                localVarQueryParameter['learnerName'] = learnerName;
            }

            if (startPeriod !== undefined) {
                localVarQueryParameter['startPeriod'] = startPeriod;
            }

            if (endPeriod !== undefined) {
                localVarQueryParameter['endPeriod'] = endPeriod;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonFees: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations/lessonFees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} learner 
         * @param {string} learnerId 
         * @param {string} company 
         * @param {string} searchStatus 
         * @param {string} lessonId 
         * @param {number} approvalFlg 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonListBgd: async (companyId: string, teacherId: string, learner: string, learnerId: string, company: string, searchStatus: string, lessonId: string, approvalFlg: number, startPeriod: string, endPeriod: string, limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonListBgd', 'companyId', companyId)
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonListBgd', 'teacherId', teacherId)
            // verify required parameter 'learner' is not null or undefined
            assertParamExists('organizationsControllerGetLessonListBgd', 'learner', learner)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonListBgd', 'learnerId', learnerId)
            // verify required parameter 'company' is not null or undefined
            assertParamExists('organizationsControllerGetLessonListBgd', 'company', company)
            // verify required parameter 'searchStatus' is not null or undefined
            assertParamExists('organizationsControllerGetLessonListBgd', 'searchStatus', searchStatus)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonListBgd', 'lessonId', lessonId)
            // verify required parameter 'approvalFlg' is not null or undefined
            assertParamExists('organizationsControllerGetLessonListBgd', 'approvalFlg', approvalFlg)
            // verify required parameter 'startPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetLessonListBgd', 'startPeriod', startPeriod)
            // verify required parameter 'endPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetLessonListBgd', 'endPeriod', endPeriod)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('organizationsControllerGetLessonListBgd', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetLessonListBgd', 'page', page)
            const localVarPath = `/api/organizations/get/lessonList_bgd`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (teacherId !== undefined) {
                localVarQueryParameter['teacherId'] = teacherId;
            }

            if (learner !== undefined) {
                localVarQueryParameter['learner'] = learner;
            }

            if (learnerId !== undefined) {
                localVarQueryParameter['learnerId'] = learnerId;
            }

            if (company !== undefined) {
                localVarQueryParameter['company'] = company;
            }

            if (searchStatus !== undefined) {
                localVarQueryParameter['searchStatus'] = searchStatus;
            }

            if (lessonId !== undefined) {
                localVarQueryParameter['lessonId'] = lessonId;
            }

            if (approvalFlg !== undefined) {
                localVarQueryParameter['approvalFlg'] = approvalFlg;
            }

            if (startPeriod !== undefined) {
                localVarQueryParameter['startPeriod'] = startPeriod;
            }

            if (endPeriod !== undefined) {
                localVarQueryParameter['endPeriod'] = endPeriod;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonNote: async (companyId: string, lessonId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonNote', 'companyId', companyId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonNote', 'lessonId', lessonId)
            // verify required parameter 'startPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetLessonNote', 'startPeriod', startPeriod)
            // verify required parameter 'endPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetLessonNote', 'endPeriod', endPeriod)
            // verify required parameter 'searchField' is not null or undefined
            assertParamExists('organizationsControllerGetLessonNote', 'searchField', searchField)
            // verify required parameter 'searchStr' is not null or undefined
            assertParamExists('organizationsControllerGetLessonNote', 'searchStr', searchStr)
            const localVarPath = `/api/organizations/{companyId}/lessonNote/{lessonId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startPeriod !== undefined) {
                localVarQueryParameter['startPeriod'] = startPeriod;
            }

            if (endPeriod !== undefined) {
                localVarQueryParameter['endPeriod'] = endPeriod;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['search_str'] = searchStr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonNoteList: async (companyId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetLessonNoteList', 'companyId', companyId)
            // verify required parameter 'startPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetLessonNoteList', 'startPeriod', startPeriod)
            // verify required parameter 'endPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetLessonNoteList', 'endPeriod', endPeriod)
            // verify required parameter 'searchField' is not null or undefined
            assertParamExists('organizationsControllerGetLessonNoteList', 'searchField', searchField)
            // verify required parameter 'searchStr' is not null or undefined
            assertParamExists('organizationsControllerGetLessonNoteList', 'searchStr', searchStr)
            const localVarPath = `/api/organizations/get/{companyId}/lessonNoteList`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startPeriod !== undefined) {
                localVarQueryParameter['startPeriod'] = startPeriod;
            }

            if (endPeriod !== undefined) {
                localVarQueryParameter['endPeriod'] = endPeriod;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['search_str'] = searchStr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLoginUserInfo: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations/login-user-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetMaintenance: async (page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetMaintenance', 'page', page)
            const localVarPath = `/api/organizations/maintenance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetManagerUserList: async (limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('organizationsControllerGetManagerUserList', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetManagerUserList', 'page', page)
            const localVarPath = `/api/organizations/managerUserList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} noticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetNotice: async (noticeId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'noticeId' is not null or undefined
            assertParamExists('organizationsControllerGetNotice', 'noticeId', noticeId)
            const localVarPath = `/api/organizations/notice/{noticeId}`
                .replace(`{${"noticeId"}}`, encodeURIComponent(String(noticeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} noticeId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetNoticeCompany: async (noticeId: string, companyId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'noticeId' is not null or undefined
            assertParamExists('organizationsControllerGetNoticeCompany', 'noticeId', noticeId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetNoticeCompany', 'companyId', companyId)
            const localVarPath = `/api/organizations/notices/{noticeId}/company/{companyId}`
                .replace(`{${"noticeId"}}`, encodeURIComponent(String(noticeId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} noticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetNoticeCompanyForManager: async (noticeId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'noticeId' is not null or undefined
            assertParamExists('organizationsControllerGetNoticeCompanyForManager', 'noticeId', noticeId)
            const localVarPath = `/api/organizations/notices/{noticeId}`
                .replace(`{${"noticeId"}}`, encodeURIComponent(String(noticeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} targetNumber 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetNoticeList: async (targetNumber: number, limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetNumber' is not null or undefined
            assertParamExists('organizationsControllerGetNoticeList', 'targetNumber', targetNumber)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('organizationsControllerGetNoticeList', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetNoticeList', 'page', page)
            const localVarPath = `/api/organizations/get/noticeList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (targetNumber !== undefined) {
                localVarQueryParameter['targetNumber'] = targetNumber;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetOperationalStatus: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations/operational_status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} teacherId 
         * @param {string} learnerId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} noneLessonNote 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetPastLessonList: async (companyId: string, paymentId: number, teacherId: string, learnerId: string, startPeriod: string, endPeriod: string, noneLessonNote: number, limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonList', 'companyId', companyId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonList', 'paymentId', paymentId)
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonList', 'teacherId', teacherId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonList', 'learnerId', learnerId)
            // verify required parameter 'startPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonList', 'startPeriod', startPeriod)
            // verify required parameter 'endPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonList', 'endPeriod', endPeriod)
            // verify required parameter 'noneLessonNote' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonList', 'noneLessonNote', noneLessonNote)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonList', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonList', 'page', page)
            const localVarPath = `/api/organizations/get/pastLessonList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (paymentId !== undefined) {
                localVarQueryParameter['paymentId'] = paymentId;
            }

            if (teacherId !== undefined) {
                localVarQueryParameter['teacherId'] = teacherId;
            }

            if (learnerId !== undefined) {
                localVarQueryParameter['learnerId'] = learnerId;
            }

            if (startPeriod !== undefined) {
                localVarQueryParameter['startPeriod'] = startPeriod;
            }

            if (endPeriod !== undefined) {
                localVarQueryParameter['endPeriod'] = endPeriod;
            }

            if (noneLessonNote !== undefined) {
                localVarQueryParameter['none_lesson_note'] = noneLessonNote;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} companyName 
         * @param {string} lessonId 
         * @param {string} learnerName 
         * @param {string} learnerId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetPastLessonListBgd: async (companyId: string, teacherId: string, companyName: string, lessonId: string, learnerName: string, learnerId: string, startPeriod: string, endPeriod: string, limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonListBgd', 'companyId', companyId)
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonListBgd', 'teacherId', teacherId)
            // verify required parameter 'companyName' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonListBgd', 'companyName', companyName)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonListBgd', 'lessonId', lessonId)
            // verify required parameter 'learnerName' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonListBgd', 'learnerName', learnerName)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonListBgd', 'learnerId', learnerId)
            // verify required parameter 'startPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonListBgd', 'startPeriod', startPeriod)
            // verify required parameter 'endPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonListBgd', 'endPeriod', endPeriod)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonListBgd', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetPastLessonListBgd', 'page', page)
            const localVarPath = `/api/organizations/get/pastLessonList_bgd`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (teacherId !== undefined) {
                localVarQueryParameter['teacherId'] = teacherId;
            }

            if (companyName !== undefined) {
                localVarQueryParameter['companyName'] = companyName;
            }

            if (lessonId !== undefined) {
                localVarQueryParameter['lessonId'] = lessonId;
            }

            if (learnerName !== undefined) {
                localVarQueryParameter['learnerName'] = learnerName;
            }

            if (learnerId !== undefined) {
                localVarQueryParameter['learnerId'] = learnerId;
            }

            if (startPeriod !== undefined) {
                localVarQueryParameter['startPeriod'] = startPeriod;
            }

            if (endPeriod !== undefined) {
                localVarQueryParameter['endPeriod'] = endPeriod;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetPaymentCompany: async (companyId: string, paymentId: number, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentCompany', 'companyId', companyId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentCompany', 'paymentId', paymentId)
            // verify required parameter 'searchStatus' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentCompany', 'searchStatus', searchStatus)
            // verify required parameter 'searchField' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentCompany', 'searchField', searchField)
            // verify required parameter 'searchStr' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentCompany', 'searchStr', searchStr)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentCompany', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentCompany', 'page', page)
            const localVarPath = `/api/organizations/{companyId}/paymentCompany`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (paymentId !== undefined) {
                localVarQueryParameter['paymentId'] = paymentId;
            }

            if (searchStatus !== undefined) {
                localVarQueryParameter['search_status'] = searchStatus;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['search_str'] = searchStr;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} targetMonth 
         * @param {number} paymentId 
         * @param {string} learnerId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetPaymentCompanyList: async (companyId: string, targetMonth: string, paymentId: number, learnerId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentCompanyList', 'companyId', companyId)
            // verify required parameter 'targetMonth' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentCompanyList', 'targetMonth', targetMonth)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentCompanyList', 'paymentId', paymentId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentCompanyList', 'learnerId', learnerId)
            // verify required parameter 'searchStatus' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentCompanyList', 'searchStatus', searchStatus)
            // verify required parameter 'searchField' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentCompanyList', 'searchField', searchField)
            // verify required parameter 'searchStr' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentCompanyList', 'searchStr', searchStr)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentCompanyList', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentCompanyList', 'page', page)
            const localVarPath = `/api/organizations/get/{companyId}/paymentList`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (targetMonth !== undefined) {
                localVarQueryParameter['target_month'] = targetMonth;
            }

            if (paymentId !== undefined) {
                localVarQueryParameter['paymentId'] = paymentId;
            }

            if (learnerId !== undefined) {
                localVarQueryParameter['learnerId'] = learnerId;
            }

            if (searchStatus !== undefined) {
                localVarQueryParameter['search_status'] = searchStatus;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['search_str'] = searchStr;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetPaymentLearnerDetails: async (companyId: string, paymentId: number, learnerId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentLearnerDetails', 'companyId', companyId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentLearnerDetails', 'paymentId', paymentId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentLearnerDetails', 'learnerId', learnerId)
            const localVarPath = `/api/organizations/get/{companyId}/{paymentId}/{learnerId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} learnerId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {number} searchAffiliationId 
         * @param {string} searchLastStudyBucket 
         * @param {string} sortStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetPaymentLearnerList: async (companyId: string, paymentId: number, learnerId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, searchAffiliationId: number, searchLastStudyBucket: string, sortStr: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentLearnerList', 'companyId', companyId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentLearnerList', 'paymentId', paymentId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentLearnerList', 'learnerId', learnerId)
            // verify required parameter 'searchStatus' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentLearnerList', 'searchStatus', searchStatus)
            // verify required parameter 'searchField' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentLearnerList', 'searchField', searchField)
            // verify required parameter 'searchStr' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentLearnerList', 'searchStr', searchStr)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentLearnerList', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentLearnerList', 'page', page)
            // verify required parameter 'searchAffiliationId' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentLearnerList', 'searchAffiliationId', searchAffiliationId)
            // verify required parameter 'searchLastStudyBucket' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentLearnerList', 'searchLastStudyBucket', searchLastStudyBucket)
            // verify required parameter 'sortStr' is not null or undefined
            assertParamExists('organizationsControllerGetPaymentLearnerList', 'sortStr', sortStr)
            const localVarPath = `/api/organizations/get/{companyId}/paymentLearnerList/{paymentId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (learnerId !== undefined) {
                localVarQueryParameter['learnerId'] = learnerId;
            }

            if (searchStatus !== undefined) {
                localVarQueryParameter['search_status'] = searchStatus;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['search_str'] = searchStr;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (searchAffiliationId !== undefined) {
                localVarQueryParameter['search_affiliation_id'] = searchAffiliationId;
            }

            if (searchLastStudyBucket !== undefined) {
                localVarQueryParameter['search_last_study_bucket'] = searchLastStudyBucket;
            }

            if (sortStr !== undefined) {
                localVarQueryParameter['sortStr'] = sortStr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} paymentId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetReportStudyRecords: async (companyId: string, paymentId: string, yearMonth: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetReportStudyRecords', 'companyId', companyId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('organizationsControllerGetReportStudyRecords', 'paymentId', paymentId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('organizationsControllerGetReportStudyRecords', 'yearMonth', yearMonth)
            const localVarPath = `/api/organizations/get/{companyId}/{paymentId}/{yearMonth}/StudyRecordsAll`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)))
                .replace(`{${"yearMonth"}}`, encodeURIComponent(String(yearMonth)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} endpoint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetStatus: async (endpoint: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'endpoint' is not null or undefined
            assertParamExists('organizationsControllerGetStatus', 'endpoint', endpoint)
            const localVarPath = `/api/organizations/subscription/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endpoint !== undefined) {
                localVarQueryParameter['endpoint'] = endpoint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetStudyRecords: async (companyId: string, learnerId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetStudyRecords', 'companyId', companyId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerGetStudyRecords', 'learnerId', learnerId)
            const localVarPath = `/api/organizations/get/{companyId}/StudyRecords/{learnerId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetSystemLearnerNotice: async (learnerId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerGetSystemLearnerNotice', 'learnerId', learnerId)
            const localVarPath = `/api/organizations/systemLearnerNotice/{learnerId}`
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetTargetMonthPaymentCompanyList: async (companyId: string, learnerId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetTargetMonthPaymentCompanyList', 'companyId', companyId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerGetTargetMonthPaymentCompanyList', 'learnerId', learnerId)
            const localVarPath = `/api/organizations/get/targetMonthPaymentList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (learnerId !== undefined) {
                localVarQueryParameter['learnerId'] = learnerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetTeacherByTeacherId: async (teacherId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherByTeacherId', 'teacherId', teacherId)
            const localVarPath = `/api/organizations/teacherInfo/{teacherId}`
                .replace(`{${"teacherId"}}`, encodeURIComponent(String(teacherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} yearMonth 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetTeacherLessonFee: async (companyId: string, teacherId: string, yearMonth: string, endPeriod: string, searchField: string, searchStr: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherLessonFee', 'companyId', companyId)
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherLessonFee', 'teacherId', teacherId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherLessonFee', 'yearMonth', yearMonth)
            // verify required parameter 'endPeriod' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherLessonFee', 'endPeriod', endPeriod)
            // verify required parameter 'searchField' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherLessonFee', 'searchField', searchField)
            // verify required parameter 'searchStr' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherLessonFee', 'searchStr', searchStr)
            const localVarPath = `/api/organizations/get/{teacherId}/LessonFee/{yearMonth}`
                .replace(`{${"teacherId"}}`, encodeURIComponent(String(teacherId)))
                .replace(`{${"yearMonth"}}`, encodeURIComponent(String(yearMonth)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (endPeriod !== undefined) {
                localVarQueryParameter['endPeriod'] = endPeriod;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['search_str'] = searchStr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {string} yearMonth 
         * @param {number} status 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetTeacherLessonFeeList: async (teacherId: string, yearMonth: string, status: number, limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherLessonFeeList', 'teacherId', teacherId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherLessonFeeList', 'yearMonth', yearMonth)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherLessonFeeList', 'status', status)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherLessonFeeList', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherLessonFeeList', 'page', page)
            const localVarPath = `/api/organizations/get/LessonFeeList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (teacherId !== undefined) {
                localVarQueryParameter['teacherId'] = teacherId;
            }

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetTeacherUserList: async (teacherId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherUserList', 'teacherId', teacherId)
            // verify required parameter 'searchStatus' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherUserList', 'searchStatus', searchStatus)
            // verify required parameter 'searchField' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherUserList', 'searchField', searchField)
            // verify required parameter 'searchStr' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherUserList', 'searchStr', searchStr)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherUserList', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('organizationsControllerGetTeacherUserList', 'page', page)
            const localVarPath = `/api/organizations/get/teacherList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (teacherId !== undefined) {
                localVarQueryParameter['teacherId'] = teacherId;
            }

            if (searchStatus !== undefined) {
                localVarQueryParameter['searchStatus'] = searchStatus;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['searchStr'] = searchStr;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetZoomToken: async (roomId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('organizationsControllerGetZoomToken', 'roomId', roomId)
            const localVarPath = `/api/organizations/zoom/{room_id}`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerImportCompanyUsersCsv: async (file: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('organizationsControllerImportCompanyUsersCsv', 'file', file)
            const localVarPath = `/api/organizations/import/company-user-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerImportLearnersCsv: async (file: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('organizationsControllerImportLearnersCsv', 'file', file)
            const localVarPath = `/api/organizations/import/learners-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} senderId 
         * @param {string} receiverId 
         * @param {string} message 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerPostZoomChat: async (companyId: string, lessonId: string, senderId: string, receiverId: string, message: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerPostZoomChat', 'companyId', companyId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerPostZoomChat', 'lessonId', lessonId)
            // verify required parameter 'senderId' is not null or undefined
            assertParamExists('organizationsControllerPostZoomChat', 'senderId', senderId)
            // verify required parameter 'receiverId' is not null or undefined
            assertParamExists('organizationsControllerPostZoomChat', 'receiverId', receiverId)
            // verify required parameter 'message' is not null or undefined
            assertParamExists('organizationsControllerPostZoomChat', 'message', message)
            const localVarPath = `/api/organizations/zoomChat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (lessonId !== undefined) {
                localVarQueryParameter['lessonId'] = lessonId;
            }

            if (senderId !== undefined) {
                localVarQueryParameter['senderId'] = senderId;
            }

            if (receiverId !== undefined) {
                localVarQueryParameter['receiverId'] = receiverId;
            }

            if (message !== undefined) {
                localVarQueryParameter['message'] = message;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PushSubscribeDto} pushSubscribeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerPushSubscribe: async (pushSubscribeDto: PushSubscribeDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pushSubscribeDto' is not null or undefined
            assertParamExists('organizationsControllerPushSubscribe', 'pushSubscribeDto', pushSubscribeDto)
            const localVarPath = `/api/organizations/subscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pushSubscribeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PushUnsubscribeDto} pushUnsubscribeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerPushUnsubscribe: async (pushUnsubscribeDto: PushUnsubscribeDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pushUnsubscribeDto' is not null or undefined
            assertParamExists('organizationsControllerPushUnsubscribe', 'pushUnsubscribeDto', pushUnsubscribeDto)
            const localVarPath = `/api/organizations/unsubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pushUnsubscribeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} roomId 
         * @param {CreateRoomChatInput} createRoomChatInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerPutCompanyRoomChat: async (companyId: string, roomId: string, createRoomChatInput: CreateRoomChatInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerPutCompanyRoomChat', 'companyId', companyId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('organizationsControllerPutCompanyRoomChat', 'roomId', roomId)
            // verify required parameter 'createRoomChatInput' is not null or undefined
            assertParamExists('organizationsControllerPutCompanyRoomChat', 'createRoomChatInput', createRoomChatInput)
            const localVarPath = `/api/organizations/{companyId}/{roomId}/chat`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoomChatInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} releaseFlg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerReleaseNotice: async (id: string, releaseFlg: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationsControllerReleaseNotice', 'id', id)
            // verify required parameter 'releaseFlg' is not null or undefined
            assertParamExists('organizationsControllerReleaseNotice', 'releaseFlg', releaseFlg)
            const localVarPath = `/api/organizations/release/noticeList/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (releaseFlg !== undefined) {
                localVarQueryParameter['release_flg'] = releaseFlg;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} userId 
         * @param {ResetCompanyUserPasswordInput} resetCompanyUserPasswordInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerResetCompanyUserPassword: async (companyId: string, userId: string, resetCompanyUserPasswordInput: ResetCompanyUserPasswordInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerResetCompanyUserPassword', 'companyId', companyId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('organizationsControllerResetCompanyUserPassword', 'userId', userId)
            // verify required parameter 'resetCompanyUserPasswordInput' is not null or undefined
            assertParamExists('organizationsControllerResetCompanyUserPassword', 'resetCompanyUserPasswordInput', resetCompanyUserPasswordInput)
            const localVarPath = `/api/organizations/update/{companyId}/companyUser/{userId}/reset-password`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetCompanyUserPasswordInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {ResetLearnerPasswordInput} resetLearnerPasswordInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerResetLearnerPassword: async (companyId: string, learnerId: string, resetLearnerPasswordInput: ResetLearnerPasswordInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerResetLearnerPassword', 'companyId', companyId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerResetLearnerPassword', 'learnerId', learnerId)
            // verify required parameter 'resetLearnerPasswordInput' is not null or undefined
            assertParamExists('organizationsControllerResetLearnerPassword', 'resetLearnerPasswordInput', resetLearnerPasswordInput)
            const localVarPath = `/api/organizations/update/{companyId}/learnerUser/{learnerId}/reset-password`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetLearnerPasswordInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mailSubject 
         * @param {string} mailerId 
         * @param {string} mailerName 
         * @param {string} kinds 
         * @param {string} mailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerSendInquiryEmail: async (mailSubject: string, mailerId: string, mailerName: string, kinds: string, mailBody: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mailSubject' is not null or undefined
            assertParamExists('organizationsControllerSendInquiryEmail', 'mailSubject', mailSubject)
            // verify required parameter 'mailerId' is not null or undefined
            assertParamExists('organizationsControllerSendInquiryEmail', 'mailerId', mailerId)
            // verify required parameter 'mailerName' is not null or undefined
            assertParamExists('organizationsControllerSendInquiryEmail', 'mailerName', mailerName)
            // verify required parameter 'kinds' is not null or undefined
            assertParamExists('organizationsControllerSendInquiryEmail', 'kinds', kinds)
            // verify required parameter 'mailBody' is not null or undefined
            assertParamExists('organizationsControllerSendInquiryEmail', 'mailBody', mailBody)
            const localVarPath = `/api/organizations/sendInquiryEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (mailSubject !== undefined) {
                localVarQueryParameter['mailSubject'] = mailSubject;
            }

            if (mailerId !== undefined) {
                localVarQueryParameter['mailerId'] = mailerId;
            }

            if (mailerName !== undefined) {
                localVarQueryParameter['mailerName'] = mailerName;
            }

            if (kinds !== undefined) {
                localVarQueryParameter['kinds'] = kinds;
            }

            if (mailBody !== undefined) {
                localVarQueryParameter['mailBody'] = mailBody;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} sendQueryEmail 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerSendQueryEmail: async (companyId: string, sendQueryEmail: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerSendQueryEmail', 'companyId', companyId)
            // verify required parameter 'sendQueryEmail' is not null or undefined
            assertParamExists('organizationsControllerSendQueryEmail', 'sendQueryEmail', sendQueryEmail)
            // verify required parameter 'startPeriod' is not null or undefined
            assertParamExists('organizationsControllerSendQueryEmail', 'startPeriod', startPeriod)
            // verify required parameter 'endPeriod' is not null or undefined
            assertParamExists('organizationsControllerSendQueryEmail', 'endPeriod', endPeriod)
            // verify required parameter 'searchField' is not null or undefined
            assertParamExists('organizationsControllerSendQueryEmail', 'searchField', searchField)
            // verify required parameter 'searchStr' is not null or undefined
            assertParamExists('organizationsControllerSendQueryEmail', 'searchStr', searchStr)
            const localVarPath = `/api/organizations/{sendQueryEmail}`
                .replace(`{${"sendQueryEmail"}}`, encodeURIComponent(String(sendQueryEmail)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (startPeriod !== undefined) {
                localVarQueryParameter['startPeriod'] = startPeriod;
            }

            if (endPeriod !== undefined) {
                localVarQueryParameter['endPeriod'] = endPeriod;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['search_str'] = searchStr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {UpdateAgreementInput} updateAgreementInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateAgreement: async (companyId: string, updateAgreementInput: UpdateAgreementInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerUpdateAgreement', 'companyId', companyId)
            // verify required parameter 'updateAgreementInput' is not null or undefined
            assertParamExists('organizationsControllerUpdateAgreement', 'updateAgreementInput', updateAgreementInput)
            const localVarPath = `/api/organizations/update/{companyId}/paymentList`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAgreementInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} paymentId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateAgreementPlan: async (companyId: string, paymentId: string, body: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerUpdateAgreementPlan', 'companyId', companyId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('organizationsControllerUpdateAgreementPlan', 'paymentId', paymentId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('organizationsControllerUpdateAgreementPlan', 'body', body)
            const localVarPath = `/api/organizations/updatePlan/{companyId}/{paymentId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {string} yearMonth 
         * @param {number} billedFlg 
         * @param {number} finalFee 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateBillingStatus: async (teacherId: string, yearMonth: string, billedFlg: number, finalFee: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerUpdateBillingStatus', 'teacherId', teacherId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('organizationsControllerUpdateBillingStatus', 'yearMonth', yearMonth)
            // verify required parameter 'billedFlg' is not null or undefined
            assertParamExists('organizationsControllerUpdateBillingStatus', 'billedFlg', billedFlg)
            // verify required parameter 'finalFee' is not null or undefined
            assertParamExists('organizationsControllerUpdateBillingStatus', 'finalFee', finalFee)
            const localVarPath = `/api/organizations/update/updateBillingStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (teacherId !== undefined) {
                localVarQueryParameter['teacherId'] = teacherId;
            }

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (billedFlg !== undefined) {
                localVarQueryParameter['billedFlg'] = billedFlg;
            }

            if (finalFee !== undefined) {
                localVarQueryParameter['finalFee'] = finalFee;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {UpdateCompanyInput} updateCompanyInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateCompany: async (companyId: string, updateCompanyInput: UpdateCompanyInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerUpdateCompany', 'companyId', companyId)
            // verify required parameter 'updateCompanyInput' is not null or undefined
            assertParamExists('organizationsControllerUpdateCompany', 'updateCompanyInput', updateCompanyInput)
            const localVarPath = `/api/organizations/update/company/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCompanyInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} maintenanceId 
         * @param {boolean} immediateFlg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateDeMaintenance: async (maintenanceId: number, immediateFlg: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'maintenanceId' is not null or undefined
            assertParamExists('organizationsControllerUpdateDeMaintenance', 'maintenanceId', maintenanceId)
            // verify required parameter 'immediateFlg' is not null or undefined
            assertParamExists('organizationsControllerUpdateDeMaintenance', 'immediateFlg', immediateFlg)
            const localVarPath = `/api/organizations/maintenances/{maintenance_id}/de_maintenance`
                .replace(`{${"maintenance_id"}}`, encodeURIComponent(String(maintenanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (immediateFlg !== undefined) {
                localVarQueryParameter['immediate_flg'] = immediateFlg;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {UpdateLearnerInput} updateLearnerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateLearnerUser: async (companyId: string, learnerId: string, updateLearnerInput: UpdateLearnerInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerUpdateLearnerUser', 'companyId', companyId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerUpdateLearnerUser', 'learnerId', learnerId)
            // verify required parameter 'updateLearnerInput' is not null or undefined
            assertParamExists('organizationsControllerUpdateLearnerUser', 'updateLearnerInput', updateLearnerInput)
            const localVarPath = `/api/organizations/update/{companyId}/learnerUser/{learnerId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLearnerInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateLesson: async (companyId: string, lessonId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerUpdateLesson', 'companyId', companyId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerUpdateLesson', 'lessonId', lessonId)
            // verify required parameter 'startPeriod' is not null or undefined
            assertParamExists('organizationsControllerUpdateLesson', 'startPeriod', startPeriod)
            // verify required parameter 'endPeriod' is not null or undefined
            assertParamExists('organizationsControllerUpdateLesson', 'endPeriod', endPeriod)
            // verify required parameter 'searchField' is not null or undefined
            assertParamExists('organizationsControllerUpdateLesson', 'searchField', searchField)
            // verify required parameter 'searchStr' is not null or undefined
            assertParamExists('organizationsControllerUpdateLesson', 'searchStr', searchStr)
            const localVarPath = `/api/organizations/update/{companyId}/lesson/{lessonId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startPeriod !== undefined) {
                localVarQueryParameter['startPeriod'] = startPeriod;
            }

            if (endPeriod !== undefined) {
                localVarQueryParameter['endPeriod'] = endPeriod;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['search_str'] = searchStr;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} feedback 
         * @param {string} learnerIdCsv 
         * @param {string} [adminComment] 
         * @param {string} [filesMetadata] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateLessonFeedback: async (companyId: string, lessonId: string, feedback: string, learnerIdCsv: string, adminComment?: string, filesMetadata?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerUpdateLessonFeedback', 'companyId', companyId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerUpdateLessonFeedback', 'lessonId', lessonId)
            // verify required parameter 'feedback' is not null or undefined
            assertParamExists('organizationsControllerUpdateLessonFeedback', 'feedback', feedback)
            // verify required parameter 'learnerIdCsv' is not null or undefined
            assertParamExists('organizationsControllerUpdateLessonFeedback', 'learnerIdCsv', learnerIdCsv)
            const localVarPath = `/api/organizations/lessonFeedback/{companyId}/{lessonId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (feedback !== undefined) { 
                localVarFormParams.append('feedback', feedback as any);
            }
    
            if (adminComment !== undefined) { 
                localVarFormParams.append('admin_comment', adminComment as any);
            }
    
            if (learnerIdCsv !== undefined) { 
                localVarFormParams.append('learner_id_csv', learnerIdCsv as any);
            }
    
            if (filesMetadata !== undefined) { 
                localVarFormParams.append('files_metadata', filesMetadata as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} learnerId 
         * @param {boolean} lessonLearnerStatus 
         * @param {UpdateLessonLearnerInput} updateLessonLearnerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateLessonLearnerStatus: async (companyId: string, lessonId: string, learnerId: string, lessonLearnerStatus: boolean, updateLessonLearnerInput: UpdateLessonLearnerInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerUpdateLessonLearnerStatus', 'companyId', companyId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerUpdateLessonLearnerStatus', 'lessonId', lessonId)
            // verify required parameter 'learnerId' is not null or undefined
            assertParamExists('organizationsControllerUpdateLessonLearnerStatus', 'learnerId', learnerId)
            // verify required parameter 'lessonLearnerStatus' is not null or undefined
            assertParamExists('organizationsControllerUpdateLessonLearnerStatus', 'lessonLearnerStatus', lessonLearnerStatus)
            // verify required parameter 'updateLessonLearnerInput' is not null or undefined
            assertParamExists('organizationsControllerUpdateLessonLearnerStatus', 'updateLessonLearnerInput', updateLessonLearnerInput)
            const localVarPath = `/api/organizations/update/{companyId}/lessonLearner/{lessonLearnerStatus}/{lessonId}/{learnerId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)))
                .replace(`{${"learnerId"}}`, encodeURIComponent(String(learnerId)))
                .replace(`{${"lessonLearnerStatus"}}`, encodeURIComponent(String(lessonLearnerStatus)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLessonLearnerInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {UpdateLessonNoteInput} updateLessonNoteInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateLessonNote: async (companyId: string, lessonId: string, updateLessonNoteInput: UpdateLessonNoteInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerUpdateLessonNote', 'companyId', companyId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerUpdateLessonNote', 'lessonId', lessonId)
            // verify required parameter 'updateLessonNoteInput' is not null or undefined
            assertParamExists('organizationsControllerUpdateLessonNote', 'updateLessonNoteInput', updateLessonNoteInput)
            const localVarPath = `/api/organizations/update/{companyId}/lessonNote/{lessonId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLessonNoteInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateLessonStatusTeacher: async (companyId: string, lessonId: string, status: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerUpdateLessonStatusTeacher', 'companyId', companyId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerUpdateLessonStatusTeacher', 'lessonId', lessonId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('organizationsControllerUpdateLessonStatusTeacher', 'status', status)
            const localVarPath = `/api/organizations/{companyId}/updateLessonStatus/{lessonId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} maintenanceId 
         * @param {CreateMaintenanceInput} createMaintenanceInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateMaintenance: async (maintenanceId: number, createMaintenanceInput: CreateMaintenanceInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'maintenanceId' is not null or undefined
            assertParamExists('organizationsControllerUpdateMaintenance', 'maintenanceId', maintenanceId)
            // verify required parameter 'createMaintenanceInput' is not null or undefined
            assertParamExists('organizationsControllerUpdateMaintenance', 'createMaintenanceInput', createMaintenanceInput)
            const localVarPath = `/api/organizations/maintenance/{maintenance_id}`
                .replace(`{${"maintenance_id"}}`, encodeURIComponent(String(maintenanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMaintenanceInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateNoticeInput} createNoticeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateNotice: async (id: string, createNoticeInput: CreateNoticeInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationsControllerUpdateNotice', 'id', id)
            // verify required parameter 'createNoticeInput' is not null or undefined
            assertParamExists('organizationsControllerUpdateNotice', 'createNoticeInput', createNoticeInput)
            const localVarPath = `/api/organizations/update/notice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNoticeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} noticeId 
         * @param {boolean} readStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateSystemLearnerNoticeReadStatus: async (noticeId: string, readStatus: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'noticeId' is not null or undefined
            assertParamExists('organizationsControllerUpdateSystemLearnerNoticeReadStatus', 'noticeId', noticeId)
            // verify required parameter 'readStatus' is not null or undefined
            assertParamExists('organizationsControllerUpdateSystemLearnerNoticeReadStatus', 'readStatus', readStatus)
            const localVarPath = `/api/organizations/update/systemNoticeLearner/{noticeId}`
                .replace(`{${"noticeId"}}`, encodeURIComponent(String(noticeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (readStatus !== undefined) {
                localVarQueryParameter['read_status'] = readStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {ConnectionId} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateTeacherConnectionId: async (companyId: string, teacherId: string, connectionId: ConnectionId, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerUpdateTeacherConnectionId', 'companyId', companyId)
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerUpdateTeacherConnectionId', 'teacherId', teacherId)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('organizationsControllerUpdateTeacherConnectionId', 'connectionId', connectionId)
            const localVarPath = `/api/organizations/{companyId}/{teacherId}/connectionId`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"teacherId"}}`, encodeURIComponent(String(teacherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectionId, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {UpdateTeacherInput} updateTeacherInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateTeacherUser: async (teacherId: string, updateTeacherInput: UpdateTeacherInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('organizationsControllerUpdateTeacherUser', 'teacherId', teacherId)
            // verify required parameter 'updateTeacherInput' is not null or undefined
            assertParamExists('organizationsControllerUpdateTeacherUser', 'updateTeacherInput', updateTeacherInput)
            const localVarPath = `/api/organizations/update/teacher/{teacherId}`
                .replace(`{${"teacherId"}}`, encodeURIComponent(String(teacherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTeacherInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} theme 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateThemeOnLesson: async (companyId: string, lessonId: string, theme: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('organizationsControllerUpdateThemeOnLesson', 'companyId', companyId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('organizationsControllerUpdateThemeOnLesson', 'lessonId', lessonId)
            // verify required parameter 'theme' is not null or undefined
            assertParamExists('organizationsControllerUpdateThemeOnLesson', 'theme', theme)
            const localVarPath = `/api/organizations/updateTheme/{companyId}/{lessonId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerVerifyCognitoUserEmail: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations/verifyEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxControllerCognitoSandbox: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sandbox/cognito`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxControllerMailSandbox: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sandbox/mail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jlptLevel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        studyRecordsControllerGetCompletedStages: async (jlptLevel: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'jlptLevel' is not null or undefined
            assertParamExists('studyRecordsControllerGetCompletedStages', 'jlptLevel', jlptLevel)
            const localVarPath = `/api/study-records/completed-stages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (jlptLevel !== undefined) {
                localVarQueryParameter['jlptLevel'] = jlptLevel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveStudyRecordStageInput} saveStudyRecordStageInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        studyRecordsControllerSaveStudyRecord: async (saveStudyRecordStageInput: SaveStudyRecordStageInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveStudyRecordStageInput' is not null or undefined
            assertParamExists('studyRecordsControllerSaveStudyRecord', 'saveStudyRecordStageInput', saveStudyRecordStageInput)
            const localVarPath = `/api/study-records/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveStudyRecordStageInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSurveyResponseDto} createSurveyResponseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyControllerCreateResponse: async (createSurveyResponseDto: CreateSurveyResponseDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSurveyResponseDto' is not null or undefined
            assertParamExists('surveyControllerCreateResponse', 'createSurveyResponseDto', createSurveyResponseDto)
            const localVarPath = `/api/surveys/responses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSurveyResponseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyControllerGetLatestSurvey: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/surveys/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teacherControllerGetLearnersWithoutFeedback: async (teacherId: string, limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('teacherControllerGetLearnersWithoutFeedback', 'teacherId', teacherId)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('teacherControllerGetLearnersWithoutFeedback', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('teacherControllerGetLearnersWithoutFeedback', 'page', page)
            const localVarPath = `/api/teacher/learners/without-feedback/{teacherId}`
                .replace(`{${"teacherId"}}`, encodeURIComponent(String(teacherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teacherControllerGetMostRecentScheduledLesson: async (teacherId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('teacherControllerGetMostRecentScheduledLesson', 'teacherId', teacherId)
            const localVarPath = `/api/teacher/most-recent-scheduled-lesson/{teacherId}`
                .replace(`{${"teacherId"}}`, encodeURIComponent(String(teacherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teacherControllerGetNotUpdatedNoteLessons: async (teacherId: string, limit: number, page: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('teacherControllerGetNotUpdatedNoteLessons', 'teacherId', teacherId)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('teacherControllerGetNotUpdatedNoteLessons', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('teacherControllerGetNotUpdatedNoteLessons', 'page', page)
            const localVarPath = `/api/teacher/lessons/not-updated-note/{teacherId}`
                .replace(`{${"teacherId"}}`, encodeURIComponent(String(teacherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teacherControllerGetUnaprovedLessons: async (teacherId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'teacherId' is not null or undefined
            assertParamExists('teacherControllerGetUnaprovedLessons', 'teacherId', teacherId)
            const localVarPath = `/api/teacher/lessons/unaproved/{teacherId}`
                .replace(`{${"teacherId"}}`, encodeURIComponent(String(teacherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LessonLoggingInput} lessonLoggingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEventControllerLogLessonEvent: async (lessonLoggingInput: LessonLoggingInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lessonLoggingInput' is not null or undefined
            assertParamExists('userEventControllerLogLessonEvent', 'lessonLoggingInput', lessonLoggingInput)
            const localVarPath = `/api/user-event/logging-lesson`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lessonLoggingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoggingInput} loggingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEventControllerLoggingEvent: async (loggingInput: LoggingInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'loggingInput' is not null or undefined
            assertParamExists('userEventControllerLoggingEvent', 'loggingInput', loggingInput)
            const localVarPath = `/api/user-event/logging`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loggingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoggingInput} loggingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEventControllerLoggingEventByNotAuth: async (loggingInput: LoggingInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'loggingInput' is not null or undefined
            assertParamExists('userEventControllerLoggingEventByNotAuth', 'loggingInput', loggingInput)
            const localVarPath = `/api/user-event/logging-not-auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loggingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * APIApi - functional programming interface
 * @export
 */
export const APIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = APIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} companyId 
         * @param {ApplyAffiliationTypeTemplateDto} applyAffiliationTypeTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async affiliationsControllerApplyTypeTemplate(companyId: string, applyAffiliationTypeTemplateDto: ApplyAffiliationTypeTemplateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.affiliationsControllerApplyTypeTemplate(companyId, applyAffiliationTypeTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {AssignAffiliationDto} assignAffiliationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async affiliationsControllerAssign(companyId: string, assignAffiliationDto: AssignAffiliationDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.affiliationsControllerAssign(companyId, assignAffiliationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} assignmentId 
         * @param {ChangeAffiliationRoleDto} changeAffiliationRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async affiliationsControllerChangeAssignmentRole(companyId: string, assignmentId: number, changeAffiliationRoleDto: ChangeAffiliationRoleDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.affiliationsControllerChangeAssignmentRole(companyId, assignmentId, changeAffiliationRoleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CreateAffiliationNodeDto} createAffiliationNodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async affiliationsControllerCreateNode(companyId: string, createAffiliationNodeDto: CreateAffiliationNodeDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.affiliationsControllerCreateNode(companyId, createAffiliationNodeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CreateAffiliationTypeDto} createAffiliationTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async affiliationsControllerCreateType(companyId: string, createAffiliationTypeDto: CreateAffiliationTypeDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.affiliationsControllerCreateType(companyId, createAffiliationTypeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} affiliationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async affiliationsControllerDeleteNode(companyId: string, affiliationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.affiliationsControllerDeleteNode(companyId, affiliationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} typeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async affiliationsControllerDeleteType(companyId: string, typeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.affiliationsControllerDeleteType(companyId, typeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async affiliationsControllerGetMyAffiliations(companyId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.affiliationsControllerGetMyAffiliations(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async affiliationsControllerGetTree(companyId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.affiliationsControllerGetTree(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} dryRun 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async affiliationsControllerImportLearnerAffiliations(companyId: string, dryRun: string, file: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.affiliationsControllerImportLearnerAffiliations(companyId, dryRun, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {'LEARNER' | 'COMPANY_USER'} [userType] 
         * @param {string} [userId] 
         * @param {number} [affiliationId] 
         * @param {boolean} [includeDescendants] affiliation_id 指定時、配下の所属も含める
         * @param {string} [searchStr] 氏名・ニックネーム・メールアドレスの部分一致
         * @param {number} [limit] 1ページの件数(既定 50、最大 1000)
         * @param {number} [page] ページ番号(1始まり)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async affiliationsControllerListAssignments(companyId: string, userType?: 'LEARNER' | 'COMPANY_USER', userId?: string, affiliationId?: number, includeDescendants?: boolean, searchStr?: string, limit?: number, page?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.affiliationsControllerListAssignments(companyId, userType, userId, affiliationId, includeDescendants, searchStr, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async affiliationsControllerUnassign(companyId: string, assignmentId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.affiliationsControllerUnassign(companyId, assignmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} affiliationId 
         * @param {UpdateAffiliationNodeDto} updateAffiliationNodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async affiliationsControllerUpdateNode(companyId: string, affiliationId: number, updateAffiliationNodeDto: UpdateAffiliationNodeDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.affiliationsControllerUpdateNode(companyId, affiliationId, updateAffiliationNodeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} typeId 
         * @param {UpdateAffiliationTypeDto} updateAffiliationTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async affiliationsControllerUpdateType(companyId: string, typeId: number, updateAffiliationTypeDto: UpdateAffiliationTypeDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.affiliationsControllerUpdateType(companyId, typeId, updateAffiliationTypeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ForgotCompanyPasswordInput} forgotCompanyPasswordInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyAuthControllerForgotCompanyPassword(forgotCompanyPasswordInput: ForgotCompanyPasswordInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyAuthControllerForgotCompanyPassword(forgotCompanyPasswordInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardControllerGetLearners(companyId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardControllerGetLearners(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardControllerGetMe(companyId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardControllerGetMe(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateForBeginnersInquiryInput} createForBeginnersInquiryInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inquiryControllerSendForBeginnersInquiryEmail(createForBeginnersInquiryInput: CreateForBeginnersInquiryInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inquiryControllerSendForBeginnersInquiryEmail(createForBeginnersInquiryInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateInquiryInput} createInquiryInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inquiryControllerSendInquiryEmail(createInquiryInput: CreateInquiryInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inquiryControllerSendInquiryEmail(createInquiryInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ForgotLearnerPasswordInput} forgotLearnerPasswordInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async learnerAuthControllerForgotLearnerPassword(forgotLearnerPasswordInput: ForgotLearnerPasswordInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.learnerAuthControllerForgotLearnerPassword(forgotLearnerPasswordInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async learnerControllerCompleteCheckTest(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.learnerControllerCompleteCheckTest(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async learnerControllerGetCheckTestStatus(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCheckTestStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.learnerControllerGetCheckTestStatus(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} learnerId 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async learnerControllerGetLearnerStudyTimeInfo(learnerId: string, companyId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLearnerStudyTimeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.learnerControllerGetLearnerStudyTimeInfo(learnerId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} learnerId 
         * @param {number} companyId 
         * @param {number} [paymentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async learnerControllerGetLearnerTotalLessonsVsParticipatedLessons(learnerId: string, companyId: number, paymentId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLearnerTotalLessonsVsParticipatedLessonsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.learnerControllerGetLearnerTotalLessonsVsParticipatedLessons(learnerId, companyId, paymentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async learnerControllerIsHighestStageCompleted(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetHighestStageCompletedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.learnerControllerIsHighestStageCompleted(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} fileUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lessonControllerGetDownloadUrl(fileUrl: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lessonControllerGetDownloadUrl(fileUrl, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} lessonId 
         * @param {string} roomId 
         * @param {number} timestamp 
         * @param {string} mimeType 
         * @param {string} targetUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lessonControllerGetUploadUrlOfRecordedFile(lessonId: string, roomId: string, timestamp: number, mimeType: string, targetUserId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lessonControllerGetUploadUrlOfRecordedFile(lessonId, roomId, timestamp, mimeType, targetUserId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerCreateActiveLearnerLog(learnerId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateActiveLearnerLogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerCreateActiveLearnerLog(learnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} lessonId 
         * @param {string} companyId 
         * @param {string} userId 
         * @param {LessonLogType} lessonLogType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerCreateLessonLog(lessonId: string, companyId: string, userId: string, lessonLogType: LessonLogType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateLessonLogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerCreateLessonLog(lessonId, companyId, userId, lessonLogType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerDeactivateLearnerEndpoints(companyId: string, learnerId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeactivateLearnerEndPointsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerDeactivateLearnerEndpoints(companyId, learnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} learnerId 
         * @param {boolean} onlyFuture 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerGetApprovedLessons(learnerId: string, onlyFuture: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetApprovedLessonsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerGetApprovedLessons(learnerId, onlyFuture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerGetLearnerActiveEndpointCount(companyId: string, learnerId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLearnerActiveEndPointCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerGetLearnerActiveEndpointCount(companyId, learnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerGetLearnerByEmail(companyId: string, email: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLearnerByEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerGetLearnerByEmail(companyId, email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerGetLearnerEndpoint(companyId: string, learnerId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLearnerDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerGetLearnerEndpoint(companyId, learnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerGetLernerById(companyId: string, learnerId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLearnerByIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerGetLernerById(companyId, learnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerGetLoginedLearnerDetail(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLearnerDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerGetLoginedLearnerDetail(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerGetMostRecentScheduledLesson(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMostRecentScheduledLessonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerGetMostRecentScheduledLesson(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} noticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerGetNoticeRead(noticeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNoticeReadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerGetNoticeRead(noticeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerGetNoticeUnreadCount(userName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNoticeUnreadCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerGetNoticeUnreadCount(userName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerGetNotices(limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNoticesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerGetNotices(limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerGetPastLessons(limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPastLessonsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerGetPastLessons(limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerGetPushMsg(companyId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPushMsgResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerGetPushMsg(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} pushMsgQId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerGetPushMsgLog(companyId: string, pushMsgQId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPushMsgLogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerGetPushMsgLog(companyId, pushMsgQId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerGetPushVapidPublicKey(companyId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPushVapidPublicKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerGetPushVapidPublicKey(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerGetStudyRecords(userName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStudyRecordsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerGetStudyRecords(userName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DrillParam} drillParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerPostStudyRecordDrill(drillParam: DrillParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostStudyRecordStoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerPostStudyRecordDrill(drillParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StudyResult} studyResult 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerPostStudyRecordStory(studyResult: StudyResult, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostStudyRecordStoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerPostStudyRecordStory(studyResult, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateDrillResult} updateDrillResult 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerPutDrillRecord(updateDrillResult: UpdateDrillResult, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutDrillRecordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerPutDrillRecord(updateDrillResult, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} noticeId 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerPutNoticeRead(companyId: string, noticeId: number, userName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutNoticeReadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerPutNoticeRead(companyId, noticeId, userName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateStudyResult} updateStudyResult 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerPutStudyRecord(updateStudyResult: UpdateStudyResult, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutStudyRecordRecordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerPutStudyRecord(updateStudyResult, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RecordStudySessionInput} recordStudySessionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerRecordStudySession(recordStudySessionInput: RecordStudySessionInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecordStudySessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerRecordStudySession(recordStudySessionInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StartStudySessionInput} startStudySessionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerStartStudySession(startStudySessionInput: StartStudySessionInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartStudySessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerStartStudySession(startStudySessionInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {ConnectionId} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerUpdateLearnerConnectionId(companyId: string, learnerId: string, connectionId: ConnectionId, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateLearnerConnectionIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerUpdateLearnerConnectionId(companyId, learnerId, connectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerUpdateLearnerEmail(companyId: string, learnerId: string, email: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateLearnerEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerUpdateLearnerEmail(companyId, learnerId, email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {string} emailSendFlg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerUpdateLearnerEmailSendFlg(companyId: string, learnerId: string, emailSendFlg: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateLearnerEmailSendFlgResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerUpdateLearnerEmailSendFlg(companyId, learnerId, emailSendFlg, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {LearnerEndpoint} learnerEndpoint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerUpsertLearnerEndpoint(companyId: string, learnerId: string, learnerEndpoint: LearnerEndpoint, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertLearnerEndPointResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerUpsertLearnerEndpoint(companyId, learnerId, learnerEndpoint, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {PushMsg} pushMsg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerUpsertPushMsg(companyId: string, pushMsg: PushMsg, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertPushMsgResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerUpsertPushMsg(companyId, pushMsg, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {PushMsgLog} pushMsgLog 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerUpsertPushMsgLog(companyId: string, pushMsgLog: PushMsgLog, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertPushMsgLogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerUpsertPushMsgLog(companyId, pushMsgLog, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerVerifyCognitoUserEmail(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyCognitoUserEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerVerifyCognitoUserEmail(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {string} email 
         * @param {VerifyInfo} verifyInfo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mobileAppControllerVerifyLearnerEmail(companyId: string, learnerId: string, email: string, verifyInfo: VerifyInfo, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyLearnerEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mobileAppControllerVerifyLearnerEmail(companyId, learnerId, email, verifyInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerApprovalLessonTeacher(companyId: string, lessonId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerApprovalLessonTeacher(companyId, lessonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {CancelLessonInput} cancelLessonInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerCancelLesson(companyId: string, lessonId: string, cancelLessonInput: CancelLessonInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerCancelLesson(companyId, lessonId, cancelLessonInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} teacherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerChangeLessonTeacher(companyId: string, lessonId: string, teacherId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerChangeLessonTeacher(companyId, lessonId, teacherId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerCreateActiveCompanyUserLog(userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerCreateActiveCompanyUserLog(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CreateAgreementInput} createAgreementInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerCreateAgreement(companyId: string, createAgreementInput: CreateAgreementInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerCreateAgreement(companyId, createAgreementInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CreateCompanyInput} createCompanyInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerCreateCompany(companyId: string, createCompanyInput: CreateCompanyInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerCreateCompany(companyId, createCompanyInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CreateCompanyUserInput} createCompanyUserInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerCreateCompanyUser(companyId: string, createCompanyUserInput: CreateCompanyUserInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerCreateCompanyUser(companyId, createCompanyUserInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateErrorLog} createErrorLog 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerCreateErrorLog(createErrorLog: CreateErrorLog, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerCreateErrorLog(createErrorLog, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {CreateLearnerInput} createLearnerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerCreateLearnerUser(companyId: string, paymentId: number, createLearnerInput: CreateLearnerInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerCreateLearnerUser(companyId, paymentId, createLearnerInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} startDatetime 
         * @param {string} endDatetime 
         * @param {CreateLessonInput} createLessonInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerCreateLesson(companyId: string, teacherId: string, startDatetime: string, endDatetime: string, createLessonInput: CreateLessonInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerCreateLesson(companyId, teacherId, startDatetime, endDatetime, createLessonInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {CreateLessonFeeInput} createLessonFeeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerCreateLessonFee(teacherId: string, createLessonFeeInput: CreateLessonFeeInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerCreateLessonFee(teacherId, createLessonFeeInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {CreateLessonFeeHistoryInput} createLessonFeeHistoryInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerCreateLessonFeeHistory(teacherId: string, createLessonFeeHistoryInput: CreateLessonFeeHistoryInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerCreateLessonFeeHistory(teacherId, createLessonFeeHistoryInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateMaintenanceInput} createMaintenanceInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerCreateMaintenance(createMaintenanceInput: CreateMaintenanceInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerCreateMaintenance(createMaintenanceInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} dummy 
         * @param {CreateManagerInput} createManagerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerCreateManagerUser(dummy: string, createManagerInput: CreateManagerInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerCreateManagerUser(dummy, createManagerInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} dummy 
         * @param {CreateNoticeInput} createNoticeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerCreateNotice(dummy: string, createNoticeInput: CreateNoticeInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerCreateNotice(dummy, createNoticeInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateNoticeCompanyInput} createNoticeCompanyInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerCreateNoticeCompany(createNoticeCompanyInput: CreateNoticeCompanyInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerCreateNoticeCompany(createNoticeCompanyInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {CreateTeacherInput} createTeacherInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerCreateTeacherUser(teacherId: string, createTeacherInput: CreateTeacherInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerCreateTeacherUser(teacherId, createTeacherInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerDeleteAgreement(companyId: string, paymentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerDeleteAgreement(companyId, paymentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerDeleteCompany(companyId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerDeleteCompany(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerDeleteCompanyUser(companyId: string, userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerDeleteCompanyUser(companyId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerDeleteLearnerUser(companyId: string, learnerId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerDeleteLearnerUser(companyId, learnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerDeleteLessonFeeOption(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerDeleteLessonFeeOption(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {DeleteLessonLearnerInput} deleteLessonLearnerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerDeleteLessonLearner(companyId: string, lessonId: string, deleteLessonLearnerInput: DeleteLessonLearnerInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerDeleteLessonLearner(companyId, lessonId, deleteLessonLearnerInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} maintenanceId 
         * @param {string} maintenanceStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerDeleteMaintenance(maintenanceId: number, maintenanceStatus: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerDeleteMaintenance(maintenanceId, maintenanceStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} managerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerDeleteManagerUser(managerId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerDeleteManagerUser(managerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {DeleteAgreementInput} deleteAgreementInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerDeleteMonthlyAgreement(companyId: string, deleteAgreementInput: DeleteAgreementInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerDeleteMonthlyAgreement(companyId, deleteAgreementInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerDeleteNotice(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerDeleteNotice(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerDeleteTeacherUser(teacherId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerDeleteTeacherUser(teacherId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ExistsLearnerInput} existsLearnerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerExistsLearner(existsLearnerInput: ExistsLearnerInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerExistsLearner(existsLearnerInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ExistsLearnerInPlanInput} existsLearnerInPlanInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerExistsLearnerInPlan(existsLearnerInPlanInput: ExistsLearnerInPlanInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerExistsLearnerInPlan(existsLearnerInPlanInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetAvailableCompanies(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetAvailableCompanies(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetCompany(companyId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetCompany(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} sortStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetCompanyList(companyId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, sortStr: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetCompanyList(companyId, searchStatus, searchField, searchStr, limit, page, sortStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetCompanyPlans(companyId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetCompanyPlans(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetCompanyUserList(companyId: string, limit: number, page: number, searchStr: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetCompanyUserList(companyId, limit, page, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetConnectionIdByRoomId(companyId: string, roomId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetConnectionIdByRoomId(companyId, roomId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetEachLearnerStudyRecordsPdf(companyId: string, paymentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetEachLearnerStudyRecordsPdf(companyId, paymentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} teacherId 
         * @param {string} learnerId 
         * @param {string} lessonId 
         * @param {number} approvalFlg 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} futureOnly 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetFutureLessonList(companyId: string, paymentId: number, teacherId: string, learnerId: string, lessonId: string, approvalFlg: number, startPeriod: string, endPeriod: string, futureOnly: number, limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetFutureLessonList(companyId, paymentId, teacherId, learnerId, lessonId, approvalFlg, startPeriod, endPeriod, futureOnly, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} learner 
         * @param {string} learnerId 
         * @param {string} company 
         * @param {string} searchStatus 
         * @param {string} lessonId 
         * @param {number} approvalFlg 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetFutureLessonListBgd(companyId: string, teacherId: string, learner: string, learnerId: string, company: string, searchStatus: string, lessonId: string, approvalFlg: number, startPeriod: string, endPeriod: string, limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetFutureLessonListBgd(companyId, teacherId, learner, learnerId, company, searchStatus, lessonId, approvalFlg, startPeriod, endPeriod, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetLatestPastLessonNote(companyId: string, learnerId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetLatestPastLessonNote(companyId, learnerId, startPeriod, endPeriod, searchField, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetLeanerUserListByLesson(companyId: string, lessonId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetLeanerUserListByLesson(companyId, lessonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetLearnerStudyRecords(companyId: string, learnerId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetLearnerStudyRecords(companyId, learnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetLearnerUserList(companyId: string, learnerId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLearnerUserListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetLearnerUserList(companyId, learnerId, searchStatus, searchField, searchStr, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} lessonId 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetLesson(companyId: string, teacherId: string, lessonId: string, searchField: string, searchStr: string, startPeriod: string, endPeriod: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetLesson(companyId, teacherId, lessonId, searchField, searchStr, startPeriod, endPeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetLessonByCompanyNLessonID(companyId: string, lessonId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetLessonByCompanyNLessonID(companyId, lessonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetLessonByRoomId(companyId: string, roomId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetLessonByRoomId(companyId, roomId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} learnerId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetLessonFeedback(companyId: string, lessonId: string, learnerId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetLessonFeedback(companyId, lessonId, learnerId, startPeriod, endPeriod, searchField, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} learnerId 
         * @param {number} lessonId 
         * @param {string} teacherId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} noneLessonFeedback 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetLessonFeedbackList(companyId: string, paymentId: number, learnerId: string, lessonId: number, teacherId: string, startPeriod: string, endPeriod: string, noneLessonFeedback: number, limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetLessonFeedbackList(companyId, paymentId, learnerId, lessonId, teacherId, startPeriod, endPeriod, noneLessonFeedback, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} learnerId 
         * @param {string} teacherId 
         * @param {string} companyName 
         * @param {string} learnerName 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetLessonFeedbackListBgd(companyId: string, paymentId: number, learnerId: string, teacherId: string, companyName: string, learnerName: string, startPeriod: string, endPeriod: string, limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetLessonFeedbackListBgd(companyId, paymentId, learnerId, teacherId, companyName, learnerName, startPeriod, endPeriod, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetLessonFees(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetLessonFees(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} learner 
         * @param {string} learnerId 
         * @param {string} company 
         * @param {string} searchStatus 
         * @param {string} lessonId 
         * @param {number} approvalFlg 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetLessonListBgd(companyId: string, teacherId: string, learner: string, learnerId: string, company: string, searchStatus: string, lessonId: string, approvalFlg: number, startPeriod: string, endPeriod: string, limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetLessonListBgd(companyId, teacherId, learner, learnerId, company, searchStatus, lessonId, approvalFlg, startPeriod, endPeriod, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetLessonNote(companyId: string, lessonId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetLessonNote(companyId, lessonId, startPeriod, endPeriod, searchField, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetLessonNoteList(companyId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetLessonNoteList(companyId, startPeriod, endPeriod, searchField, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetLoginUserInfo(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetLoginUserInfo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetMaintenance(page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetMaintenance(page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetManagerUserList(limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetManagerUserList(limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} noticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetNotice(noticeId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetNotice(noticeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} noticeId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetNoticeCompany(noticeId: string, companyId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetNoticeCompany(noticeId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} noticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetNoticeCompanyForManager(noticeId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetNoticeCompanyForManager(noticeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} targetNumber 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetNoticeList(targetNumber: number, limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetNoticeList(targetNumber, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetOperationalStatus(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetOperationalStatus(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} teacherId 
         * @param {string} learnerId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} noneLessonNote 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetPastLessonList(companyId: string, paymentId: number, teacherId: string, learnerId: string, startPeriod: string, endPeriod: string, noneLessonNote: number, limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetPastLessonList(companyId, paymentId, teacherId, learnerId, startPeriod, endPeriod, noneLessonNote, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} companyName 
         * @param {string} lessonId 
         * @param {string} learnerName 
         * @param {string} learnerId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetPastLessonListBgd(companyId: string, teacherId: string, companyName: string, lessonId: string, learnerName: string, learnerId: string, startPeriod: string, endPeriod: string, limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetPastLessonListBgd(companyId, teacherId, companyName, lessonId, learnerName, learnerId, startPeriod, endPeriod, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetPaymentCompany(companyId: string, paymentId: number, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetPaymentCompany(companyId, paymentId, searchStatus, searchField, searchStr, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} targetMonth 
         * @param {number} paymentId 
         * @param {string} learnerId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetPaymentCompanyList(companyId: string, targetMonth: string, paymentId: number, learnerId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetPaymentCompanyList(companyId, targetMonth, paymentId, learnerId, searchStatus, searchField, searchStr, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetPaymentLearnerDetails(companyId: string, paymentId: number, learnerId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetPaymentLearnerDetails(companyId, paymentId, learnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} learnerId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {number} searchAffiliationId 
         * @param {string} searchLastStudyBucket 
         * @param {string} sortStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetPaymentLearnerList(companyId: string, paymentId: number, learnerId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, searchAffiliationId: number, searchLastStudyBucket: string, sortStr: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetPaymentLearnerList(companyId, paymentId, learnerId, searchStatus, searchField, searchStr, limit, page, searchAffiliationId, searchLastStudyBucket, sortStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} paymentId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetReportStudyRecords(companyId: string, paymentId: string, yearMonth: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetReportStudyRecords(companyId, paymentId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} endpoint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetStatus(endpoint: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetStatus(endpoint, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetStudyRecords(companyId: string, learnerId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetStudyRecords(companyId, learnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetSystemLearnerNotice(learnerId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetSystemLearnerNotice(learnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetTargetMonthPaymentCompanyList(companyId: string, learnerId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetTargetMonthPaymentCompanyList(companyId, learnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetTeacherByTeacherId(teacherId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetTeacherByTeacherId(teacherId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} yearMonth 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetTeacherLessonFee(companyId: string, teacherId: string, yearMonth: string, endPeriod: string, searchField: string, searchStr: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetTeacherLessonFee(companyId, teacherId, yearMonth, endPeriod, searchField, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {string} yearMonth 
         * @param {number} status 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetTeacherLessonFeeList(teacherId: string, yearMonth: string, status: number, limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetTeacherLessonFeeList(teacherId, yearMonth, status, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetTeacherUserList(teacherId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetTeacherUserList(teacherId, searchStatus, searchField, searchStr, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerGetZoomToken(roomId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerGetZoomToken(roomId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerImportCompanyUsersCsv(file: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerImportCompanyUsersCsv(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerImportLearnersCsv(file: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerImportLearnersCsv(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} senderId 
         * @param {string} receiverId 
         * @param {string} message 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerPostZoomChat(companyId: string, lessonId: string, senderId: string, receiverId: string, message: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerPostZoomChat(companyId, lessonId, senderId, receiverId, message, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PushSubscribeDto} pushSubscribeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerPushSubscribe(pushSubscribeDto: PushSubscribeDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerPushSubscribe(pushSubscribeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PushUnsubscribeDto} pushUnsubscribeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerPushUnsubscribe(pushUnsubscribeDto: PushUnsubscribeDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerPushUnsubscribe(pushUnsubscribeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} roomId 
         * @param {CreateRoomChatInput} createRoomChatInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerPutCompanyRoomChat(companyId: string, roomId: string, createRoomChatInput: CreateRoomChatInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerPutCompanyRoomChat(companyId, roomId, createRoomChatInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} releaseFlg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerReleaseNotice(id: string, releaseFlg: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerReleaseNotice(id, releaseFlg, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} userId 
         * @param {ResetCompanyUserPasswordInput} resetCompanyUserPasswordInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerResetCompanyUserPassword(companyId: string, userId: string, resetCompanyUserPasswordInput: ResetCompanyUserPasswordInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerResetCompanyUserPassword(companyId, userId, resetCompanyUserPasswordInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {ResetLearnerPasswordInput} resetLearnerPasswordInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerResetLearnerPassword(companyId: string, learnerId: string, resetLearnerPasswordInput: ResetLearnerPasswordInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerResetLearnerPassword(companyId, learnerId, resetLearnerPasswordInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} mailSubject 
         * @param {string} mailerId 
         * @param {string} mailerName 
         * @param {string} kinds 
         * @param {string} mailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerSendInquiryEmail(mailSubject: string, mailerId: string, mailerName: string, kinds: string, mailBody: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerSendInquiryEmail(mailSubject, mailerId, mailerName, kinds, mailBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} sendQueryEmail 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerSendQueryEmail(companyId: string, sendQueryEmail: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerSendQueryEmail(companyId, sendQueryEmail, startPeriod, endPeriod, searchField, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {UpdateAgreementInput} updateAgreementInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerUpdateAgreement(companyId: string, updateAgreementInput: UpdateAgreementInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerUpdateAgreement(companyId, updateAgreementInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} paymentId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerUpdateAgreementPlan(companyId: string, paymentId: string, body: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerUpdateAgreementPlan(companyId, paymentId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {string} yearMonth 
         * @param {number} billedFlg 
         * @param {number} finalFee 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerUpdateBillingStatus(teacherId: string, yearMonth: string, billedFlg: number, finalFee: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerUpdateBillingStatus(teacherId, yearMonth, billedFlg, finalFee, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {UpdateCompanyInput} updateCompanyInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerUpdateCompany(companyId: string, updateCompanyInput: UpdateCompanyInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerUpdateCompany(companyId, updateCompanyInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} maintenanceId 
         * @param {boolean} immediateFlg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerUpdateDeMaintenance(maintenanceId: number, immediateFlg: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerUpdateDeMaintenance(maintenanceId, immediateFlg, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {UpdateLearnerInput} updateLearnerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerUpdateLearnerUser(companyId: string, learnerId: string, updateLearnerInput: UpdateLearnerInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerUpdateLearnerUser(companyId, learnerId, updateLearnerInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerUpdateLesson(companyId: string, lessonId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerUpdateLesson(companyId, lessonId, startPeriod, endPeriod, searchField, searchStr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} feedback 
         * @param {string} learnerIdCsv 
         * @param {string} [adminComment] 
         * @param {string} [filesMetadata] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerUpdateLessonFeedback(companyId: string, lessonId: string, feedback: string, learnerIdCsv: string, adminComment?: string, filesMetadata?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerUpdateLessonFeedback(companyId, lessonId, feedback, learnerIdCsv, adminComment, filesMetadata, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} learnerId 
         * @param {boolean} lessonLearnerStatus 
         * @param {UpdateLessonLearnerInput} updateLessonLearnerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerUpdateLessonLearnerStatus(companyId: string, lessonId: string, learnerId: string, lessonLearnerStatus: boolean, updateLessonLearnerInput: UpdateLessonLearnerInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerUpdateLessonLearnerStatus(companyId, lessonId, learnerId, lessonLearnerStatus, updateLessonLearnerInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {UpdateLessonNoteInput} updateLessonNoteInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerUpdateLessonNote(companyId: string, lessonId: string, updateLessonNoteInput: UpdateLessonNoteInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerUpdateLessonNote(companyId, lessonId, updateLessonNoteInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerUpdateLessonStatusTeacher(companyId: string, lessonId: string, status: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerUpdateLessonStatusTeacher(companyId, lessonId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} maintenanceId 
         * @param {CreateMaintenanceInput} createMaintenanceInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerUpdateMaintenance(maintenanceId: number, createMaintenanceInput: CreateMaintenanceInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerUpdateMaintenance(maintenanceId, createMaintenanceInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateNoticeInput} createNoticeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerUpdateNotice(id: string, createNoticeInput: CreateNoticeInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerUpdateNotice(id, createNoticeInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} noticeId 
         * @param {boolean} readStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerUpdateSystemLearnerNoticeReadStatus(noticeId: string, readStatus: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerUpdateSystemLearnerNoticeReadStatus(noticeId, readStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {ConnectionId} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerUpdateTeacherConnectionId(companyId: string, teacherId: string, connectionId: ConnectionId, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerUpdateTeacherConnectionId(companyId, teacherId, connectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {UpdateTeacherInput} updateTeacherInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerUpdateTeacherUser(teacherId: string, updateTeacherInput: UpdateTeacherInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerUpdateTeacherUser(teacherId, updateTeacherInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} theme 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerUpdateThemeOnLesson(companyId: string, lessonId: string, theme: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerUpdateThemeOnLesson(companyId, lessonId, theme, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsControllerVerifyCognitoUserEmail(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsControllerVerifyCognitoUserEmail(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sandboxControllerCognitoSandbox(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sandboxControllerCognitoSandbox(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sandboxControllerMailSandbox(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sandboxControllerMailSandbox(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} jlptLevel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async studyRecordsControllerGetCompletedStages(jlptLevel: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompletedStagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.studyRecordsControllerGetCompletedStages(jlptLevel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SaveStudyRecordStageInput} saveStudyRecordStageInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async studyRecordsControllerSaveStudyRecord(saveStudyRecordStageInput: SaveStudyRecordStageInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.studyRecordsControllerSaveStudyRecord(saveStudyRecordStageInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateSurveyResponseDto} createSurveyResponseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async surveyControllerCreateResponse(createSurveyResponseDto: CreateSurveyResponseDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSurveyResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.surveyControllerCreateResponse(createSurveyResponseDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async surveyControllerGetLatestSurvey(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLatestSurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.surveyControllerGetLatestSurvey(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teacherControllerGetLearnersWithoutFeedback(teacherId: string, limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLearnersWithoutFeedbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teacherControllerGetLearnersWithoutFeedback(teacherId, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teacherControllerGetMostRecentScheduledLesson(teacherId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMostRecentScheduledLessonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teacherControllerGetMostRecentScheduledLesson(teacherId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teacherControllerGetNotUpdatedNoteLessons(teacherId: string, limit: number, page: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNotUpdatedNoteLessonsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teacherControllerGetNotUpdatedNoteLessons(teacherId, limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teacherControllerGetUnaprovedLessons(teacherId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnApprovedLessonsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teacherControllerGetUnaprovedLessons(teacherId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LessonLoggingInput} lessonLoggingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userEventControllerLogLessonEvent(lessonLoggingInput: LessonLoggingInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userEventControllerLogLessonEvent(lessonLoggingInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LoggingInput} loggingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userEventControllerLoggingEvent(loggingInput: LoggingInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userEventControllerLoggingEvent(loggingInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LoggingInput} loggingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userEventControllerLoggingEventByNotAuth(loggingInput: LoggingInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userEventControllerLoggingEventByNotAuth(loggingInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * APIApi - factory interface
 * @export
 */
export const APIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = APIApiFp(configuration)
    return {
        /**
         * 
         * @param {string} companyId 
         * @param {ApplyAffiliationTypeTemplateDto} applyAffiliationTypeTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerApplyTypeTemplate(companyId: string, applyAffiliationTypeTemplateDto: ApplyAffiliationTypeTemplateDto, options?: any): AxiosPromise<object> {
            return localVarFp.affiliationsControllerApplyTypeTemplate(companyId, applyAffiliationTypeTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {AssignAffiliationDto} assignAffiliationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerAssign(companyId: string, assignAffiliationDto: AssignAffiliationDto, options?: any): AxiosPromise<object> {
            return localVarFp.affiliationsControllerAssign(companyId, assignAffiliationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} assignmentId 
         * @param {ChangeAffiliationRoleDto} changeAffiliationRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerChangeAssignmentRole(companyId: string, assignmentId: number, changeAffiliationRoleDto: ChangeAffiliationRoleDto, options?: any): AxiosPromise<object> {
            return localVarFp.affiliationsControllerChangeAssignmentRole(companyId, assignmentId, changeAffiliationRoleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CreateAffiliationNodeDto} createAffiliationNodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerCreateNode(companyId: string, createAffiliationNodeDto: CreateAffiliationNodeDto, options?: any): AxiosPromise<object> {
            return localVarFp.affiliationsControllerCreateNode(companyId, createAffiliationNodeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CreateAffiliationTypeDto} createAffiliationTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerCreateType(companyId: string, createAffiliationTypeDto: CreateAffiliationTypeDto, options?: any): AxiosPromise<object> {
            return localVarFp.affiliationsControllerCreateType(companyId, createAffiliationTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} affiliationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerDeleteNode(companyId: string, affiliationId: number, options?: any): AxiosPromise<object> {
            return localVarFp.affiliationsControllerDeleteNode(companyId, affiliationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} typeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerDeleteType(companyId: string, typeId: number, options?: any): AxiosPromise<object> {
            return localVarFp.affiliationsControllerDeleteType(companyId, typeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerGetMyAffiliations(companyId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.affiliationsControllerGetMyAffiliations(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerGetTree(companyId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.affiliationsControllerGetTree(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} dryRun 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerImportLearnerAffiliations(companyId: string, dryRun: string, file: any, options?: any): AxiosPromise<object> {
            return localVarFp.affiliationsControllerImportLearnerAffiliations(companyId, dryRun, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {'LEARNER' | 'COMPANY_USER'} [userType] 
         * @param {string} [userId] 
         * @param {number} [affiliationId] 
         * @param {boolean} [includeDescendants] affiliation_id 指定時、配下の所属も含める
         * @param {string} [searchStr] 氏名・ニックネーム・メールアドレスの部分一致
         * @param {number} [limit] 1ページの件数(既定 50、最大 1000)
         * @param {number} [page] ページ番号(1始まり)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerListAssignments(companyId: string, userType?: 'LEARNER' | 'COMPANY_USER', userId?: string, affiliationId?: number, includeDescendants?: boolean, searchStr?: string, limit?: number, page?: number, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.affiliationsControllerListAssignments(companyId, userType, userId, affiliationId, includeDescendants, searchStr, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerUnassign(companyId: string, assignmentId: number, options?: any): AxiosPromise<object> {
            return localVarFp.affiliationsControllerUnassign(companyId, assignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} affiliationId 
         * @param {UpdateAffiliationNodeDto} updateAffiliationNodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerUpdateNode(companyId: string, affiliationId: number, updateAffiliationNodeDto: UpdateAffiliationNodeDto, options?: any): AxiosPromise<object> {
            return localVarFp.affiliationsControllerUpdateNode(companyId, affiliationId, updateAffiliationNodeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} typeId 
         * @param {UpdateAffiliationTypeDto} updateAffiliationTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        affiliationsControllerUpdateType(companyId: string, typeId: number, updateAffiliationTypeDto: UpdateAffiliationTypeDto, options?: any): AxiosPromise<object> {
            return localVarFp.affiliationsControllerUpdateType(companyId, typeId, updateAffiliationTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ForgotCompanyPasswordInput} forgotCompanyPasswordInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyAuthControllerForgotCompanyPassword(forgotCompanyPasswordInput: ForgotCompanyPasswordInput, options?: any): AxiosPromise<object> {
            return localVarFp.companyAuthControllerForgotCompanyPassword(forgotCompanyPasswordInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerGetLearners(companyId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.dashboardControllerGetLearners(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardControllerGetMe(companyId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.dashboardControllerGetMe(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateForBeginnersInquiryInput} createForBeginnersInquiryInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inquiryControllerSendForBeginnersInquiryEmail(createForBeginnersInquiryInput: CreateForBeginnersInquiryInput, options?: any): AxiosPromise<object> {
            return localVarFp.inquiryControllerSendForBeginnersInquiryEmail(createForBeginnersInquiryInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateInquiryInput} createInquiryInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inquiryControllerSendInquiryEmail(createInquiryInput: CreateInquiryInput, options?: any): AxiosPromise<object> {
            return localVarFp.inquiryControllerSendInquiryEmail(createInquiryInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ForgotLearnerPasswordInput} forgotLearnerPasswordInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learnerAuthControllerForgotLearnerPassword(forgotLearnerPasswordInput: ForgotLearnerPasswordInput, options?: any): AxiosPromise<object> {
            return localVarFp.learnerAuthControllerForgotLearnerPassword(forgotLearnerPasswordInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learnerControllerCompleteCheckTest(options?: any): AxiosPromise<void> {
            return localVarFp.learnerControllerCompleteCheckTest(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learnerControllerGetCheckTestStatus(options?: any): AxiosPromise<GetCheckTestStatusResponse> {
            return localVarFp.learnerControllerGetCheckTestStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} learnerId 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learnerControllerGetLearnerStudyTimeInfo(learnerId: string, companyId: number, options?: any): AxiosPromise<GetLearnerStudyTimeResponse> {
            return localVarFp.learnerControllerGetLearnerStudyTimeInfo(learnerId, companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} learnerId 
         * @param {number} companyId 
         * @param {number} [paymentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learnerControllerGetLearnerTotalLessonsVsParticipatedLessons(learnerId: string, companyId: number, paymentId?: number, options?: any): AxiosPromise<GetLearnerTotalLessonsVsParticipatedLessonsResponse> {
            return localVarFp.learnerControllerGetLearnerTotalLessonsVsParticipatedLessons(learnerId, companyId, paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learnerControllerIsHighestStageCompleted(options?: any): AxiosPromise<GetHighestStageCompletedResponse> {
            return localVarFp.learnerControllerIsHighestStageCompleted(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lessonControllerGetDownloadUrl(fileUrl: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.lessonControllerGetDownloadUrl(fileUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} lessonId 
         * @param {string} roomId 
         * @param {number} timestamp 
         * @param {string} mimeType 
         * @param {string} targetUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lessonControllerGetUploadUrlOfRecordedFile(lessonId: string, roomId: string, timestamp: number, mimeType: string, targetUserId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.lessonControllerGetUploadUrlOfRecordedFile(lessonId, roomId, timestamp, mimeType, targetUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerCreateActiveLearnerLog(learnerId: string, options?: any): AxiosPromise<CreateActiveLearnerLogResponse> {
            return localVarFp.mobileAppControllerCreateActiveLearnerLog(learnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} lessonId 
         * @param {string} companyId 
         * @param {string} userId 
         * @param {LessonLogType} lessonLogType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerCreateLessonLog(lessonId: string, companyId: string, userId: string, lessonLogType: LessonLogType, options?: any): AxiosPromise<CreateLessonLogResponse> {
            return localVarFp.mobileAppControllerCreateLessonLog(lessonId, companyId, userId, lessonLogType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerDeactivateLearnerEndpoints(companyId: string, learnerId: string, options?: any): AxiosPromise<DeactivateLearnerEndPointsResponse> {
            return localVarFp.mobileAppControllerDeactivateLearnerEndpoints(companyId, learnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} learnerId 
         * @param {boolean} onlyFuture 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetApprovedLessons(learnerId: string, onlyFuture: boolean, options?: any): AxiosPromise<GetApprovedLessonsResponse> {
            return localVarFp.mobileAppControllerGetApprovedLessons(learnerId, onlyFuture, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetLearnerActiveEndpointCount(companyId: string, learnerId: string, options?: any): AxiosPromise<GetLearnerActiveEndPointCountResponse> {
            return localVarFp.mobileAppControllerGetLearnerActiveEndpointCount(companyId, learnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetLearnerByEmail(companyId: string, email: string, options?: any): AxiosPromise<GetLearnerByEmailResponse> {
            return localVarFp.mobileAppControllerGetLearnerByEmail(companyId, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetLearnerEndpoint(companyId: string, learnerId: string, options?: any): AxiosPromise<GetLearnerDetailsResponse> {
            return localVarFp.mobileAppControllerGetLearnerEndpoint(companyId, learnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetLernerById(companyId: string, learnerId: string, options?: any): AxiosPromise<GetLearnerByIdResponse> {
            return localVarFp.mobileAppControllerGetLernerById(companyId, learnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetLoginedLearnerDetail(options?: any): AxiosPromise<GetLearnerDetailsResponse> {
            return localVarFp.mobileAppControllerGetLoginedLearnerDetail(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetMostRecentScheduledLesson(options?: any): AxiosPromise<GetMostRecentScheduledLessonResponse> {
            return localVarFp.mobileAppControllerGetMostRecentScheduledLesson(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} noticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetNoticeRead(noticeId: number, options?: any): AxiosPromise<GetNoticeReadResponse> {
            return localVarFp.mobileAppControllerGetNoticeRead(noticeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetNoticeUnreadCount(userName: string, options?: any): AxiosPromise<GetNoticeUnreadCountResponse> {
            return localVarFp.mobileAppControllerGetNoticeUnreadCount(userName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetNotices(limit: number, page: number, options?: any): AxiosPromise<GetNoticesResponse> {
            return localVarFp.mobileAppControllerGetNotices(limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetPastLessons(limit: number, page: number, options?: any): AxiosPromise<GetPastLessonsResponse> {
            return localVarFp.mobileAppControllerGetPastLessons(limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetPushMsg(companyId: string, options?: any): AxiosPromise<GetPushMsgResponse> {
            return localVarFp.mobileAppControllerGetPushMsg(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} pushMsgQId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetPushMsgLog(companyId: string, pushMsgQId: number, options?: any): AxiosPromise<GetPushMsgLogResponse> {
            return localVarFp.mobileAppControllerGetPushMsgLog(companyId, pushMsgQId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetPushVapidPublicKey(companyId: string, options?: any): AxiosPromise<GetPushVapidPublicKeyResponse> {
            return localVarFp.mobileAppControllerGetPushVapidPublicKey(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerGetStudyRecords(userName: string, options?: any): AxiosPromise<GetStudyRecordsResponse> {
            return localVarFp.mobileAppControllerGetStudyRecords(userName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DrillParam} drillParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerPostStudyRecordDrill(drillParam: DrillParam, options?: any): AxiosPromise<PostStudyRecordStoryResponse> {
            return localVarFp.mobileAppControllerPostStudyRecordDrill(drillParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StudyResult} studyResult 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerPostStudyRecordStory(studyResult: StudyResult, options?: any): AxiosPromise<PostStudyRecordStoryResponse> {
            return localVarFp.mobileAppControllerPostStudyRecordStory(studyResult, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateDrillResult} updateDrillResult 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerPutDrillRecord(updateDrillResult: UpdateDrillResult, options?: any): AxiosPromise<PutDrillRecordResponse> {
            return localVarFp.mobileAppControllerPutDrillRecord(updateDrillResult, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} noticeId 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerPutNoticeRead(companyId: string, noticeId: number, userName: string, options?: any): AxiosPromise<PutNoticeReadResponse> {
            return localVarFp.mobileAppControllerPutNoticeRead(companyId, noticeId, userName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateStudyResult} updateStudyResult 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerPutStudyRecord(updateStudyResult: UpdateStudyResult, options?: any): AxiosPromise<PutStudyRecordRecordResponse> {
            return localVarFp.mobileAppControllerPutStudyRecord(updateStudyResult, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RecordStudySessionInput} recordStudySessionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerRecordStudySession(recordStudySessionInput: RecordStudySessionInput, options?: any): AxiosPromise<RecordStudySessionResponse> {
            return localVarFp.mobileAppControllerRecordStudySession(recordStudySessionInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StartStudySessionInput} startStudySessionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerStartStudySession(startStudySessionInput: StartStudySessionInput, options?: any): AxiosPromise<StartStudySessionResponse> {
            return localVarFp.mobileAppControllerStartStudySession(startStudySessionInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {ConnectionId} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerUpdateLearnerConnectionId(companyId: string, learnerId: string, connectionId: ConnectionId, options?: any): AxiosPromise<UpdateLearnerConnectionIdResponse> {
            return localVarFp.mobileAppControllerUpdateLearnerConnectionId(companyId, learnerId, connectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerUpdateLearnerEmail(companyId: string, learnerId: string, email: string, options?: any): AxiosPromise<UpdateLearnerEmailResponse> {
            return localVarFp.mobileAppControllerUpdateLearnerEmail(companyId, learnerId, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {string} emailSendFlg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerUpdateLearnerEmailSendFlg(companyId: string, learnerId: string, emailSendFlg: string, options?: any): AxiosPromise<UpdateLearnerEmailSendFlgResponse> {
            return localVarFp.mobileAppControllerUpdateLearnerEmailSendFlg(companyId, learnerId, emailSendFlg, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {LearnerEndpoint} learnerEndpoint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerUpsertLearnerEndpoint(companyId: string, learnerId: string, learnerEndpoint: LearnerEndpoint, options?: any): AxiosPromise<UpsertLearnerEndPointResponse> {
            return localVarFp.mobileAppControllerUpsertLearnerEndpoint(companyId, learnerId, learnerEndpoint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {PushMsg} pushMsg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerUpsertPushMsg(companyId: string, pushMsg: PushMsg, options?: any): AxiosPromise<UpsertPushMsgResponse> {
            return localVarFp.mobileAppControllerUpsertPushMsg(companyId, pushMsg, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {PushMsgLog} pushMsgLog 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerUpsertPushMsgLog(companyId: string, pushMsgLog: PushMsgLog, options?: any): AxiosPromise<UpsertPushMsgLogResponse> {
            return localVarFp.mobileAppControllerUpsertPushMsgLog(companyId, pushMsgLog, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerVerifyCognitoUserEmail(options?: any): AxiosPromise<VerifyCognitoUserEmailResponse> {
            return localVarFp.mobileAppControllerVerifyCognitoUserEmail(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {string} email 
         * @param {VerifyInfo} verifyInfo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mobileAppControllerVerifyLearnerEmail(companyId: string, learnerId: string, email: string, verifyInfo: VerifyInfo, options?: any): AxiosPromise<VerifyLearnerEmailResponse> {
            return localVarFp.mobileAppControllerVerifyLearnerEmail(companyId, learnerId, email, verifyInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerApprovalLessonTeacher(companyId: string, lessonId: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerApprovalLessonTeacher(companyId, lessonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {CancelLessonInput} cancelLessonInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCancelLesson(companyId: string, lessonId: string, cancelLessonInput: CancelLessonInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerCancelLesson(companyId, lessonId, cancelLessonInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} teacherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerChangeLessonTeacher(companyId: string, lessonId: string, teacherId: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerChangeLessonTeacher(companyId, lessonId, teacherId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateActiveCompanyUserLog(userId: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerCreateActiveCompanyUserLog(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CreateAgreementInput} createAgreementInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateAgreement(companyId: string, createAgreementInput: CreateAgreementInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerCreateAgreement(companyId, createAgreementInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CreateCompanyInput} createCompanyInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateCompany(companyId: string, createCompanyInput: CreateCompanyInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerCreateCompany(companyId, createCompanyInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {CreateCompanyUserInput} createCompanyUserInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateCompanyUser(companyId: string, createCompanyUserInput: CreateCompanyUserInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerCreateCompanyUser(companyId, createCompanyUserInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateErrorLog} createErrorLog 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateErrorLog(createErrorLog: CreateErrorLog, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerCreateErrorLog(createErrorLog, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {CreateLearnerInput} createLearnerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateLearnerUser(companyId: string, paymentId: number, createLearnerInput: CreateLearnerInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerCreateLearnerUser(companyId, paymentId, createLearnerInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} startDatetime 
         * @param {string} endDatetime 
         * @param {CreateLessonInput} createLessonInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateLesson(companyId: string, teacherId: string, startDatetime: string, endDatetime: string, createLessonInput: CreateLessonInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerCreateLesson(companyId, teacherId, startDatetime, endDatetime, createLessonInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {CreateLessonFeeInput} createLessonFeeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateLessonFee(teacherId: string, createLessonFeeInput: CreateLessonFeeInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerCreateLessonFee(teacherId, createLessonFeeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {CreateLessonFeeHistoryInput} createLessonFeeHistoryInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateLessonFeeHistory(teacherId: string, createLessonFeeHistoryInput: CreateLessonFeeHistoryInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerCreateLessonFeeHistory(teacherId, createLessonFeeHistoryInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateMaintenanceInput} createMaintenanceInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateMaintenance(createMaintenanceInput: CreateMaintenanceInput, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsControllerCreateMaintenance(createMaintenanceInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} dummy 
         * @param {CreateManagerInput} createManagerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateManagerUser(dummy: string, createManagerInput: CreateManagerInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerCreateManagerUser(dummy, createManagerInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} dummy 
         * @param {CreateNoticeInput} createNoticeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateNotice(dummy: string, createNoticeInput: CreateNoticeInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerCreateNotice(dummy, createNoticeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateNoticeCompanyInput} createNoticeCompanyInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateNoticeCompany(createNoticeCompanyInput: CreateNoticeCompanyInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerCreateNoticeCompany(createNoticeCompanyInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {CreateTeacherInput} createTeacherInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerCreateTeacherUser(teacherId: string, createTeacherInput: CreateTeacherInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerCreateTeacherUser(teacherId, createTeacherInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteAgreement(companyId: string, paymentId: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerDeleteAgreement(companyId, paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteCompany(companyId: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerDeleteCompany(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteCompanyUser(companyId: string, userId: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerDeleteCompanyUser(companyId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteLearnerUser(companyId: string, learnerId: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerDeleteLearnerUser(companyId, learnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteLessonFeeOption(id: number, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerDeleteLessonFeeOption(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {DeleteLessonLearnerInput} deleteLessonLearnerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteLessonLearner(companyId: string, lessonId: string, deleteLessonLearnerInput: DeleteLessonLearnerInput, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsControllerDeleteLessonLearner(companyId, lessonId, deleteLessonLearnerInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} maintenanceId 
         * @param {string} maintenanceStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteMaintenance(maintenanceId: number, maintenanceStatus: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerDeleteMaintenance(maintenanceId, maintenanceStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} managerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteManagerUser(managerId: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerDeleteManagerUser(managerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {DeleteAgreementInput} deleteAgreementInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteMonthlyAgreement(companyId: string, deleteAgreementInput: DeleteAgreementInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerDeleteMonthlyAgreement(companyId, deleteAgreementInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteNotice(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerDeleteNotice(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerDeleteTeacherUser(teacherId: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerDeleteTeacherUser(teacherId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExistsLearnerInput} existsLearnerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerExistsLearner(existsLearnerInput: ExistsLearnerInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerExistsLearner(existsLearnerInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExistsLearnerInPlanInput} existsLearnerInPlanInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerExistsLearnerInPlan(existsLearnerInPlanInput: ExistsLearnerInPlanInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerExistsLearnerInPlan(existsLearnerInPlanInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetAvailableCompanies(options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetAvailableCompanies(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetCompany(companyId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetCompany(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} sortStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetCompanyList(companyId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, sortStr: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetCompanyList(companyId, searchStatus, searchField, searchStr, limit, page, sortStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetCompanyPlans(companyId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetCompanyPlans(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetCompanyUserList(companyId: string, limit: number, page: number, searchStr: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetCompanyUserList(companyId, limit, page, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetConnectionIdByRoomId(companyId: string, roomId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetConnectionIdByRoomId(companyId, roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetEachLearnerStudyRecordsPdf(companyId: string, paymentId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetEachLearnerStudyRecordsPdf(companyId, paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} teacherId 
         * @param {string} learnerId 
         * @param {string} lessonId 
         * @param {number} approvalFlg 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} futureOnly 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetFutureLessonList(companyId: string, paymentId: number, teacherId: string, learnerId: string, lessonId: string, approvalFlg: number, startPeriod: string, endPeriod: string, futureOnly: number, limit: number, page: number, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetFutureLessonList(companyId, paymentId, teacherId, learnerId, lessonId, approvalFlg, startPeriod, endPeriod, futureOnly, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} learner 
         * @param {string} learnerId 
         * @param {string} company 
         * @param {string} searchStatus 
         * @param {string} lessonId 
         * @param {number} approvalFlg 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetFutureLessonListBgd(companyId: string, teacherId: string, learner: string, learnerId: string, company: string, searchStatus: string, lessonId: string, approvalFlg: number, startPeriod: string, endPeriod: string, limit: number, page: number, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetFutureLessonListBgd(companyId, teacherId, learner, learnerId, company, searchStatus, lessonId, approvalFlg, startPeriod, endPeriod, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLatestPastLessonNote(companyId: string, learnerId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetLatestPastLessonNote(companyId, learnerId, startPeriod, endPeriod, searchField, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLeanerUserListByLesson(companyId: string, lessonId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetLeanerUserListByLesson(companyId, lessonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLearnerStudyRecords(companyId: string, learnerId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetLearnerStudyRecords(companyId, learnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLearnerUserList(companyId: string, learnerId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, options?: any): AxiosPromise<GetLearnerUserListResponse> {
            return localVarFp.organizationsControllerGetLearnerUserList(companyId, learnerId, searchStatus, searchField, searchStr, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} lessonId 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLesson(companyId: string, teacherId: string, lessonId: string, searchField: string, searchStr: string, startPeriod: string, endPeriod: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetLesson(companyId, teacherId, lessonId, searchField, searchStr, startPeriod, endPeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonByCompanyNLessonID(companyId: string, lessonId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetLessonByCompanyNLessonID(companyId, lessonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonByRoomId(companyId: string, roomId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetLessonByRoomId(companyId, roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} learnerId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonFeedback(companyId: string, lessonId: string, learnerId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetLessonFeedback(companyId, lessonId, learnerId, startPeriod, endPeriod, searchField, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} learnerId 
         * @param {number} lessonId 
         * @param {string} teacherId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} noneLessonFeedback 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonFeedbackList(companyId: string, paymentId: number, learnerId: string, lessonId: number, teacherId: string, startPeriod: string, endPeriod: string, noneLessonFeedback: number, limit: number, page: number, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetLessonFeedbackList(companyId, paymentId, learnerId, lessonId, teacherId, startPeriod, endPeriod, noneLessonFeedback, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} learnerId 
         * @param {string} teacherId 
         * @param {string} companyName 
         * @param {string} learnerName 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonFeedbackListBgd(companyId: string, paymentId: number, learnerId: string, teacherId: string, companyName: string, learnerName: string, startPeriod: string, endPeriod: string, limit: number, page: number, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetLessonFeedbackListBgd(companyId, paymentId, learnerId, teacherId, companyName, learnerName, startPeriod, endPeriod, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonFees(options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetLessonFees(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} learner 
         * @param {string} learnerId 
         * @param {string} company 
         * @param {string} searchStatus 
         * @param {string} lessonId 
         * @param {number} approvalFlg 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonListBgd(companyId: string, teacherId: string, learner: string, learnerId: string, company: string, searchStatus: string, lessonId: string, approvalFlg: number, startPeriod: string, endPeriod: string, limit: number, page: number, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetLessonListBgd(companyId, teacherId, learner, learnerId, company, searchStatus, lessonId, approvalFlg, startPeriod, endPeriod, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonNote(companyId: string, lessonId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetLessonNote(companyId, lessonId, startPeriod, endPeriod, searchField, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLessonNoteList(companyId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetLessonNoteList(companyId, startPeriod, endPeriod, searchField, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetLoginUserInfo(options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetLoginUserInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetMaintenance(page: number, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsControllerGetMaintenance(page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetManagerUserList(limit: number, page: number, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetManagerUserList(limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} noticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetNotice(noticeId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetNotice(noticeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} noticeId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetNoticeCompany(noticeId: string, companyId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetNoticeCompany(noticeId, companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} noticeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetNoticeCompanyForManager(noticeId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetNoticeCompanyForManager(noticeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} targetNumber 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetNoticeList(targetNumber: number, limit: number, page: number, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetNoticeList(targetNumber, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetOperationalStatus(options?: any): AxiosPromise<void> {
            return localVarFp.organizationsControllerGetOperationalStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} teacherId 
         * @param {string} learnerId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} noneLessonNote 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetPastLessonList(companyId: string, paymentId: number, teacherId: string, learnerId: string, startPeriod: string, endPeriod: string, noneLessonNote: number, limit: number, page: number, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetPastLessonList(companyId, paymentId, teacherId, learnerId, startPeriod, endPeriod, noneLessonNote, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} companyName 
         * @param {string} lessonId 
         * @param {string} learnerName 
         * @param {string} learnerId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetPastLessonListBgd(companyId: string, teacherId: string, companyName: string, lessonId: string, learnerName: string, learnerId: string, startPeriod: string, endPeriod: string, limit: number, page: number, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetPastLessonListBgd(companyId, teacherId, companyName, lessonId, learnerName, learnerId, startPeriod, endPeriod, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetPaymentCompany(companyId: string, paymentId: number, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetPaymentCompany(companyId, paymentId, searchStatus, searchField, searchStr, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} targetMonth 
         * @param {number} paymentId 
         * @param {string} learnerId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetPaymentCompanyList(companyId: string, targetMonth: string, paymentId: number, learnerId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetPaymentCompanyList(companyId, targetMonth, paymentId, learnerId, searchStatus, searchField, searchStr, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetPaymentLearnerDetails(companyId: string, paymentId: number, learnerId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetPaymentLearnerDetails(companyId, paymentId, learnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {number} paymentId 
         * @param {string} learnerId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {number} searchAffiliationId 
         * @param {string} searchLastStudyBucket 
         * @param {string} sortStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetPaymentLearnerList(companyId: string, paymentId: number, learnerId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, searchAffiliationId: number, searchLastStudyBucket: string, sortStr: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetPaymentLearnerList(companyId, paymentId, learnerId, searchStatus, searchField, searchStr, limit, page, searchAffiliationId, searchLastStudyBucket, sortStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} paymentId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetReportStudyRecords(companyId: string, paymentId: string, yearMonth: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetReportStudyRecords(companyId, paymentId, yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} endpoint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetStatus(endpoint: string, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsControllerGetStatus(endpoint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetStudyRecords(companyId: string, learnerId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetStudyRecords(companyId, learnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetSystemLearnerNotice(learnerId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetSystemLearnerNotice(learnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetTargetMonthPaymentCompanyList(companyId: string, learnerId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetTargetMonthPaymentCompanyList(companyId, learnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetTeacherByTeacherId(teacherId: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetTeacherByTeacherId(teacherId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {string} yearMonth 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetTeacherLessonFee(companyId: string, teacherId: string, yearMonth: string, endPeriod: string, searchField: string, searchStr: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetTeacherLessonFee(companyId, teacherId, yearMonth, endPeriod, searchField, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {string} yearMonth 
         * @param {number} status 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetTeacherLessonFeeList(teacherId: string, yearMonth: string, status: number, limit: number, page: number, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetTeacherLessonFeeList(teacherId, yearMonth, status, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {number} searchStatus 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetTeacherUserList(teacherId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.organizationsControllerGetTeacherUserList(teacherId, searchStatus, searchField, searchStr, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerGetZoomToken(roomId: string, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsControllerGetZoomToken(roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerImportCompanyUsersCsv(file: any, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsControllerImportCompanyUsersCsv(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerImportLearnersCsv(file: any, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsControllerImportLearnersCsv(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} senderId 
         * @param {string} receiverId 
         * @param {string} message 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerPostZoomChat(companyId: string, lessonId: string, senderId: string, receiverId: string, message: string, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsControllerPostZoomChat(companyId, lessonId, senderId, receiverId, message, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PushSubscribeDto} pushSubscribeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerPushSubscribe(pushSubscribeDto: PushSubscribeDto, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsControllerPushSubscribe(pushSubscribeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PushUnsubscribeDto} pushUnsubscribeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerPushUnsubscribe(pushUnsubscribeDto: PushUnsubscribeDto, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsControllerPushUnsubscribe(pushUnsubscribeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} roomId 
         * @param {CreateRoomChatInput} createRoomChatInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerPutCompanyRoomChat(companyId: string, roomId: string, createRoomChatInput: CreateRoomChatInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerPutCompanyRoomChat(companyId, roomId, createRoomChatInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} releaseFlg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerReleaseNotice(id: string, releaseFlg: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerReleaseNotice(id, releaseFlg, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} userId 
         * @param {ResetCompanyUserPasswordInput} resetCompanyUserPasswordInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerResetCompanyUserPassword(companyId: string, userId: string, resetCompanyUserPasswordInput: ResetCompanyUserPasswordInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerResetCompanyUserPassword(companyId, userId, resetCompanyUserPasswordInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {ResetLearnerPasswordInput} resetLearnerPasswordInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerResetLearnerPassword(companyId: string, learnerId: string, resetLearnerPasswordInput: ResetLearnerPasswordInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerResetLearnerPassword(companyId, learnerId, resetLearnerPasswordInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mailSubject 
         * @param {string} mailerId 
         * @param {string} mailerName 
         * @param {string} kinds 
         * @param {string} mailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerSendInquiryEmail(mailSubject: string, mailerId: string, mailerName: string, kinds: string, mailBody: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerSendInquiryEmail(mailSubject, mailerId, mailerName, kinds, mailBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} sendQueryEmail 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerSendQueryEmail(companyId: string, sendQueryEmail: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerSendQueryEmail(companyId, sendQueryEmail, startPeriod, endPeriod, searchField, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {UpdateAgreementInput} updateAgreementInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateAgreement(companyId: string, updateAgreementInput: UpdateAgreementInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerUpdateAgreement(companyId, updateAgreementInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} paymentId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateAgreementPlan(companyId: string, paymentId: string, body: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerUpdateAgreementPlan(companyId, paymentId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {string} yearMonth 
         * @param {number} billedFlg 
         * @param {number} finalFee 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateBillingStatus(teacherId: string, yearMonth: string, billedFlg: number, finalFee: number, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerUpdateBillingStatus(teacherId, yearMonth, billedFlg, finalFee, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {UpdateCompanyInput} updateCompanyInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateCompany(companyId: string, updateCompanyInput: UpdateCompanyInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerUpdateCompany(companyId, updateCompanyInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} maintenanceId 
         * @param {boolean} immediateFlg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateDeMaintenance(maintenanceId: number, immediateFlg: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsControllerUpdateDeMaintenance(maintenanceId, immediateFlg, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} learnerId 
         * @param {UpdateLearnerInput} updateLearnerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateLearnerUser(companyId: string, learnerId: string, updateLearnerInput: UpdateLearnerInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerUpdateLearnerUser(companyId, learnerId, updateLearnerInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} startPeriod 
         * @param {string} endPeriod 
         * @param {string} searchField 
         * @param {string} searchStr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateLesson(companyId: string, lessonId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerUpdateLesson(companyId, lessonId, startPeriod, endPeriod, searchField, searchStr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} feedback 
         * @param {string} learnerIdCsv 
         * @param {string} [adminComment] 
         * @param {string} [filesMetadata] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateLessonFeedback(companyId: string, lessonId: string, feedback: string, learnerIdCsv: string, adminComment?: string, filesMetadata?: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerUpdateLessonFeedback(companyId, lessonId, feedback, learnerIdCsv, adminComment, filesMetadata, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} learnerId 
         * @param {boolean} lessonLearnerStatus 
         * @param {UpdateLessonLearnerInput} updateLessonLearnerInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateLessonLearnerStatus(companyId: string, lessonId: string, learnerId: string, lessonLearnerStatus: boolean, updateLessonLearnerInput: UpdateLessonLearnerInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerUpdateLessonLearnerStatus(companyId, lessonId, learnerId, lessonLearnerStatus, updateLessonLearnerInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {UpdateLessonNoteInput} updateLessonNoteInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateLessonNote(companyId: string, lessonId: string, updateLessonNoteInput: UpdateLessonNoteInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerUpdateLessonNote(companyId, lessonId, updateLessonNoteInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateLessonStatusTeacher(companyId: string, lessonId: string, status: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerUpdateLessonStatusTeacher(companyId, lessonId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} maintenanceId 
         * @param {CreateMaintenanceInput} createMaintenanceInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateMaintenance(maintenanceId: number, createMaintenanceInput: CreateMaintenanceInput, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsControllerUpdateMaintenance(maintenanceId, createMaintenanceInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateNoticeInput} createNoticeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateNotice(id: string, createNoticeInput: CreateNoticeInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerUpdateNotice(id, createNoticeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} noticeId 
         * @param {boolean} readStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateSystemLearnerNoticeReadStatus(noticeId: string, readStatus: boolean, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerUpdateSystemLearnerNoticeReadStatus(noticeId, readStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} teacherId 
         * @param {ConnectionId} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateTeacherConnectionId(companyId: string, teacherId: string, connectionId: ConnectionId, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerUpdateTeacherConnectionId(companyId, teacherId, connectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {UpdateTeacherInput} updateTeacherInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateTeacherUser(teacherId: string, updateTeacherInput: UpdateTeacherInput, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerUpdateTeacherUser(teacherId, updateTeacherInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} lessonId 
         * @param {string} theme 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerUpdateThemeOnLesson(companyId: string, lessonId: string, theme: string, options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerUpdateThemeOnLesson(companyId, lessonId, theme, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsControllerVerifyCognitoUserEmail(options?: any): AxiosPromise<object> {
            return localVarFp.organizationsControllerVerifyCognitoUserEmail(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxControllerCognitoSandbox(options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.sandboxControllerCognitoSandbox(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxControllerMailSandbox(options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.sandboxControllerMailSandbox(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} jlptLevel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        studyRecordsControllerGetCompletedStages(jlptLevel: string, options?: any): AxiosPromise<GetCompletedStagesResponse> {
            return localVarFp.studyRecordsControllerGetCompletedStages(jlptLevel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SaveStudyRecordStageInput} saveStudyRecordStageInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        studyRecordsControllerSaveStudyRecord(saveStudyRecordStageInput: SaveStudyRecordStageInput, options?: any): AxiosPromise<void> {
            return localVarFp.studyRecordsControllerSaveStudyRecord(saveStudyRecordStageInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSurveyResponseDto} createSurveyResponseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyControllerCreateResponse(createSurveyResponseDto: CreateSurveyResponseDto, options?: any): AxiosPromise<CreateSurveyResponseResponse> {
            return localVarFp.surveyControllerCreateResponse(createSurveyResponseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyControllerGetLatestSurvey(options?: any): AxiosPromise<GetLatestSurveyResponse> {
            return localVarFp.surveyControllerGetLatestSurvey(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teacherControllerGetLearnersWithoutFeedback(teacherId: string, limit: number, page: number, options?: any): AxiosPromise<GetLearnersWithoutFeedbackResponse> {
            return localVarFp.teacherControllerGetLearnersWithoutFeedback(teacherId, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teacherControllerGetMostRecentScheduledLesson(teacherId: string, options?: any): AxiosPromise<GetMostRecentScheduledLessonResponse> {
            return localVarFp.teacherControllerGetMostRecentScheduledLesson(teacherId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {number} limit 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teacherControllerGetNotUpdatedNoteLessons(teacherId: string, limit: number, page: number, options?: any): AxiosPromise<GetNotUpdatedNoteLessonsResponse> {
            return localVarFp.teacherControllerGetNotUpdatedNoteLessons(teacherId, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teacherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teacherControllerGetUnaprovedLessons(teacherId: string, options?: any): AxiosPromise<GetUnApprovedLessonsResponse> {
            return localVarFp.teacherControllerGetUnaprovedLessons(teacherId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LessonLoggingInput} lessonLoggingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEventControllerLogLessonEvent(lessonLoggingInput: LessonLoggingInput, options?: any): AxiosPromise<object> {
            return localVarFp.userEventControllerLogLessonEvent(lessonLoggingInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoggingInput} loggingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEventControllerLoggingEvent(loggingInput: LoggingInput, options?: any): AxiosPromise<object> {
            return localVarFp.userEventControllerLoggingEvent(loggingInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoggingInput} loggingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEventControllerLoggingEventByNotAuth(loggingInput: LoggingInput, options?: any): AxiosPromise<object> {
            return localVarFp.userEventControllerLoggingEventByNotAuth(loggingInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * APIApi - object-oriented interface
 * @export
 * @class APIApi
 * @extends {BaseAPI}
 */
export class APIApi extends BaseAPI {
    /**
     * 
     * @param {string} companyId 
     * @param {ApplyAffiliationTypeTemplateDto} applyAffiliationTypeTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public affiliationsControllerApplyTypeTemplate(companyId: string, applyAffiliationTypeTemplateDto: ApplyAffiliationTypeTemplateDto, options?: any) {
        return APIApiFp(this.configuration).affiliationsControllerApplyTypeTemplate(companyId, applyAffiliationTypeTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {AssignAffiliationDto} assignAffiliationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public affiliationsControllerAssign(companyId: string, assignAffiliationDto: AssignAffiliationDto, options?: any) {
        return APIApiFp(this.configuration).affiliationsControllerAssign(companyId, assignAffiliationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} assignmentId 
     * @param {ChangeAffiliationRoleDto} changeAffiliationRoleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public affiliationsControllerChangeAssignmentRole(companyId: string, assignmentId: number, changeAffiliationRoleDto: ChangeAffiliationRoleDto, options?: any) {
        return APIApiFp(this.configuration).affiliationsControllerChangeAssignmentRole(companyId, assignmentId, changeAffiliationRoleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {CreateAffiliationNodeDto} createAffiliationNodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public affiliationsControllerCreateNode(companyId: string, createAffiliationNodeDto: CreateAffiliationNodeDto, options?: any) {
        return APIApiFp(this.configuration).affiliationsControllerCreateNode(companyId, createAffiliationNodeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {CreateAffiliationTypeDto} createAffiliationTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public affiliationsControllerCreateType(companyId: string, createAffiliationTypeDto: CreateAffiliationTypeDto, options?: any) {
        return APIApiFp(this.configuration).affiliationsControllerCreateType(companyId, createAffiliationTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} affiliationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public affiliationsControllerDeleteNode(companyId: string, affiliationId: number, options?: any) {
        return APIApiFp(this.configuration).affiliationsControllerDeleteNode(companyId, affiliationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} typeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public affiliationsControllerDeleteType(companyId: string, typeId: number, options?: any) {
        return APIApiFp(this.configuration).affiliationsControllerDeleteType(companyId, typeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public affiliationsControllerGetMyAffiliations(companyId: string, options?: any) {
        return APIApiFp(this.configuration).affiliationsControllerGetMyAffiliations(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public affiliationsControllerGetTree(companyId: string, options?: any) {
        return APIApiFp(this.configuration).affiliationsControllerGetTree(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} dryRun 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public affiliationsControllerImportLearnerAffiliations(companyId: string, dryRun: string, file: any, options?: any) {
        return APIApiFp(this.configuration).affiliationsControllerImportLearnerAffiliations(companyId, dryRun, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {'LEARNER' | 'COMPANY_USER'} [userType] 
     * @param {string} [userId] 
     * @param {number} [affiliationId] 
     * @param {boolean} [includeDescendants] affiliation_id 指定時、配下の所属も含める
     * @param {string} [searchStr] 氏名・ニックネーム・メールアドレスの部分一致
     * @param {number} [limit] 1ページの件数(既定 50、最大 1000)
     * @param {number} [page] ページ番号(1始まり)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public affiliationsControllerListAssignments(companyId: string, userType?: 'LEARNER' | 'COMPANY_USER', userId?: string, affiliationId?: number, includeDescendants?: boolean, searchStr?: string, limit?: number, page?: number, options?: any) {
        return APIApiFp(this.configuration).affiliationsControllerListAssignments(companyId, userType, userId, affiliationId, includeDescendants, searchStr, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} assignmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public affiliationsControllerUnassign(companyId: string, assignmentId: number, options?: any) {
        return APIApiFp(this.configuration).affiliationsControllerUnassign(companyId, assignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} affiliationId 
     * @param {UpdateAffiliationNodeDto} updateAffiliationNodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public affiliationsControllerUpdateNode(companyId: string, affiliationId: number, updateAffiliationNodeDto: UpdateAffiliationNodeDto, options?: any) {
        return APIApiFp(this.configuration).affiliationsControllerUpdateNode(companyId, affiliationId, updateAffiliationNodeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} typeId 
     * @param {UpdateAffiliationTypeDto} updateAffiliationTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public affiliationsControllerUpdateType(companyId: string, typeId: number, updateAffiliationTypeDto: UpdateAffiliationTypeDto, options?: any) {
        return APIApiFp(this.configuration).affiliationsControllerUpdateType(companyId, typeId, updateAffiliationTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ForgotCompanyPasswordInput} forgotCompanyPasswordInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public companyAuthControllerForgotCompanyPassword(forgotCompanyPasswordInput: ForgotCompanyPasswordInput, options?: any) {
        return APIApiFp(this.configuration).companyAuthControllerForgotCompanyPassword(forgotCompanyPasswordInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public dashboardControllerGetLearners(companyId: string, options?: any) {
        return APIApiFp(this.configuration).dashboardControllerGetLearners(companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public dashboardControllerGetMe(companyId: string, options?: any) {
        return APIApiFp(this.configuration).dashboardControllerGetMe(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateForBeginnersInquiryInput} createForBeginnersInquiryInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public inquiryControllerSendForBeginnersInquiryEmail(createForBeginnersInquiryInput: CreateForBeginnersInquiryInput, options?: any) {
        return APIApiFp(this.configuration).inquiryControllerSendForBeginnersInquiryEmail(createForBeginnersInquiryInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateInquiryInput} createInquiryInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public inquiryControllerSendInquiryEmail(createInquiryInput: CreateInquiryInput, options?: any) {
        return APIApiFp(this.configuration).inquiryControllerSendInquiryEmail(createInquiryInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ForgotLearnerPasswordInput} forgotLearnerPasswordInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public learnerAuthControllerForgotLearnerPassword(forgotLearnerPasswordInput: ForgotLearnerPasswordInput, options?: any) {
        return APIApiFp(this.configuration).learnerAuthControllerForgotLearnerPassword(forgotLearnerPasswordInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public learnerControllerCompleteCheckTest(options?: any) {
        return APIApiFp(this.configuration).learnerControllerCompleteCheckTest(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public learnerControllerGetCheckTestStatus(options?: any) {
        return APIApiFp(this.configuration).learnerControllerGetCheckTestStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} learnerId 
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public learnerControllerGetLearnerStudyTimeInfo(learnerId: string, companyId: number, options?: any) {
        return APIApiFp(this.configuration).learnerControllerGetLearnerStudyTimeInfo(learnerId, companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} learnerId 
     * @param {number} companyId 
     * @param {number} [paymentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public learnerControllerGetLearnerTotalLessonsVsParticipatedLessons(learnerId: string, companyId: number, paymentId?: number, options?: any) {
        return APIApiFp(this.configuration).learnerControllerGetLearnerTotalLessonsVsParticipatedLessons(learnerId, companyId, paymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public learnerControllerIsHighestStageCompleted(options?: any) {
        return APIApiFp(this.configuration).learnerControllerIsHighestStageCompleted(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileUrl 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public lessonControllerGetDownloadUrl(fileUrl: string, options?: any) {
        return APIApiFp(this.configuration).lessonControllerGetDownloadUrl(fileUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} lessonId 
     * @param {string} roomId 
     * @param {number} timestamp 
     * @param {string} mimeType 
     * @param {string} targetUserId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public lessonControllerGetUploadUrlOfRecordedFile(lessonId: string, roomId: string, timestamp: number, mimeType: string, targetUserId: string, options?: any) {
        return APIApiFp(this.configuration).lessonControllerGetUploadUrlOfRecordedFile(lessonId, roomId, timestamp, mimeType, targetUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} learnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerCreateActiveLearnerLog(learnerId: string, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerCreateActiveLearnerLog(learnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} lessonId 
     * @param {string} companyId 
     * @param {string} userId 
     * @param {LessonLogType} lessonLogType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerCreateLessonLog(lessonId: string, companyId: string, userId: string, lessonLogType: LessonLogType, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerCreateLessonLog(lessonId, companyId, userId, lessonLogType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} learnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerDeactivateLearnerEndpoints(companyId: string, learnerId: string, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerDeactivateLearnerEndpoints(companyId, learnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} learnerId 
     * @param {boolean} onlyFuture 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerGetApprovedLessons(learnerId: string, onlyFuture: boolean, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerGetApprovedLessons(learnerId, onlyFuture, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} learnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerGetLearnerActiveEndpointCount(companyId: string, learnerId: string, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerGetLearnerActiveEndpointCount(companyId, learnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerGetLearnerByEmail(companyId: string, email: string, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerGetLearnerByEmail(companyId, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} learnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerGetLearnerEndpoint(companyId: string, learnerId: string, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerGetLearnerEndpoint(companyId, learnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} learnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerGetLernerById(companyId: string, learnerId: string, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerGetLernerById(companyId, learnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerGetLoginedLearnerDetail(options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerGetLoginedLearnerDetail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerGetMostRecentScheduledLesson(options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerGetMostRecentScheduledLesson(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} noticeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerGetNoticeRead(noticeId: number, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerGetNoticeRead(noticeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerGetNoticeUnreadCount(userName: string, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerGetNoticeUnreadCount(userName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerGetNotices(limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerGetNotices(limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerGetPastLessons(limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerGetPastLessons(limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerGetPushMsg(companyId: string, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerGetPushMsg(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} pushMsgQId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerGetPushMsgLog(companyId: string, pushMsgQId: number, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerGetPushMsgLog(companyId, pushMsgQId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerGetPushVapidPublicKey(companyId: string, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerGetPushVapidPublicKey(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerGetStudyRecords(userName: string, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerGetStudyRecords(userName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DrillParam} drillParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerPostStudyRecordDrill(drillParam: DrillParam, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerPostStudyRecordDrill(drillParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StudyResult} studyResult 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerPostStudyRecordStory(studyResult: StudyResult, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerPostStudyRecordStory(studyResult, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateDrillResult} updateDrillResult 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerPutDrillRecord(updateDrillResult: UpdateDrillResult, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerPutDrillRecord(updateDrillResult, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} noticeId 
     * @param {string} userName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerPutNoticeRead(companyId: string, noticeId: number, userName: string, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerPutNoticeRead(companyId, noticeId, userName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateStudyResult} updateStudyResult 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerPutStudyRecord(updateStudyResult: UpdateStudyResult, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerPutStudyRecord(updateStudyResult, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RecordStudySessionInput} recordStudySessionInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerRecordStudySession(recordStudySessionInput: RecordStudySessionInput, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerRecordStudySession(recordStudySessionInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StartStudySessionInput} startStudySessionInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerStartStudySession(startStudySessionInput: StartStudySessionInput, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerStartStudySession(startStudySessionInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} learnerId 
     * @param {ConnectionId} connectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerUpdateLearnerConnectionId(companyId: string, learnerId: string, connectionId: ConnectionId, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerUpdateLearnerConnectionId(companyId, learnerId, connectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} learnerId 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerUpdateLearnerEmail(companyId: string, learnerId: string, email: string, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerUpdateLearnerEmail(companyId, learnerId, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} learnerId 
     * @param {string} emailSendFlg 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerUpdateLearnerEmailSendFlg(companyId: string, learnerId: string, emailSendFlg: string, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerUpdateLearnerEmailSendFlg(companyId, learnerId, emailSendFlg, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} learnerId 
     * @param {LearnerEndpoint} learnerEndpoint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerUpsertLearnerEndpoint(companyId: string, learnerId: string, learnerEndpoint: LearnerEndpoint, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerUpsertLearnerEndpoint(companyId, learnerId, learnerEndpoint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {PushMsg} pushMsg 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerUpsertPushMsg(companyId: string, pushMsg: PushMsg, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerUpsertPushMsg(companyId, pushMsg, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {PushMsgLog} pushMsgLog 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerUpsertPushMsgLog(companyId: string, pushMsgLog: PushMsgLog, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerUpsertPushMsgLog(companyId, pushMsgLog, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerVerifyCognitoUserEmail(options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerVerifyCognitoUserEmail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} learnerId 
     * @param {string} email 
     * @param {VerifyInfo} verifyInfo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public mobileAppControllerVerifyLearnerEmail(companyId: string, learnerId: string, email: string, verifyInfo: VerifyInfo, options?: any) {
        return APIApiFp(this.configuration).mobileAppControllerVerifyLearnerEmail(companyId, learnerId, email, verifyInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} lessonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerApprovalLessonTeacher(companyId: string, lessonId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerApprovalLessonTeacher(companyId, lessonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} lessonId 
     * @param {CancelLessonInput} cancelLessonInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerCancelLesson(companyId: string, lessonId: string, cancelLessonInput: CancelLessonInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerCancelLesson(companyId, lessonId, cancelLessonInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} lessonId 
     * @param {string} teacherId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerChangeLessonTeacher(companyId: string, lessonId: string, teacherId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerChangeLessonTeacher(companyId, lessonId, teacherId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerCreateActiveCompanyUserLog(userId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerCreateActiveCompanyUserLog(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {CreateAgreementInput} createAgreementInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerCreateAgreement(companyId: string, createAgreementInput: CreateAgreementInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerCreateAgreement(companyId, createAgreementInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {CreateCompanyInput} createCompanyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerCreateCompany(companyId: string, createCompanyInput: CreateCompanyInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerCreateCompany(companyId, createCompanyInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {CreateCompanyUserInput} createCompanyUserInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerCreateCompanyUser(companyId: string, createCompanyUserInput: CreateCompanyUserInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerCreateCompanyUser(companyId, createCompanyUserInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateErrorLog} createErrorLog 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerCreateErrorLog(createErrorLog: CreateErrorLog, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerCreateErrorLog(createErrorLog, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} paymentId 
     * @param {CreateLearnerInput} createLearnerInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerCreateLearnerUser(companyId: string, paymentId: number, createLearnerInput: CreateLearnerInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerCreateLearnerUser(companyId, paymentId, createLearnerInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} teacherId 
     * @param {string} startDatetime 
     * @param {string} endDatetime 
     * @param {CreateLessonInput} createLessonInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerCreateLesson(companyId: string, teacherId: string, startDatetime: string, endDatetime: string, createLessonInput: CreateLessonInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerCreateLesson(companyId, teacherId, startDatetime, endDatetime, createLessonInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teacherId 
     * @param {CreateLessonFeeInput} createLessonFeeInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerCreateLessonFee(teacherId: string, createLessonFeeInput: CreateLessonFeeInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerCreateLessonFee(teacherId, createLessonFeeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teacherId 
     * @param {CreateLessonFeeHistoryInput} createLessonFeeHistoryInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerCreateLessonFeeHistory(teacherId: string, createLessonFeeHistoryInput: CreateLessonFeeHistoryInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerCreateLessonFeeHistory(teacherId, createLessonFeeHistoryInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateMaintenanceInput} createMaintenanceInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerCreateMaintenance(createMaintenanceInput: CreateMaintenanceInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerCreateMaintenance(createMaintenanceInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} dummy 
     * @param {CreateManagerInput} createManagerInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerCreateManagerUser(dummy: string, createManagerInput: CreateManagerInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerCreateManagerUser(dummy, createManagerInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} dummy 
     * @param {CreateNoticeInput} createNoticeInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerCreateNotice(dummy: string, createNoticeInput: CreateNoticeInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerCreateNotice(dummy, createNoticeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateNoticeCompanyInput} createNoticeCompanyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerCreateNoticeCompany(createNoticeCompanyInput: CreateNoticeCompanyInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerCreateNoticeCompany(createNoticeCompanyInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teacherId 
     * @param {CreateTeacherInput} createTeacherInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerCreateTeacherUser(teacherId: string, createTeacherInput: CreateTeacherInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerCreateTeacherUser(teacherId, createTeacherInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} paymentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerDeleteAgreement(companyId: string, paymentId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerDeleteAgreement(companyId, paymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerDeleteCompany(companyId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerDeleteCompany(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerDeleteCompanyUser(companyId: string, userId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerDeleteCompanyUser(companyId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} learnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerDeleteLearnerUser(companyId: string, learnerId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerDeleteLearnerUser(companyId, learnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerDeleteLessonFeeOption(id: number, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerDeleteLessonFeeOption(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} lessonId 
     * @param {DeleteLessonLearnerInput} deleteLessonLearnerInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerDeleteLessonLearner(companyId: string, lessonId: string, deleteLessonLearnerInput: DeleteLessonLearnerInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerDeleteLessonLearner(companyId, lessonId, deleteLessonLearnerInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} maintenanceId 
     * @param {string} maintenanceStatus 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerDeleteMaintenance(maintenanceId: number, maintenanceStatus: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerDeleteMaintenance(maintenanceId, maintenanceStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} managerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerDeleteManagerUser(managerId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerDeleteManagerUser(managerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {DeleteAgreementInput} deleteAgreementInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerDeleteMonthlyAgreement(companyId: string, deleteAgreementInput: DeleteAgreementInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerDeleteMonthlyAgreement(companyId, deleteAgreementInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerDeleteNotice(id: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerDeleteNotice(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teacherId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerDeleteTeacherUser(teacherId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerDeleteTeacherUser(teacherId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExistsLearnerInput} existsLearnerInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerExistsLearner(existsLearnerInput: ExistsLearnerInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerExistsLearner(existsLearnerInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExistsLearnerInPlanInput} existsLearnerInPlanInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerExistsLearnerInPlan(existsLearnerInPlanInput: ExistsLearnerInPlanInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerExistsLearnerInPlan(existsLearnerInPlanInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetAvailableCompanies(options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetAvailableCompanies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetCompany(companyId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetCompany(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} searchStatus 
     * @param {string} searchField 
     * @param {string} searchStr 
     * @param {number} limit 
     * @param {number} page 
     * @param {string} sortStr 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetCompanyList(companyId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, sortStr: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetCompanyList(companyId, searchStatus, searchField, searchStr, limit, page, sortStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetCompanyPlans(companyId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetCompanyPlans(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} limit 
     * @param {number} page 
     * @param {string} searchStr 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetCompanyUserList(companyId: string, limit: number, page: number, searchStr: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetCompanyUserList(companyId, limit, page, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} roomId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetConnectionIdByRoomId(companyId: string, roomId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetConnectionIdByRoomId(companyId, roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} paymentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetEachLearnerStudyRecordsPdf(companyId: string, paymentId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetEachLearnerStudyRecordsPdf(companyId, paymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} paymentId 
     * @param {string} teacherId 
     * @param {string} learnerId 
     * @param {string} lessonId 
     * @param {number} approvalFlg 
     * @param {string} startPeriod 
     * @param {string} endPeriod 
     * @param {number} futureOnly 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetFutureLessonList(companyId: string, paymentId: number, teacherId: string, learnerId: string, lessonId: string, approvalFlg: number, startPeriod: string, endPeriod: string, futureOnly: number, limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetFutureLessonList(companyId, paymentId, teacherId, learnerId, lessonId, approvalFlg, startPeriod, endPeriod, futureOnly, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} teacherId 
     * @param {string} learner 
     * @param {string} learnerId 
     * @param {string} company 
     * @param {string} searchStatus 
     * @param {string} lessonId 
     * @param {number} approvalFlg 
     * @param {string} startPeriod 
     * @param {string} endPeriod 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetFutureLessonListBgd(companyId: string, teacherId: string, learner: string, learnerId: string, company: string, searchStatus: string, lessonId: string, approvalFlg: number, startPeriod: string, endPeriod: string, limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetFutureLessonListBgd(companyId, teacherId, learner, learnerId, company, searchStatus, lessonId, approvalFlg, startPeriod, endPeriod, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} learnerId 
     * @param {string} startPeriod 
     * @param {string} endPeriod 
     * @param {string} searchField 
     * @param {string} searchStr 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetLatestPastLessonNote(companyId: string, learnerId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetLatestPastLessonNote(companyId, learnerId, startPeriod, endPeriod, searchField, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} lessonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetLeanerUserListByLesson(companyId: string, lessonId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetLeanerUserListByLesson(companyId, lessonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} learnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetLearnerStudyRecords(companyId: string, learnerId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetLearnerStudyRecords(companyId, learnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} learnerId 
     * @param {number} searchStatus 
     * @param {string} searchField 
     * @param {string} searchStr 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetLearnerUserList(companyId: string, learnerId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetLearnerUserList(companyId, learnerId, searchStatus, searchField, searchStr, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} teacherId 
     * @param {string} lessonId 
     * @param {string} searchField 
     * @param {string} searchStr 
     * @param {string} startPeriod 
     * @param {string} endPeriod 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetLesson(companyId: string, teacherId: string, lessonId: string, searchField: string, searchStr: string, startPeriod: string, endPeriod: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetLesson(companyId, teacherId, lessonId, searchField, searchStr, startPeriod, endPeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} lessonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetLessonByCompanyNLessonID(companyId: string, lessonId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetLessonByCompanyNLessonID(companyId, lessonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} roomId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetLessonByRoomId(companyId: string, roomId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetLessonByRoomId(companyId, roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} lessonId 
     * @param {string} learnerId 
     * @param {string} startPeriod 
     * @param {string} endPeriod 
     * @param {string} searchField 
     * @param {string} searchStr 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetLessonFeedback(companyId: string, lessonId: string, learnerId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetLessonFeedback(companyId, lessonId, learnerId, startPeriod, endPeriod, searchField, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} paymentId 
     * @param {string} learnerId 
     * @param {number} lessonId 
     * @param {string} teacherId 
     * @param {string} startPeriod 
     * @param {string} endPeriod 
     * @param {number} noneLessonFeedback 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetLessonFeedbackList(companyId: string, paymentId: number, learnerId: string, lessonId: number, teacherId: string, startPeriod: string, endPeriod: string, noneLessonFeedback: number, limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetLessonFeedbackList(companyId, paymentId, learnerId, lessonId, teacherId, startPeriod, endPeriod, noneLessonFeedback, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} paymentId 
     * @param {string} learnerId 
     * @param {string} teacherId 
     * @param {string} companyName 
     * @param {string} learnerName 
     * @param {string} startPeriod 
     * @param {string} endPeriod 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetLessonFeedbackListBgd(companyId: string, paymentId: number, learnerId: string, teacherId: string, companyName: string, learnerName: string, startPeriod: string, endPeriod: string, limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetLessonFeedbackListBgd(companyId, paymentId, learnerId, teacherId, companyName, learnerName, startPeriod, endPeriod, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetLessonFees(options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetLessonFees(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} teacherId 
     * @param {string} learner 
     * @param {string} learnerId 
     * @param {string} company 
     * @param {string} searchStatus 
     * @param {string} lessonId 
     * @param {number} approvalFlg 
     * @param {string} startPeriod 
     * @param {string} endPeriod 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetLessonListBgd(companyId: string, teacherId: string, learner: string, learnerId: string, company: string, searchStatus: string, lessonId: string, approvalFlg: number, startPeriod: string, endPeriod: string, limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetLessonListBgd(companyId, teacherId, learner, learnerId, company, searchStatus, lessonId, approvalFlg, startPeriod, endPeriod, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} lessonId 
     * @param {string} startPeriod 
     * @param {string} endPeriod 
     * @param {string} searchField 
     * @param {string} searchStr 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetLessonNote(companyId: string, lessonId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetLessonNote(companyId, lessonId, startPeriod, endPeriod, searchField, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} startPeriod 
     * @param {string} endPeriod 
     * @param {string} searchField 
     * @param {string} searchStr 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetLessonNoteList(companyId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetLessonNoteList(companyId, startPeriod, endPeriod, searchField, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetLoginUserInfo(options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetLoginUserInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetMaintenance(page: number, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetMaintenance(page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetManagerUserList(limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetManagerUserList(limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} noticeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetNotice(noticeId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetNotice(noticeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} noticeId 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetNoticeCompany(noticeId: string, companyId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetNoticeCompany(noticeId, companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} noticeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetNoticeCompanyForManager(noticeId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetNoticeCompanyForManager(noticeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} targetNumber 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetNoticeList(targetNumber: number, limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetNoticeList(targetNumber, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetOperationalStatus(options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetOperationalStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} paymentId 
     * @param {string} teacherId 
     * @param {string} learnerId 
     * @param {string} startPeriod 
     * @param {string} endPeriod 
     * @param {number} noneLessonNote 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetPastLessonList(companyId: string, paymentId: number, teacherId: string, learnerId: string, startPeriod: string, endPeriod: string, noneLessonNote: number, limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetPastLessonList(companyId, paymentId, teacherId, learnerId, startPeriod, endPeriod, noneLessonNote, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} teacherId 
     * @param {string} companyName 
     * @param {string} lessonId 
     * @param {string} learnerName 
     * @param {string} learnerId 
     * @param {string} startPeriod 
     * @param {string} endPeriod 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetPastLessonListBgd(companyId: string, teacherId: string, companyName: string, lessonId: string, learnerName: string, learnerId: string, startPeriod: string, endPeriod: string, limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetPastLessonListBgd(companyId, teacherId, companyName, lessonId, learnerName, learnerId, startPeriod, endPeriod, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} paymentId 
     * @param {number} searchStatus 
     * @param {string} searchField 
     * @param {string} searchStr 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetPaymentCompany(companyId: string, paymentId: number, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetPaymentCompany(companyId, paymentId, searchStatus, searchField, searchStr, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} targetMonth 
     * @param {number} paymentId 
     * @param {string} learnerId 
     * @param {number} searchStatus 
     * @param {string} searchField 
     * @param {string} searchStr 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetPaymentCompanyList(companyId: string, targetMonth: string, paymentId: number, learnerId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetPaymentCompanyList(companyId, targetMonth, paymentId, learnerId, searchStatus, searchField, searchStr, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} paymentId 
     * @param {string} learnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetPaymentLearnerDetails(companyId: string, paymentId: number, learnerId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetPaymentLearnerDetails(companyId, paymentId, learnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {number} paymentId 
     * @param {string} learnerId 
     * @param {number} searchStatus 
     * @param {string} searchField 
     * @param {string} searchStr 
     * @param {number} limit 
     * @param {number} page 
     * @param {number} searchAffiliationId 
     * @param {string} searchLastStudyBucket 
     * @param {string} sortStr 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetPaymentLearnerList(companyId: string, paymentId: number, learnerId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, searchAffiliationId: number, searchLastStudyBucket: string, sortStr: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetPaymentLearnerList(companyId, paymentId, learnerId, searchStatus, searchField, searchStr, limit, page, searchAffiliationId, searchLastStudyBucket, sortStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} paymentId 
     * @param {string} yearMonth 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetReportStudyRecords(companyId: string, paymentId: string, yearMonth: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetReportStudyRecords(companyId, paymentId, yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} endpoint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetStatus(endpoint: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetStatus(endpoint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} learnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetStudyRecords(companyId: string, learnerId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetStudyRecords(companyId, learnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} learnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetSystemLearnerNotice(learnerId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetSystemLearnerNotice(learnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} learnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetTargetMonthPaymentCompanyList(companyId: string, learnerId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetTargetMonthPaymentCompanyList(companyId, learnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teacherId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetTeacherByTeacherId(teacherId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetTeacherByTeacherId(teacherId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} teacherId 
     * @param {string} yearMonth 
     * @param {string} endPeriod 
     * @param {string} searchField 
     * @param {string} searchStr 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetTeacherLessonFee(companyId: string, teacherId: string, yearMonth: string, endPeriod: string, searchField: string, searchStr: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetTeacherLessonFee(companyId, teacherId, yearMonth, endPeriod, searchField, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teacherId 
     * @param {string} yearMonth 
     * @param {number} status 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetTeacherLessonFeeList(teacherId: string, yearMonth: string, status: number, limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetTeacherLessonFeeList(teacherId, yearMonth, status, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teacherId 
     * @param {number} searchStatus 
     * @param {string} searchField 
     * @param {string} searchStr 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetTeacherUserList(teacherId: string, searchStatus: number, searchField: string, searchStr: string, limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetTeacherUserList(teacherId, searchStatus, searchField, searchStr, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} roomId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerGetZoomToken(roomId: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerGetZoomToken(roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerImportCompanyUsersCsv(file: any, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerImportCompanyUsersCsv(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerImportLearnersCsv(file: any, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerImportLearnersCsv(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} lessonId 
     * @param {string} senderId 
     * @param {string} receiverId 
     * @param {string} message 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerPostZoomChat(companyId: string, lessonId: string, senderId: string, receiverId: string, message: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerPostZoomChat(companyId, lessonId, senderId, receiverId, message, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PushSubscribeDto} pushSubscribeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerPushSubscribe(pushSubscribeDto: PushSubscribeDto, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerPushSubscribe(pushSubscribeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PushUnsubscribeDto} pushUnsubscribeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerPushUnsubscribe(pushUnsubscribeDto: PushUnsubscribeDto, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerPushUnsubscribe(pushUnsubscribeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} roomId 
     * @param {CreateRoomChatInput} createRoomChatInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerPutCompanyRoomChat(companyId: string, roomId: string, createRoomChatInput: CreateRoomChatInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerPutCompanyRoomChat(companyId, roomId, createRoomChatInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} releaseFlg 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerReleaseNotice(id: string, releaseFlg: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerReleaseNotice(id, releaseFlg, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} userId 
     * @param {ResetCompanyUserPasswordInput} resetCompanyUserPasswordInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerResetCompanyUserPassword(companyId: string, userId: string, resetCompanyUserPasswordInput: ResetCompanyUserPasswordInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerResetCompanyUserPassword(companyId, userId, resetCompanyUserPasswordInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} learnerId 
     * @param {ResetLearnerPasswordInput} resetLearnerPasswordInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerResetLearnerPassword(companyId: string, learnerId: string, resetLearnerPasswordInput: ResetLearnerPasswordInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerResetLearnerPassword(companyId, learnerId, resetLearnerPasswordInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mailSubject 
     * @param {string} mailerId 
     * @param {string} mailerName 
     * @param {string} kinds 
     * @param {string} mailBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerSendInquiryEmail(mailSubject: string, mailerId: string, mailerName: string, kinds: string, mailBody: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerSendInquiryEmail(mailSubject, mailerId, mailerName, kinds, mailBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} sendQueryEmail 
     * @param {string} startPeriod 
     * @param {string} endPeriod 
     * @param {string} searchField 
     * @param {string} searchStr 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerSendQueryEmail(companyId: string, sendQueryEmail: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerSendQueryEmail(companyId, sendQueryEmail, startPeriod, endPeriod, searchField, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {UpdateAgreementInput} updateAgreementInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerUpdateAgreement(companyId: string, updateAgreementInput: UpdateAgreementInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerUpdateAgreement(companyId, updateAgreementInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} paymentId 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerUpdateAgreementPlan(companyId: string, paymentId: string, body: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerUpdateAgreementPlan(companyId, paymentId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teacherId 
     * @param {string} yearMonth 
     * @param {number} billedFlg 
     * @param {number} finalFee 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerUpdateBillingStatus(teacherId: string, yearMonth: string, billedFlg: number, finalFee: number, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerUpdateBillingStatus(teacherId, yearMonth, billedFlg, finalFee, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {UpdateCompanyInput} updateCompanyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerUpdateCompany(companyId: string, updateCompanyInput: UpdateCompanyInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerUpdateCompany(companyId, updateCompanyInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} maintenanceId 
     * @param {boolean} immediateFlg 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerUpdateDeMaintenance(maintenanceId: number, immediateFlg: boolean, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerUpdateDeMaintenance(maintenanceId, immediateFlg, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} learnerId 
     * @param {UpdateLearnerInput} updateLearnerInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerUpdateLearnerUser(companyId: string, learnerId: string, updateLearnerInput: UpdateLearnerInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerUpdateLearnerUser(companyId, learnerId, updateLearnerInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} lessonId 
     * @param {string} startPeriod 
     * @param {string} endPeriod 
     * @param {string} searchField 
     * @param {string} searchStr 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerUpdateLesson(companyId: string, lessonId: string, startPeriod: string, endPeriod: string, searchField: string, searchStr: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerUpdateLesson(companyId, lessonId, startPeriod, endPeriod, searchField, searchStr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} lessonId 
     * @param {string} feedback 
     * @param {string} learnerIdCsv 
     * @param {string} [adminComment] 
     * @param {string} [filesMetadata] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerUpdateLessonFeedback(companyId: string, lessonId: string, feedback: string, learnerIdCsv: string, adminComment?: string, filesMetadata?: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerUpdateLessonFeedback(companyId, lessonId, feedback, learnerIdCsv, adminComment, filesMetadata, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} lessonId 
     * @param {string} learnerId 
     * @param {boolean} lessonLearnerStatus 
     * @param {UpdateLessonLearnerInput} updateLessonLearnerInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerUpdateLessonLearnerStatus(companyId: string, lessonId: string, learnerId: string, lessonLearnerStatus: boolean, updateLessonLearnerInput: UpdateLessonLearnerInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerUpdateLessonLearnerStatus(companyId, lessonId, learnerId, lessonLearnerStatus, updateLessonLearnerInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} lessonId 
     * @param {UpdateLessonNoteInput} updateLessonNoteInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerUpdateLessonNote(companyId: string, lessonId: string, updateLessonNoteInput: UpdateLessonNoteInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerUpdateLessonNote(companyId, lessonId, updateLessonNoteInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} lessonId 
     * @param {string} status 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerUpdateLessonStatusTeacher(companyId: string, lessonId: string, status: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerUpdateLessonStatusTeacher(companyId, lessonId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} maintenanceId 
     * @param {CreateMaintenanceInput} createMaintenanceInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerUpdateMaintenance(maintenanceId: number, createMaintenanceInput: CreateMaintenanceInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerUpdateMaintenance(maintenanceId, createMaintenanceInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CreateNoticeInput} createNoticeInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerUpdateNotice(id: string, createNoticeInput: CreateNoticeInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerUpdateNotice(id, createNoticeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} noticeId 
     * @param {boolean} readStatus 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerUpdateSystemLearnerNoticeReadStatus(noticeId: string, readStatus: boolean, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerUpdateSystemLearnerNoticeReadStatus(noticeId, readStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} teacherId 
     * @param {ConnectionId} connectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerUpdateTeacherConnectionId(companyId: string, teacherId: string, connectionId: ConnectionId, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerUpdateTeacherConnectionId(companyId, teacherId, connectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teacherId 
     * @param {UpdateTeacherInput} updateTeacherInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerUpdateTeacherUser(teacherId: string, updateTeacherInput: UpdateTeacherInput, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerUpdateTeacherUser(teacherId, updateTeacherInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} lessonId 
     * @param {string} theme 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerUpdateThemeOnLesson(companyId: string, lessonId: string, theme: string, options?: any) {
        return APIApiFp(this.configuration).organizationsControllerUpdateThemeOnLesson(companyId, lessonId, theme, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public organizationsControllerVerifyCognitoUserEmail(options?: any) {
        return APIApiFp(this.configuration).organizationsControllerVerifyCognitoUserEmail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public sandboxControllerCognitoSandbox(options?: any) {
        return APIApiFp(this.configuration).sandboxControllerCognitoSandbox(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public sandboxControllerMailSandbox(options?: any) {
        return APIApiFp(this.configuration).sandboxControllerMailSandbox(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} jlptLevel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public studyRecordsControllerGetCompletedStages(jlptLevel: string, options?: any) {
        return APIApiFp(this.configuration).studyRecordsControllerGetCompletedStages(jlptLevel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SaveStudyRecordStageInput} saveStudyRecordStageInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public studyRecordsControllerSaveStudyRecord(saveStudyRecordStageInput: SaveStudyRecordStageInput, options?: any) {
        return APIApiFp(this.configuration).studyRecordsControllerSaveStudyRecord(saveStudyRecordStageInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSurveyResponseDto} createSurveyResponseDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public surveyControllerCreateResponse(createSurveyResponseDto: CreateSurveyResponseDto, options?: any) {
        return APIApiFp(this.configuration).surveyControllerCreateResponse(createSurveyResponseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public surveyControllerGetLatestSurvey(options?: any) {
        return APIApiFp(this.configuration).surveyControllerGetLatestSurvey(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teacherId 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public teacherControllerGetLearnersWithoutFeedback(teacherId: string, limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).teacherControllerGetLearnersWithoutFeedback(teacherId, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teacherId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public teacherControllerGetMostRecentScheduledLesson(teacherId: string, options?: any) {
        return APIApiFp(this.configuration).teacherControllerGetMostRecentScheduledLesson(teacherId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teacherId 
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public teacherControllerGetNotUpdatedNoteLessons(teacherId: string, limit: number, page: number, options?: any) {
        return APIApiFp(this.configuration).teacherControllerGetNotUpdatedNoteLessons(teacherId, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teacherId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public teacherControllerGetUnaprovedLessons(teacherId: string, options?: any) {
        return APIApiFp(this.configuration).teacherControllerGetUnaprovedLessons(teacherId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LessonLoggingInput} lessonLoggingInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public userEventControllerLogLessonEvent(lessonLoggingInput: LessonLoggingInput, options?: any) {
        return APIApiFp(this.configuration).userEventControllerLogLessonEvent(lessonLoggingInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoggingInput} loggingInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public userEventControllerLoggingEvent(loggingInput: LoggingInput, options?: any) {
        return APIApiFp(this.configuration).userEventControllerLoggingEvent(loggingInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoggingInput} loggingInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public userEventControllerLoggingEventByNotAuth(loggingInput: LoggingInput, options?: any) {
        return APIApiFp(this.configuration).userEventControllerLoggingEventByNotAuth(loggingInput, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HealthAPIApi - axios parameter creator
 * @export
 */
export const HealthAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerHealth: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthAPIApi - functional programming interface
 * @export
 */
export const HealthAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthControllerHealth(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthControllerHealth(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HealthAPIApi - factory interface
 * @export
 */
export const HealthAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthAPIApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerHealth(options?: any): AxiosPromise<void> {
            return localVarFp.healthControllerHealth(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthAPIApi - object-oriented interface
 * @export
 * @class HealthAPIApi
 * @extends {BaseAPI}
 */
export class HealthAPIApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthAPIApi
     */
    public healthControllerHealth(options?: any) {
        return HealthAPIApiFp(this.configuration).healthControllerHealth(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResourcesApi - axios parameter creator
 * @export
 */
export const ResourcesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resourcesControllerGetBaseEndpoint: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/resources/base-endpoint`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} storyNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resourcesControllerGetStoryExercisesEndpoint: async (storyNo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storyNo' is not null or undefined
            assertParamExists('resourcesControllerGetStoryExercisesEndpoint', 'storyNo', storyNo)
            const localVarPath = `/api/resources/story-exercises-endpoint`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storyNo !== undefined) {
                localVarQueryParameter['storyNo'] = storyNo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResourcesApi - functional programming interface
 * @export
 */
export const ResourcesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResourcesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resourcesControllerGetBaseEndpoint(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resourcesControllerGetBaseEndpoint(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} storyNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resourcesControllerGetStoryExercisesEndpoint(storyNo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resourcesControllerGetStoryExercisesEndpoint(storyNo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResourcesApi - factory interface
 * @export
 */
export const ResourcesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResourcesApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resourcesControllerGetBaseEndpoint(options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.resourcesControllerGetBaseEndpoint(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} storyNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resourcesControllerGetStoryExercisesEndpoint(storyNo: string, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.resourcesControllerGetStoryExercisesEndpoint(storyNo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResourcesApi - object-oriented interface
 * @export
 * @class ResourcesApi
 * @extends {BaseAPI}
 */
export class ResourcesApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public resourcesControllerGetBaseEndpoint(options?: any) {
        return ResourcesApiFp(this.configuration).resourcesControllerGetBaseEndpoint(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} storyNo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public resourcesControllerGetStoryExercisesEndpoint(storyNo: string, options?: any) {
        return ResourcesApiFp(this.configuration).resourcesControllerGetStoryExercisesEndpoint(storyNo, options).then((request) => request(this.axios, this.basePath));
    }
}


